import React, { useEffect, useState, useContext, useMemo, useCallback, useRef } from "react";
import toast, { Toaster } from "react-hot-toast";

import axios from "axios";
import { Autocomplete, Avatar, Stack, Chip } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SettingsIcon from "@mui/icons-material/Settings";
import DropArea from "../purchasing-popup/drag-and-drop/DropArea";
import AddIcon from "@mui/icons-material/Add"; 
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import "../style.css"
import {
    Box,
    Dialog,
    DialogContent,
    IconButton,
    FormControl,
    InputLabel,
    Select,
    DialogTitle,
    Tabs,
    Tab,
    MenuItem,
    Checkbox,
    Typography, 
    Button,
    DialogActions,
    TextField,
    FormControlLabel,
    Tooltip,
    CircularProgress,
    LinearProgress,
    Slider,
    Grid,
    Card,
    CardHeader,
    CardContent,
    FormHelperText,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useParams, Link } from "react-router-dom";
import { AuthContext } from "../../../../../helpers/AuthContext";
import { PURCHASE_ORDER_STATUS_OPTIONS } from "../../../../../constants/purchaseOrderStatuses";
import { GlobalWorkerOptions, getDocument } from "pdfjs-dist";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import {
  fetchAllProofsList,
  approveProofList,
  uploadProofList,
  updatePurchaseOrderDetails,
  fetchAllDesignReps,
  fetchProductionNotes,
  addProductionNoteByPO,
  lookupPurchaseOrders,
  invalidatePurchaseOrderCache,
  publishPurchaseOrderInvalidation,
  subscribePurchaseOrderInvalidation,
} from "../../../../../services/purchaseOrder";
import {
  fetchPoReceipts,
  fetchWarehouseLayout,
  fetchWarehouses,
  updatePoReceiptStoragePlacement,
} from "../../../../../services/shipping";
import { resolveProofsForPurchaseOrder } from "../../../../../utils/purchaseOrderProofScope";
import {
  getPoAllProofsUploaded,
} from "./poProofStatus";
import {
  buildPurchaseOrderProofStatusPatch,
  getPurchaseOrderProofStatusForReadiness,
  normalizePurchaseOrderProofStatus,
  PURCHASE_ORDER_PROOF_STATUS_OPTIONS,
} from "../../../../../constants/purchaseOrderProofStatuses";
import {
  buildReceiptStoragePresentation,
  getStorageLocationDisplay,
  getWarehouseLevelTooltip,
} from "./warehouseLocationDisplay";

import {
  listPurchasingReportDefinitions
} from "../../../../../services/purchasingReport";

import {
  ReportingPanel
} from '../../dashboard/ReportingPanel/ReportingPanel';
import GridViewIcon from "@mui/icons-material/GridView";
import { Menu, FormGroup, Switch } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import LaunchIcon from "@mui/icons-material/Launch"; 
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CancelIcon from '@mui/icons-material/Cancel'
import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'
import HistoryIcon from "@mui/icons-material/History";
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import UpdateIcon from "@mui/icons-material/Update";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import BuildIcon from "@mui/icons-material/Build"; // or Notes icon if you prefer
import NoteAltIcon from "@mui/icons-material/NoteAlt"; // alternative
import DescriptionIcon from "@mui/icons-material/Description";
import PaymentsIcon from "@mui/icons-material/Payments";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { formatDistanceToNow } from "date-fns";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import ReplyIcon from "@mui/icons-material/Reply";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarehouseIcon from "@mui/icons-material/Warehouse";
import { useInstanceNextActionTypes } from "../../../../../helpers/instanceTerms";
import EmailComposer from "../../../../../components/EmailComposer";
import EmailViewerDialog from "../../../../../components/EmailViewer/EmailViewerDialog";
import WarehouseBinPickerMap from "../../../../../components/Warehouse/WarehouseBinPickerMap";
import { isProductionBucketNote } from "../../../../../utils/noteBuckets";
import { buildEmailNotePreview, buildEmailViewerPropsFromNote, canViewEmailNote } from "../../../../../utils/emailViewerNotes";
import { isInboundProjectEmailNote } from "../../../../../constants/noteActionRegistry";
import {
  applyRevisedPrefix,
  buildDefaultProofSubject,
  getProofEmailPoNumber,
  resolveProofEmailSender,
  mergeProofSenderIntoBcc,
  stripRevisedPrefix,
} from "./proofEmailHelpers";
GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

// Soft, modern palette for proofing proof review
const STATUS_COLORS = {
  approved: { bg: '#E8F5E9', text: '#1B5E20', bd: '#A5D6A7' }, // green
  rejected: { bg: '#FFEBEE', text: '#B71C1C', bd: '#EF9A9A' }, // red
  pending:  { bg: '#FFF8E1', text: '#8D6E00', bd: '#FFE082' }, // amber
  default:  { bg: '#ECEFF1', text: '#37474F', bd: '#CFD8DC' }, // slate
};

// Distinguish roles (subtle hue shift for Internal vs Client)
const ROLE_ACCENTS = {
  internal: { ring: '#1E3A8A', dot: '#3B82F6' }, // blue family
  client:   { ring: '#064E3B', dot: '#10B981' }, // green/teal family
};

const pickStatus = (s) => {
  const key = (s || 'pending').toLowerCase();
  return STATUS_COLORS[key] || STATUS_COLORS.default;
};

// --- Email helpers ---
const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const splitEmails = (s = "") =>
  String(s).split(/[,\s;]+/).map(t => t.trim()).filter(Boolean);

const normalizeEmails = (arr = []) =>
  Array.from(new Set(
    arr.flatMap(v => typeof v === "string" ? splitEmails(v) : [])
       .map(s => s.trim())
       .filter(Boolean)
  ));

const validEmailList = (arr = []) =>
  normalizeEmails(arr).filter(e => EMAIL_RX.test(e));

  const dedupeEmails = (arr = []) =>
  Array.from(new Set((arr || []).map(s => String(s || "").trim()).filter(Boolean)));

const collectAllPossibleEmails = (src) =>
  dedupeEmails([
    ...(src?.customer || []),
    ...(src?.clientReps || []),
    ...(src?.orderReps || []),
    ...(src?.assignedToEmails || []),
    ...(Array.isArray(src?.all) ? src.all : []),
  ]).filter(e => EMAIL_RX.test(e));

const normalizeProofContactOption = (contact = {}) => {
  const email = String(contact?.email || "").trim().toLowerCase();
  if (!EMAIL_RX.test(email)) return null;

  const badge = contact?.badge || contact?.label || "";
  const name = contact?.name || email;

  return {
    id: contact?.id || contact?.contactId || email,
    email,
    name,
    role: "client-contact",
    badge,
    label: contact?.label || badge,
    source: contact?.source || "sales-order-contact",
  };
};

const mergeContactOptionsByEmail = (contacts = []) => {
  const byEmail = new Map();

  contacts.filter(Boolean).forEach((contact) => {
    const normalized = normalizeProofContactOption(contact);
    if (!normalized) return;

    const existing = byEmail.get(normalized.email);
    if (!existing) {
      byEmail.set(normalized.email, normalized);
      return;
    }

    const labels = Array.from(new Set([
      existing.badge,
      normalized.badge,
    ].filter(Boolean)));

    byEmail.set(normalized.email, {
      ...existing,
      name: existing.name || normalized.name,
      badge: labels.join(" / "),
      label: labels.join(" / "),
      source: labels.length > 1
        ? "sales-order-billing-shipping-contact"
        : existing.source,
    });
  });

  return Array.from(byEmail.values());
};

const renderBy = (v) => {
  if (!v) return "";
  if (typeof v === "string") return v;
  if (typeof v === "object") return v.name || v.email || "";
  return String(v);
};

// ── Mentions + filters helpers ───────────────────────────────────────────────
const pickUserLabel = (u) => {
  if (!u) return "";
  const f = u.first_name || u.firstName || "";
  const l = u.last_name  || u.lastName  || "";
  const name = `${f} ${l}`.trim();
  return name || u.email || `User #${u.id}`;
};

const unique = (arr = []) => Array.from(new Set(arr.filter(Boolean)));
const chunk20 = (arr) => arr.slice(0, 20); // simple CSS/UX pagination (load more button)
const extractMentionIds = (text = "") => (
  Array.from(new Set(
    Array.from(String(text || "").matchAll(/@\[[^\]]+\]\((\d+)\)/g))
      .map((match) => Number(match[1]))
      .filter(Number.isFinite)
  ))
);

const extractCommentersFromNotes = (notes = []) => {
  const ids = [];
  const byId = new Map();
  notes.forEach(n => {
    const id = n.userId != null ? String(n.userId) : null;
    if (id) {
      ids.push(id);
      if (!byId.has(id)) {
        byId.set(id, {
          id,
          name: n.userName || "",
          email: n.userEmail || "",
          avatar: n.userAvatar || null
        });
      }
    }
  });
  return { ids: unique(ids), index: byId };
};

// try to map a bunch of userIds → full user objects using any directory we have
const mapUserIdsToOptions = (ids = [], directories = []) => {
  const pools = directories.filter(Array.isArray).flat();
  const out = [];
  const seen = new Set();
  ids.forEach((id) => {
    const sid = String(id);
    if (seen.has(sid)) return;
    const hit = pools.find(u => {
      const uid = u?.id ?? u?.userId ?? u?.user_id ?? u?.value;
      return uid != null && String(uid) === sid;
    });
    if (hit) {
      out.push({
        id: sid,
        name: pickUserLabel(hit),
        email: hit.email || "",
        avatar: hit.profilePicture || hit.avatar || null,
      });
      seen.add(sid);
    }
  });
  return out.sort((a,b) => a.name.localeCompare(b.name));
};

// static enums
const STATUS_ENUMS = ["Problem","OK","Follow Up"];
const RECEIVING_PROGRESS_STATUSES = new Set([
  "received",
  "partially received",
  "in progress",
  "ready for billing",
  "closed",
  "billed",
]);
const normalizeReceivingStatus = (value) => {
  const raw = String(value || "").trim().toLowerCase();
  if (!raw) return "unknown";
  if (raw === "recieved") return "received";
  if (raw === "confirmed by shipping") return "received";
  if (raw === "in production") return "partially received";
  return raw;
};
const shouldShowReceivingProgress = (status) => {
  const normalized = normalizeReceivingStatus(status);
  return RECEIVING_PROGRESS_STATUSES.has(normalized);
};
const parseReceivablePoLines = (poRow) => {
  const items = Array.isArray(poRow?.items) ? poRow.items : [];
  const lines = [];
  items.forEach((item, itemIndex) => {
    const itemId = String(item?.id || item?._id || item?.poItemId || item?.productId || `item-${itemIndex + 1}`);
    const itemLabelBase = String(
      item?.productName
      || item?.name
      || item?.itemName
      || item?.description
      || item?.sku
      || `PO Line ${itemIndex + 1}`
    ).trim();
    const itemSku = String(item?.SKU || item?.sku || "").trim();
    const pricingRows = Array.isArray(item?.pricings) ? item.pricings : [];
    pricingRows.forEach((pricing, pricingIndex) => {
      const qty = Number(pricing?.Quantity ?? pricing?.quantity);
      if (!Number.isFinite(qty) || qty <= 0) return;
      const size = String(pricing?.Size ?? pricing?.size ?? "").trim();
      const color = String(pricing?.Color ?? pricing?.color ?? "").trim();
      const variantLabel = `${size}${size && color ? " - " : ""}${color}`.trim();
      const rowSku = String(pricing?.SKU ?? pricing?.sku ?? itemSku).trim();
      const lineKey = String(
        pricing?.id
        || pricing?._id
        || pricing?.pricingId
        || `${itemId}:pricing:${pricingIndex + 1}:${rowSku || "sku"}:${size || "na"}:${color || "na"}`
      );
      lines.push({
        lineKey,
        lineLabel: variantLabel || itemLabelBase || `PO Line ${itemIndex + 1}`,
        orderedQuantity: qty,
      });
    });
    if (!pricingRows.length) {
      const orderedQuantityRaw = item?.quantity ?? item?.qty ?? item?.orderQuantity ?? item?.orderedQuantity ?? item?.units ?? null;
      const orderedQuantity = Number(orderedQuantityRaw);
      if (!Number.isFinite(orderedQuantity) || orderedQuantity <= 0) return;
      lines.push({
        lineKey: itemId,
        lineLabel: itemLabelBase || `PO Line ${itemIndex + 1}`,
        orderedQuantity,
      });
    }
  });
  return lines;
};

const parseWarehouseBins = (layout) => {
  if (!layout || !Array.isArray(layout?.levels)) return [];
  const bins = [];
  layout.levels.forEach((level) => {
    Object.entries(level?.cells || {}).forEach(([cellKey, cell]) => {
      if (cell?.type !== "bin") return;
      bins.push({
        key: `${level.id}:${cellKey}`,
        warehouseLevel: level.id,
        warehouseCell: cellKey,
        label: cell?.label || `Bin ${cellKey}`,
        levelName: level?.name || level?.id,
      });
    });
  });
  return bins;
};

const STAGE_ENUMS = PURCHASE_ORDER_STATUS_OPTIONS.map((option) => option.id);

export const purchaseOrderStatusOptions = PURCHASE_ORDER_STATUS_OPTIONS;

// --- shipping helpers ---
const isoToYmd = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d)) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
};

const ymdToIso = (ymd) => {
  if (!ymd) return null;
  // treat as local date at midnight
  const [y,m,d] = ymd.split("-").map(Number);
  if (!y || !m || !d) return null;
  const dt = new Date(y, m-1, d);
  return Number.isNaN(dt) ? null : dt.toISOString();
};

const toMoneyNumber = (v) => {
  if (v == null || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

const parseTrackingCsv = (s) =>
  (s || "")
    .split(",")
    .map(x => x.trim())
    .filter(Boolean);

const trackingToCsv = (arr) =>
  Array.isArray(arr) ? arr.filter(Boolean).join(", ") : (arr || "");

const AUTO_SHIP_ALLOWED_STATUSES = new Set([
  "created",
  "submitted",
  "confirmed",
  "follow up",
  "open",
  "in progress",
]);

const parseMaybeJsonObject = (value) => {
  if (!value) return {};
  if (typeof value === "object") return value;
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

const normalizePoStatus = (value) => String(value || "").trim().toLowerCase();

const isSupplierGoodsPurchaseOrder = (po = {}) => {
  const info = parseMaybeJsonObject(po.supplierInfo);
  const typeValues = [po.purchaseOrderType, info.type].map((v) => String(v || "").trim());
  const decorationTypes = new Set([
    "Different_supplier_decoration",
    "Same_supplier_decoration",
    "decoration",
  ]);

  if (typeValues.some((type) => decorationTypes.has(type))) return false;
  if (info.decoratorId != null && String(info.decoratorId).trim()) return false;
  if (Array.isArray(info.charges) && info.charges.some((charge) => charge?.decoratorId != null)) return false;

  const supplierId = info.supplierId || po.SupplierId || po.supplierId || null;
  const supplierName = info.supplierName || po.SupplierName || po.supplierName || "";
  const hasProducts =
    (Array.isArray(po.items) && po.items.length > 0) ||
    (Array.isArray(info.products) && info.products.length > 0);

  return Boolean(supplierId || supplierName || hasProducts);
};

const shouldAutoMarkSupplierPoShipped = (po, nextDateIso) => {
  if (!nextDateIso) return false;
  const currentStatus = normalizePoStatus(po?.supplierStatus);
  if (!AUTO_SHIP_ALLOWED_STATUSES.has(currentStatus)) return false;
  return isSupplierGoodsPurchaseOrder(po);
};

// reverse map for case-insensitive label -> code
// put this near buildUserIndex
const normalizeAvatarUrl = (imgSrc) => {
  if (!imgSrc) return null;
  if (Array.isArray(imgSrc)) {
    const selected = imgSrc.find((p) => p?.selected) || imgSrc[0];
    return normalizeAvatarUrl(selected?.url || selected?.src || selected?.path || null);
  }
  if (typeof imgSrc === "object") {
    return normalizeAvatarUrl(imgSrc.url || imgSrc.src || imgSrc.path || null);
  }
  const raw = String(imgSrc || "").trim();
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed === "string") return normalizeAvatarUrl(parsed);
    if (parsed && typeof parsed === "object") return normalizeAvatarUrl(parsed);
  } catch (_err) {
    // Not JSON; continue with string URL normalization.
  }
  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.startsWith('/uploads')) return `${process.env.REACT_APP_NODEJS_SERVER_URL}${raw}`;
  if (raw.startsWith('/')) return raw;
  if (raw.startsWith('uploads')) return `${process.env.REACT_APP_NODEJS_SERVER_URL}/${raw}`;
  return raw;
};

const resolveNoteAvatarUrl = (note = {}, userObj = null) => normalizeAvatarUrl(
  note.userAvatar ||
  note.userAvatarUrl ||
  note.avatar ||
  note.avatarUrl ||
  note.profilePicture ||
  note.userProfilePicture ||
  note.user?.profilePicture ||
  note.user?.avatar ||
  note.user?.avatarUrl ||
  userObj?.profilePicture ||
  userObj?.avatar ||
  userObj?.avatarUrl ||
  null
);

const findNoteDirectoryUser = (note = {}, directories = []) => {
  const users = (directories || []).flat(Infinity).filter((u) => u && typeof u === "object");
  const userId = String(note?.userId || note?.user?.id || "");
  if (userId) {
    const byId = users.find((u) => String(u?.id ?? u?.userId ?? u?.user_id ?? "") === userId);
    if (byId) return byId;
  }

  const noteEmail = String(
    note?.userEmail ||
    note?.fromEmail ||
    note?.email?.fromEmail ||
    note?.meta?.originalSenderEmail ||
    ""
  ).trim().toLowerCase();
  if (!noteEmail) return null;

  return users.find((u) => String(
    u?.email || u?.Email || u?.workEmail || u?.userEmail || u?.primaryEmail || ""
  ).trim().toLowerCase() === noteEmail) || null;
};

const PRODUCTION_NOTE_ATTACHMENT_TYPES = new Set([
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
  "application/pdf",
]);
const PRODUCTION_NOTE_ATTACHMENT_MAX_BYTES = 15 * 1024 * 1024;

const formatProductionAttachmentSize = (size) => {
  const bytes = Number(size || 0);
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(bytes < 10 * 1024 ? 1 : 0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const validateProductionNoteAttachment = (file) => {
  if (!file) return null;
  if (!PRODUCTION_NOTE_ATTACHMENT_TYPES.has(file.type)) {
    return "Only image and PDF attachments are supported for production notes.";
  }
  if (file.size > PRODUCTION_NOTE_ATTACHMENT_MAX_BYTES) {
    return "Attachment must be 15 MB or smaller.";
  }
  return null;
};

const mergeDefinedProductionNoteFields = (base = {}, incoming = {}) => {
  const definedIncoming = Object.fromEntries(
    Object.entries(incoming || {}).filter(([, value]) => value !== undefined)
  );
  return { ...base, ...definedIncoming };
};

const productionNoteIdentityMatches = (a = {}, b = {}, options = {}) => {
  const aSeq = Number(a?.sequence);
  const bSeq = Number(b?.sequence);
  if (Number.isFinite(aSeq) && aSeq > 0 && Number.isFinite(bSeq) && bSeq > 0) return aSeq === bSeq;
  if (options.optimisticId && String(a?.id || "") === String(options.optimisticId)) return true;
  if (a?.id && b?.id && String(a.id) === String(b.id)) return true;
  if (String(a?.id || "").startsWith("tmp-") && b?.message && a?.message === b.message) {
    return String(a?.orderId || "") === String(b?.orderId || "") &&
      Math.abs(new Date(a?.createdAt || a?.timestamp || 0) - new Date(b?.createdAt || b?.timestamp || 0)) < 15000;
  }
  return false;
};

const upsertPurchasingProductionNote = (notes = [], note, options = {}) => {
  if (!note) return Array.isArray(notes) ? notes : [];
  const list = Array.isArray(notes) ? notes : [];
  let matched = false;
  const next = list.map((existing) => {
    if (!productionNoteIdentityMatches(existing, note, options)) return existing;
    matched = true;
    return mergeDefinedProductionNoteFields(existing, note);
  });
  if (matched) return next;
  return [note, ...list];
};

function ProductionNoteAttachmentPreview({ file, compact = false, onRemove }) {
  const [previewUrl, setPreviewUrl] = React.useState(null);
  const isPdf = file?.type === "application/pdf";
  React.useEffect(() => {
    if (!file || isPdf) {
      setPreviewUrl(null);
      return undefined;
    }
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file, isPdf]);
  if (!file) return null;
  return (
    <div className={`production-note-attachment-preview${compact ? " is-compact" : ""}`}>
      {isPdf ? (
        <PictureAsPdfOutlinedIcon className="production-note-attachment-icon" fontSize="small" />
      ) : (
        previewUrl && <img className="production-note-attachment-thumb" src={previewUrl} alt="Attachment preview" />
      )}
      <span className="production-note-attachment-copy">
        <span className="production-note-attachment-name" title={file.name}>{file.name}</span>
        <span className="production-note-attachment-meta">{formatProductionAttachmentSize(file.size)}</span>
      </span>
      <button type="button" className="production-note-attachment-remove" onClick={onRemove} aria-label="Remove attachment">×</button>
    </div>
  );
}

function ProductionNoteAttachments({ attachments = [], onImageClick }) {
  const list = Array.isArray(attachments) ? attachments.filter((a) => a?.url) : [];
  if (!list.length) return null;
  return (
    <div className="production-note-attachments">
      {list.map((attachment, idx) => {
        const isPdf = attachment.type === "pdf" || attachment.mimeType === "application/pdf";
        const key = `${attachment.url}-${idx}`;
        if (isPdf) {
          return (
            <a key={key} className="production-note-file-card" href={attachment.url} target="_blank" rel="noreferrer">
              <PictureAsPdfOutlinedIcon className="production-note-file-icon" fontSize="small" />
              <span className="production-note-file-copy">
                <span className="production-note-file-name">{attachment.fileName || "PDF attachment"}</span>
                <span className="production-note-file-meta">{formatProductionAttachmentSize(attachment.size)}{attachment.size ? " · " : ""}Open PDF →</span>
              </span>
            </a>
          );
        }
        return (
          <button key={key} type="button" className="production-note-image-button" onClick={() => onImageClick?.(attachment)}>
            <img className="production-note-image-thumb" src={attachment.url} alt={attachment.fileName || "Production note attachment"} />
          </button>
        );
      })}
    </div>
  );
}

const getInitials = (name = "", fallback = "U") => {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return fallback;
};

const getStatusColors = (status) => {
  switch ((status || "").toLowerCase()) {
    case "problem":   return { bg: "#dc2626", fg: "#fff" }; // red
    case "ok":        return { bg: "#16a34a", fg: "#fff" }; // green
    case "follow up": return { bg: "#d97706", fg: "#fff" }; // amber
    default:          return { bg: "#6b7280", fg: "#fff" }; // gray for N/A
  }
};

// --- PDF helpers ---
const isPdfUrl = (s = "") => /\.pdf(?:$|[?#])/i.test(s);
const extFromUrl = (url = "") => {
  try {
    const u = new URL(url);
    const m = (u.pathname || "").toLowerCase().match(/\.([a-z0-9]+)$/i);
    return m ? m[1] : "";
  } catch {
    const m = String(url).toLowerCase().match(/\.([a-z0-9]+)(?:\?|#|$)/i);
    return m ? m[1] : "";
  }
};
const isImageExt = (ext = "") => ["png", "jpg", "jpeg", "gif", "pdf", "esv", "webp", "bmp", "svg"].includes(ext);
const toAuditTrail = (proof) => {
  const raw = proof?.auditTrail;
  if (Array.isArray(raw)) return raw;
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

const hasUploadedFile = (p) => {
  const url = String(p?.proofFilePath || p?.filePath || "");
  if (!url) return false;
  return !/placeholder|sample|dummy|temp|draft/i.test(url);
};

const getVisibleProofRows = (rows = [], poId) => {
  return (Array.isArray(rows) ? rows : []).filter((row) => {
    const rowId = String(row?.id || "");
    const poKey = String(row?.poId || poId || "");

    const hasFile = hasUploadedFile(row);
    const hasHistory = toAuditTrail(row).length > 0;

    const isSyntheticEmptyPoRow =
      rowId === poKey &&
      !hasFile &&
      !hasHistory &&
      !row?.proofFilePath &&
      !row?.filePath;

    return !isSyntheticEmptyPoRow;
  });
};

// Small cached PDF thumbnail (page 1)
const __pdfThumbCache = new Map(); // url -> dataURL
const PdfThumb = ({ src, width = 180, height = 120, skeleton = "…" }) => {
  const [dataUrl, setDataUrl] = React.useState(() => __pdfThumbCache.get(src) || "");
  const [fail, setFail] = React.useState(false);

  React.useEffect(() => {
    let cancelled = false;
    if (!src) return;
    if (__pdfThumbCache.has(src)) { setDataUrl(__pdfThumbCache.get(src)); return; }

    (async () => {
      try {
        const task = getDocument({ url: src, withCredentials: false });
        const pdf = await task.promise;
        const page = await pdf.getPage(1);
        const v0 = page.getViewport({ scale: 1 });
        const scale = Math.min(width / v0.width, height / v0.height);
        const viewport = page.getViewport({ scale: Math.max(scale, 0.2) });

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = Math.floor(viewport.width);
        canvas.height = Math.floor(viewport.height);
        await page.render({ canvasContext: ctx, viewport }).promise;
        if (cancelled) return;
        const url = canvas.toDataURL("image/png");
        __pdfThumbCache.set(src, url);
        setDataUrl(url);
      } catch {
        if (!cancelled) setFail(true);
      }
    })();

    return () => { cancelled = true; };
  }, [src, width, height]);

  if (fail) return null;
  if (!dataUrl) {
    return (
      <div style={{ width, height, display:"grid", placeItems:"center", fontSize:12, color:"#888" }}>
        {skeleton}
      </div>
    );
  }
  return <img src={dataUrl} alt="PDF" style={{ width, height, objectFit:"contain" }} />;
};

// Full live PDF viewer dialog
const PdfViewerDialog = ({ open, src, fileName, onClose }) => {
  const canvasRef = React.useRef(null);
  const [numPages, setNumPages] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const [scale, setScale] = React.useState(1);
  const [busy, setBusy] = React.useState(false);
  const [err, setErr] = React.useState("");

  const renderPage = async (pdf, pageNum, scl) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    setBusy(true);
    try {
      const p = await pdf.getPage(pageNum);
      const viewport = p.getViewport({ scale: scl });
      const dpr = window.devicePixelRatio || 1;
      const ctx = canvas.getContext("2d", { alpha: false });
      canvas.width = Math.floor(viewport.width * dpr);
      canvas.height = Math.floor(viewport.height * dpr);
      canvas.style.width = `${Math.floor(viewport.width)}px`;
      canvas.style.height = `${Math.floor(viewport.height)}px`;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      await p.render({ canvasContext: ctx, viewport }).promise;
    } finally {
      setBusy(false);
    }
  };

  // (re)load doc on open/src
  React.useEffect(() => {
    if (!open || !src) return;
    let cancelled = false;

    (async () => {
      try {
        setErr("");
        const task = getDocument({ url: src, withCredentials: false });
        const pdf = await task.promise;
        if (cancelled) return;
        setNumPages(pdf.numPages);
        setPage(1);
        await renderPage(pdf, 1, scale);
      } catch {
        if (!cancelled) setErr("Could not load PDF.");
      }
    })();

    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, src]);

  // re-render page when page/scale change
  React.useEffect(() => {
    if (!open || !src) return;
    let cancelled = false;
    (async () => {
      try {
        const task = getDocument({ url: src, withCredentials: false });
        const pdf = await task.promise;
        if (cancelled) return;
        if (page < 1 || page > pdf.numPages) return;
        await renderPage(pdf, page, scale);
      } catch {/* noop */}
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, scale]);

  const zoomIn  = () => setScale(s => Math.min(s + 0.25, 4));
  const zoomOut = () => setScale(s => Math.max(s - 0.25, 0.25));
  const prev    = () => setPage(p => Math.max(p - 1, 1));
  const next    = () => setPage(p => Math.min(p + 1, numPages));

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle sx={{ display:"flex", alignItems:"center", gap:1 }}>
        {fileName || "Preview"}
        <Box sx={{ ml:"auto", display:"flex", alignItems:"center", gap:0.5 }}>
          <IconButton onClick={zoomOut} size="small" title="Zoom out" disabled={busy}><ZoomOutIcon fontSize="small" /></IconButton>
          <IconButton onClick={zoomIn}  size="small" title="Zoom in"  disabled={busy}><ZoomInIcon fontSize="small" /></IconButton>
          <IconButton onClick={prev}    size="small" title="Previous" disabled={busy || page<=1}><NavigateBeforeIcon fontSize="small" /></IconButton>
          <Typography variant="body2" sx={{ minWidth:80, textAlign:"center" }}>{page} / {numPages || "—"}</Typography>
          <IconButton onClick={next}    size="small" title="Next"     disabled={busy || page>=numPages}><NavigateNextIcon fontSize="small" /></IconButton>
          <IconButton size="small" title="Download" onClick={() => window.open(src, "_blank", "noopener,noreferrer")}>
            <FileDownloadOutlinedIcon fontSize="small" />
          </IconButton>
          <IconButton onClick={onClose} size="small" title="Close"><CloseIcon fontSize="small" /></IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={{ display:"grid", placeItems:"center", bgcolor:"#f7f7f7", minHeight:420 }}>
        {err ? <Typography color="error">{err}</Typography> : <canvas ref={canvasRef} />}
      </DialogContent>
    </Dialog>
  );
};

const ACTION_META = {
  'sent-email':         { icon: <MailOutlineIcon fontSize="small" />,       label: 'Email Sent',          color: '#1976d2' /* blue */ },
  'update':             { icon: <UpdateIcon fontSize="small" />,            label: 'Customer Updated',             color: '#0288d1' /* light blue */ },
  'approve':            { icon: <CheckCircleIcon fontSize="small" />,      label: 'Approved',            color: '#2e7d32' /* green */ },
  'decline':            { icon: <CancelIcon fontSize="small" />,           label: 'Declined',            color: '#c62828' /* red */ },
  'order-create':          { icon: <ShoppingCartIcon fontSize="small" />,     label: 'New Order',           color: '#ff8f00' /* amber */ },
  'presentation-generate':   { icon: <SlideshowIcon fontSize="small" />,        label: 'New Presentation',    color: '#6a1b9a' /* purple */ },
  'presentation-comment':   { icon: <SlideshowIcon fontSize="small" />,        label: 'Presentation Comment',    color: '#6a1b9a' /* purple */ },
  'estimate-create':       { icon: <ReceiptLongIcon fontSize="small" />,      label: 'New Estimate',        color: '#00796b' /* teal */ },
  'new-sales-order':    { icon: <MonetizationOnIcon fontSize="small" />,   label: 'New Sales Order',     color: '#afb42b' /* lime */ },
  'purchase-order-create': { icon: <LocalOfferIcon fontSize="small" />,       label: 'New Purchase Order',  color: '#5d4037' /* brown */ },
  'new-invoice':        { icon: <DescriptionIcon fontSize="small" />,     label: 'New Invoice',         color: '#283593' /* indigo */ },
  'new-bill':           { icon: <PaymentsIcon fontSize="small" />,        label: 'New Bill',            color: '#c79100' /* golden */ },
  'completed-order':    { icon: <DoneAllIcon fontSize="small" />,         label: 'Order Completed',     color: '#388e3c' /* dark green */ },
};

// Parse safely if backend ever returns proofs as a JSON string
const ensureArray = (v) => {
  if (Array.isArray(v)) return v;
  if (typeof v === 'string') { try { const p = JSON.parse(v); return Array.isArray(p) ? p : []; } catch { return []; } }
  return [];
};

// put this near your other helpers
const normalizeIdList = (val) => {
  if (!val) return [];
  // start from an array
  let arr =
    Array.isArray(val) ? val
    : typeof val === "string" ? val.split(/[,\s;]+/)
    : [val];

  return arr
    .flatMap((v) => {
      if (v == null) return [];
      // already an id
      if (typeof v === "number") return [String(v)];
      if (typeof v === "string") {
        const s = v.trim();
        if (!s) return [];
        // ignore emails here (they aren't ids)
        if (s.includes("@")) return [];
        return [s];
      }
      // object shapes we see in payloads
      if (typeof v === "object") {
        const id = v.id ?? v.userId ?? v.user_id ?? v.value ?? null;
        return id != null ? [String(id)] : [];
      }
      return [];
    })
    .filter(Boolean);
};


// Build once (optional): pass the same array you already fetch as `allUsers`
const buildUserIndex = (users = []) => {
  const byId = new Map();
  const flatUsers = Array.isArray(users) ? users.flat(Infinity) : [];
  flatUsers.forEach(u => {
    const id = u?.id ?? u?.userId ?? u?.user_id ?? u?.value ?? null;
    if (id == null) return;
    const first = u.first_name || u.firstName || "";
    const last  = u.last_name  || u.lastName  || "";
    const email = u.email || "";
    const name  = `${first} ${last}`.trim() || u.name || email || `User #${id}`;
    const pic   = u.profilePicture || u.avatar || u.avatarUrl || u.photoUrl || null;

    byId.set(String(id), {
      id: String(id),
      name,
      role: u.role || u.userRole || "",
      avatarUrl: normalizeAvatarUrl(pic),
      profilePicture: normalizeAvatarUrl(u.profilePicture || null),
      avatar: normalizeAvatarUrl(u.avatar || null),
      first, last, email,
    });
  });
  return byId;
};

// Safe label from ACTION_META (or prettify unknown actions)
const labelForAction = (action, ACTION_META = {}) => {
  const a = (action || "").trim();
  if (ACTION_META[a]) return ACTION_META[a].label;
  return a
    ? a.replace(/[-_]/g, " ").replace(/\b\w/g, c => c.toUpperCase())
    : "System";
};

const StatusPill = ({ status, onClick }) => {
  const { bg, fg } = getStatusColors(status);
  const label = status || "N/A";
  return (
    <Box
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick(e)}
      sx={{
        backgroundColor: bg,
        color: fg,
        px: 1,
        py: 0.5,
        borderRadius: 1,
        textAlign: "center",
        width: "100%",
        fontWeight: 700,
        fontSize: "0.875rem",
        cursor: "pointer",
        outline: "none",
        "&:focus-visible": { boxShadow: "0 0 0 2px rgba(25,118,210,0.6)" },
      }}
      title="Click to change status"
    >
      {label}
    </Box>
  );
};


export const normalizeCustomerNotes = (arr = [], userDirectory = [], ACTION_META = {}) => {
  const idx = Array.isArray(userDirectory) ? buildUserIndex(userDirectory) : userDirectory;

  return arr.map((n, i) => {
    const id        = n.id || `cust-${n.sequence ?? i}`;
    const createdAt = n.createdAt || n.timestamp || null;
    const action    = n.action || null;

    const userObj   = n.userId != null ? idx?.get?.(String(n.userId)) : null;
    const candidate = (n.userName || "").trim();
    const bad       = !candidate || /^undefined\s+undefined$/i.test(candidate) || /^no username/i.test(candidate);
    const userName  = !bad ? candidate : (userObj?.name || (action ? "System" : "Customer"));

    const userAvatar = resolveNoteAvatarUrl(n, userObj);

    return {
      id,
      message: n.message ?? "",
      createdAt,
      userId: n.userId ?? userObj?.id ?? null,
      userName,
      userAvatar,                      // ✅ add this
      avatar: userAvatar,
      avatarUrl: userAvatar,
      profilePicture: normalizeAvatarUrl(n.profilePicture || n.user?.profilePicture || userObj?.profilePicture || null),
      userRole: n.userRole || userObj?.role || (action ? "system" : "user"),
      action,
      label: labelForAction(action, ACTION_META),
      orderId: n.orderId ?? null,
      poId: n.poId ?? null,
      purchaseOrderId: n.purchaseOrderId ?? null,
      purchase_order_id: n.purchase_order_id ?? null,
      poNumber: n.poNumber ?? null,
      purchaseOrderNumber: n.purchaseOrderNumber ?? null,
      purchase_order_number: n.purchase_order_number ?? null,
      poIds: Array.isArray(n.poIds) ? n.poIds : undefined,
      purchaseOrderIds: Array.isArray(n.purchaseOrderIds) ? n.purchaseOrderIds : undefined,
      poNumbers: Array.isArray(n.poNumbers) ? n.poNumbers : undefined,
      purchaseOrderNumbers: Array.isArray(n.purchaseOrderNumbers) ? n.purchaseOrderNumbers : undefined,
      noteBucket: n.noteBucket ?? null,
      scope: n.scope ?? null,
      source: n.source ?? null,
      _origin: "customer",
    };
  });
};


// Actions that are clearly production-related
const PROD_ACTIONS = new Set([
  "purchase-order-create",
  "po-lifecycle-status-change",
  "production-note",
  "purchasing-note",
  "proof-approved",
  "proof-rejected",
  "proof-uploaded",
  "proof-upload-deleted",
  "all-proofs-approved",
  "po-receipt-saved",
  "po-receipt",
  "receiving",
]);

// Actions that are sales-order/project lifecycle notes, not production notes
const SALES_ORDER_ACTIONS = new Set([
  "sent-email",
  "sales-order-email",
  "sales-order-update",
  "new-sales-order",
  "update",
]);

// Sales order lifecycle/email/payment messages we do NOT want in Production
const SALES_ORDER_KEYWORDS =
  /\b(sales order|agreement sent|client approved|client change requested|agreement pending|customer change request|upfront payment|deposit|sales order email|email copy|view document)\b/i;

// Cart/product edits we do NOT want in Production
const CART_ITEM_KEYWORDS =
  /\b(edited cart item|cart item|qty\s+\d+\s*→\s*\d+|decorations?:)\b/i;

// Specific PO/proof/receiving events we DO want in Production
const PROD_EVENT_KEYWORDS =
  /\b(PO\s+\d+-\d+|PO:\s*\d+-\d+|proof\s+\S+\s+for\s+PO|all proofs approved|receipt saved|project PO statuses recalculated|receiver:|PO line:|qty mode:|qty input:|qty total on row:)\b/i;

// Decide if a note is production-y
const isWrittenProjectNoteForPurchasingPopup = (note = {}) => {
  const action = String(note?.action || "").trim().toLowerCase();
  const noteType = String(note?.noteType || "").trim().toLowerCase();
  const bucket = String(note?.noteBucket || "").trim().toLowerCase();
  const scope = String(note?.scope || "").trim().toLowerCase();

  return (
    action === "written-project-note" ||
    action === "order-note" ||
    noteType === "manual" ||
    (bucket === "project" && scope === "project")
  );
};

export const isProductionNote = (note) => {
  if (!note) return false;

  const action = String(note.action || "").toLowerCase();
  const message = String(note.message || "");

  // Exclude sales-order/cart lifecycle notes first.
  // Important: this must happen before `note.poId != null`.
  if (
    SALES_ORDER_ACTIONS.has(action) ||
    SALES_ORDER_KEYWORDS.test(message) ||
    CART_ITEM_KEYWORDS.test(message)
  ) {
    return false;
  }

  // Explicit production/purchasing/proof/receiving actions
  if (PROD_ACTIONS.has(action)) return true;

  // If explicitly tied to a PO, treat as production, after exclusions above
  if (note.poId != null) return true;

  // Keep only specific operational PO/proof/receiving system notes
  return PROD_EVENT_KEYWORDS.test(message);
};

// Aggregate a side's overall state across uploaded proofs
// returns: 'approved' | 'rejected' | 'pending' | 'na'
const aggregateSideState = (proofsRaw, side/*'user'|'client'*/) => {
  const proofs = ensureArray(proofsRaw).filter(p => !!p?.filePath); // only consider uploaded
  if (!proofs.length) return 'na';

  if (proofs.some(p => p?.approvals?.[side]?.state === 'rejected')) return 'rejected';
  if (proofs.every(p => p?.approvals?.[side]?.state === 'approved')) return 'approved';
  return 'pending';
};

// Simple dot UI
const colorForState = (state) => {
  switch (state) {
    case 'approved': return { fill: '#22c55e', border: '#16a34a' }; // green
    case 'rejected': return { fill: '#ef4444', border: '#dc2626' }; // red
    case 'pending':  return { fill: '#f59e0b', border: '#d97706' }; // amber
    default:         return { fill: '#e5e7eb', border: '#9ca3af' }; // gray (na/unknown)
  }
};

const humanize = (state) => {
  if (state === 'na') return '—';
  return state?.charAt(0).toUpperCase() + state?.slice(1);
};

// Tiny dot + compact orbs with tooltips
const SmallDot = ({ fill, border, label, state, onClick }) => (
  <Tooltip arrow placement="top" title={`${label}: ${humanize(state)}`}>
    <Box
      onClick={onClick}
      role="button"
      tabIndex={0}
      sx={{
        width: 12,
        height: 12,
        borderRadius: '50%',
        bgcolor: fill,
        border: `1px solid ${border}`,
        cursor: 'pointer',
      }}
    />
  </Tooltip>
);


const buildProofTooltip = (ps) => {
  if (!ps) return '';
  const chunks = [];
  if (ps.total) chunks.push(`${ps.approved}/${ps.total} approved`);
  if (ps.rejected) chunks.push(`${ps.rejected} rejected`);
  if (ps.pendingUser || ps.pendingClient) {
    const wait = [];
    if (ps.pendingUser)   wait.push(`${ps.pendingUser} internal`);
    if (ps.pendingClient) wait.push(`${ps.pendingClient} client`);
    chunks.push(`waiting: ${wait.join(', ')}`);
  }
  return chunks.join(' • ') || 'No proofs';
};

// Shorten long status labels for the pill
const shortLabelMap = {
  'Pending Approval': 'Pending',
  'Proof Needed': 'Needed',
  'No Proof': 'No Proof',
};
const shortLabel = (label) => shortLabelMap[label] || label;


const ApprovalOrb = ({ state, label }) => {
  const { fill, border } = colorForState(state);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 72 }}>
      <Typography variant="caption" sx={{ fontWeight: 600, color: '#374151', mb: 0.5 }}>
        {label}
      </Typography>
      <Box
        title={`${label}: ${humanize(state)}`}
        aria-label={`${label}: ${humanize(state)}`}
        sx={{
          width: 30,
          height: 30,
          borderRadius: '50%',
          backgroundColor: fill,
          border: `2px solid ${border}`,
          boxShadow: '0 0 0 2px #fff', // subtle ring separation if on colored bg
        }}
      />
      <Typography variant="caption" sx={{ mt: 0.5, color: '#6b7280', textTransform: 'capitalize' }}>
        {humanize(state)}
      </Typography>
    </Box>
  );
};

// Client-side fallback if backend didn't include proofSummary
// Client-side fallback if backend didn't include proofSummary
// Client-side fallback if backend didn't include proofSummary
const summarizeProofsClient = (po) => {
  const proofs   = ensureArray(po?.proofs);
  const uploaded = proofs.filter(p => !!p?.filePath);

  const isRejected = (p) => {
    const u = p?.approvals?.user?.state?.toLowerCase();
    const c = p?.approvals?.client?.state?.toLowerCase();
    return p?.status === 'Rejected' || u === 'rejected' || c === 'rejected';
  };
  const isApproved = (p) => {
    const u = p?.approvals?.user?.state?.toLowerCase();
    const c = p?.approvals?.client?.state?.toLowerCase();
    return p?.status === 'Approved' || (u === 'approved' && c === 'approved');
  };

  const approvedCount = uploaded.filter(isApproved).length;
  const rejectedCount = uploaded.filter(isRejected).length;

  const pendingClient = uploaded.filter(p => {
    const s = p?.approvals?.client?.state?.toLowerCase();
    return s !== 'approved' && s !== 'rejected';
  }).length;

  const pendingUser = uploaded.filter(p => {
    const s = p?.approvals?.user?.state?.toLowerCase();
    return s !== 'approved' && s !== 'rejected';
  }).length;

  const total = proofs.length;
  const proofRequired = !!po?.proofRequired;
  const dbStatus = (po?.proofStatus || '').trim().toLowerCase();

  // Only treat as "No Proof" if there is truly nothing proof-related
  const nothingProofy =
    total === 0 &&
    uploaded.length === 0 &&
    !proofRequired;

  if (dbStatus === 'no proof' && nothingProofy) {
    return {
      total: 0, uploaded: 0, approved: 0, rejected: 0,
      pendingClient: 0, pendingUser: 0,
      allProofsUploaded: false,
      displayStatus: 'No Proof',
      clientLinks: [],
    };
  }

  let displayStatus = 'Proof Needed';
  if (rejectedCount > 0) displayStatus = 'Rejected';
  else if (approvedCount === uploaded.length && uploaded.length > 0) displayStatus = 'Approved';
  else if (uploaded.length > 0) displayStatus = 'Pending Approval';

  const clientLinks = uploaded.map(p => ({
    proofId:  String(p.id),
    location: p.location || p.decoration?.location || null,
    path:     `/generated-proofs/${po.id}`,
  }));

  return {
    total,
    uploaded: uploaded.length,
    approved: approvedCount,
    rejected: rejectedCount,
    pendingClient,
    pendingUser,
    allProofsUploaded: proofs.some(p => p?.allProofsUploaded) && displayStatus !== 'No Proof',
    displayStatus,
    clientLinks,
  };
};

const normalize = s => (s || '').trim().toLowerCase();

const finalizeProofSummaryForUI = (po) => {
  const client = summarizeProofsClient(po);

  // If anything is rejected, don't force Uploaded
  const anyRejected =
    (client.rejected ?? 0) > 0 ||
    ensureArray(po?.proofs).some(p => {
      const u = p?.approvals?.user?.state?.toLowerCase();
      const c = p?.approvals?.client?.state?.toLowerCase();
      return u === 'rejected' || c === 'rejected';
    });

  // Are ALL uploaded proofs approved?
  const allApproved =
    (client.uploaded ?? 0) > 0 &&
    (client.approved ?? 0) === (client.uploaded ?? 0);

  // Only show "Proof Uploaded" while waiting on approvals
  if (po.allProofsUploaded === true &&
      client.displayStatus !== 'No Proof' &&
      !anyRejected &&
      !allApproved &&              // ← key change
      (client.uploaded ?? 0) > 0)  // must actually have uploads
  {
    return { ...client, allProofsUploaded: true, displayStatus: 'Proof Uploaded' };
  }

  return client;
};

const normalizeNote = (n, i, userDirectory = []) => {
  const seq = Number(n?.sequence);
  const normalizedSequence = Number.isFinite(seq) && seq > 0 ? seq : null;
  const idx = Array.isArray(userDirectory) ? buildUserIndex(userDirectory) : userDirectory;
  const userObj = n?.userId != null ? idx?.get?.(String(n.userId)) : null;
  const userAvatar = resolveNoteAvatarUrl(n, userObj);
  return {
    ...n,
    id: n.id || (normalizedSequence ? `seq-${normalizedSequence}` : `cust-${i ?? Date.now()}`),
    sequence: normalizedSequence,
    message: n.message ?? "",
    createdAt: n.createdAt || n.timestamp || new Date().toISOString(),
    userName: n.userName || userObj?.name || n.action || "Customer",
    userId: n.userId ?? userObj?.id ?? null,
    userAvatar,
    avatar: userAvatar,
    avatarUrl: userAvatar,
    profilePicture: normalizeAvatarUrl(n.profilePicture || n.user?.profilePicture || userObj?.profilePicture || null),
    poId: n.poId ?? null,
    purchaseOrderId: n.purchaseOrderId ?? null,
    orderId: n.orderId ?? null,
    customerId: n.customerId ?? null,
    noteBucket: n.noteBucket ?? null,
    scope: n.scope ?? null,
    source: n.source ?? null,
    parentId: n.parentId ?? null,
    parentSequence: n.parentSequence ?? null,
    parentNoteSequence: n.parentNoteSequence ?? null,
    messageText: n.messageText ?? null,
    messageHtml: n.messageHtml ?? null,
    attachments: Array.isArray(n.attachments) ? n.attachments : [],
    mentions: Array.isArray(n.mentions) ? n.mentions : [],
    pinned: Boolean(n.pinned || n.pinnedPurchasing),
    pinnedPurchasing: Boolean(n.pinnedPurchasing),
    _origin: n._origin || "unknown",
  };
};

const noteKeyOf = (n) => {
  const seq = Number(n?.sequence);
  if (Number.isFinite(seq) && seq > 0) return `seq:${seq}`;
  if (n?.id) return `id:${String(n.id)}`;
  return `tmp:${String(n?.createdAt || Date.now())}:${String(n?.message || "").slice(0, 24)}`;
};

const parentKeyOf = (n) => {
  const parentSeq = Number(n?.parentSequence);
  if (Number.isFinite(parentSeq) && parentSeq > 0) return `seq:${parentSeq}`;
  const rawParentId = String(n?.parentId || "").trim();
  if (!rawParentId) return "";
  if (rawParentId.startsWith("seq:") || rawParentId.startsWith("id:")) return rawParentId;
  return `id:${rawParentId}`;
};


// Upsert one or many notes into state (by sequence/id; also merges optimistic duplicates)
const upsertNotes = (prev, incomingRaw, userDirectory = [], options = {}) => {
  const incomingArr = Array.isArray(incomingRaw) ? incomingRaw : [incomingRaw];
  return incomingArr.reduce((acc, raw, index) => {
    const normalized = normalizeNote(raw, index, userDirectory);
    return upsertPurchasingProductionNote(acc, normalized, options);
  }, Array.isArray(prev) ? prev : []).sort((a, b) =>
    new Date(b.createdAt || b.timestamp || 0) - new Date(a.createdAt || a.timestamp || 0)
  );
};

const ProofThumb = ({ src, href, onDelete, width = 160 }) => {
  const handleDeleteClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!onDelete) return;
    const ok = window.confirm("Delete this image?");
    if (!ok) return;
    await onDelete();
  };

  return (
    <Box
      className="proof-thumb"
      sx={{
        position: "relative",
        borderRadius: 1,
        overflow: "hidden",
        "&:hover .delBtn, &:focus-within .delBtn": {
          opacity: 1,
          transform: "scale(1)",
        },
        // Optional: keep visible on touch devices (comment out if you truly want *only* hover)
        // "@media (hover: none)": { "& .delBtn": { opacity: 1 } },
      }}
    >
      <a href={href} target="_blank" rel="noopener noreferrer" aria-label="Open proof in new tab">
        <Box
          component="img"
          src={src}
          alt="Proof image"
          sx={{ display: "block", width: "100%", objectFit: "contain" }}
        />
      </a>

      {onDelete && (
        <IconButton
          aria-label="Delete image"
          title="Delete"
          className="delBtn"
          size="small"
          onClick={handleDeleteClick}
          sx={{
            position: "absolute",
            top: 6,
            right: 6,
            opacity: 0,
            transform: "scale(0.9)",
            transition: "opacity 120ms ease, transform 120ms ease",
            bgcolor: "rgba(0,0,0,0.55)",
            color: "common.white",
            "&:hover": { bgcolor: "error.main" },
            zIndex: 2,
          }}
        >
          <DeleteForeverIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};

// --- proof normalization (UI <-> server) ---
const normalizeProof = (p) => {
  const out = {
    ...p,
    status: p?.status ?? p?.proofStatus ?? "Proof Needed",
    filePath: p?.filePath ?? p?.proofFilePath ?? null,
    approvals: p?.approvals ?? {
      user:   { state: "pending", by: null, byId: null, at: null },
      client: { state: "pending", by: null, byId: null, at: null },
    },
  };

  // If there’s an upload, infer status from approvals when status is stale
  if (out.filePath) {
    const u = out.approvals?.user?.state?.toLowerCase();
    const c = out.approvals?.client?.state?.toLowerCase();
    if (u === 'rejected' || c === 'rejected') out.status = 'Rejected';
    else if (u === 'approved' && c === 'approved') out.status = 'Approved';
    else if (!out.status || out.status === 'Proof Needed') out.status = 'Uploaded';
  }
  return out;
};

const toServerUpdate = (partial) => {
  const out = { ...partial };
  if ("status" in out) { out.proofStatus = out.status; delete out.status; }
  if ("filePath" in out) { out.proofFilePath = out.filePath; delete out.filePath; }
  return out;
};

// Compact approval chip used in SIMPLE view
// Compact approval chip (simple view)
function ApprovalChip({ roleLabel = "", state = "pending", at, by }) {
  // normalize from earlier answer
  const normBy = (v) => {
    if (!v) return { name: "", email: "" };
    if (typeof v === "string") {
      const m = v.match(/^(.*?)\s*<([^>]+)>$/);
      return m ? { name: (m[1] || "").trim(), email: (m[2] || "").trim() }
               : { name: v.trim(), email: "" };
    }
    if (typeof v === "object") return { name: v.name || "", email: v.email || "" };
    return { name: String(v), email: "" };
  };
  const { name, email } = normBy(by);

  const whenTxt = (ts, s) => {
    if (!ts) return "—";
    const dt = new Date(ts);
    const verb = s === "approved" ? "Approved" : s === "rejected" ? "Rejected" : "Updated";
    return `${verb} at ${dt.toLocaleString()}`;
  };

  const tone = pickStatus(state);
  const isInternal = /^internal/i.test(roleLabel);
  const roleTone = isInternal ? ROLE_ACCENTS.internal : ROLE_ACCENTS.client;

  return (
    <Tooltip
      arrow
      title={
        <div>
          <div><b>{name || roleLabel}</b></div>
          <div style={{opacity:0.8}}>{email || "—"}</div>
          <div style={{opacity:0.8, marginTop: 4}}>{whenTxt(at, (state || "").toLowerCase())}</div>
        </div>
      }
    >
      <Chip
        size="small"
        label={`${roleLabel}: ${state || "pending"}`}
        variant="outlined"
        sx={{
          textTransform: "capitalize",
          fontWeight: 700,
          bgcolor: tone.bg,
          color: tone.text,
          borderColor: tone.bd,
          position: 'relative',
          pl: 1.75, // space for the dot
          '& .MuiChip-label': { px: 1.25, py: 0.25 },
          // subtle role accent ring
          boxShadow: `0 0 0 2px ${roleTone.ring}1A`, // 10% alpha
          // tiny left dot to differentiate Internal vs Client
          '&:before': {
            content: '""',
            position: 'absolute',
            left: 6,
            top: '50%',
            transform: 'translateY(-50%)',
            width: 6,
            height: 6,
            borderRadius: '999px',
            background: roleTone.dot,
          },
        }}
      />
    </Tooltip>
  );
}

















export default function PurchasingPopup({ open, onClose, poData, onPoFlagChange, onProofsChange, onPoUpdated, initialTab = "overview", initialRecipients, usersForMentions =[] }) {
  const { instanceUniqueId } = useParams();
  const { nextActionTypeOptions, nextActionTypes } = useInstanceNextActionTypes(instanceUniqueId);

  const actionNameFromAny = useCallback((val) => {
    if (val == null) return null;
    const byId = nextActionTypeOptions.find((option) => String(option.id) === String(val));
    if (byId) return byId.name;
    const byName = nextActionTypeOptions.find((option) => option.name === String(val));
    return byName ? byName.name : String(val);
  }, [nextActionTypeOptions]);

  const actionIdFromAny = useCallback((val) => {
    if (val == null) return "";
    const byName = nextActionTypeOptions.find((option) => option.name === String(val));
    if (byName) return String(byName.id);
    const byId = nextActionTypeOptions.find((option) => String(option.id) === String(val));
    return byId ? String(byId.id) : String(val);
  }, [nextActionTypeOptions]);
  const { authState } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState(initialTab);
  
  const [fromUserId, setFromUserId] = useState("");
  const [fromOptions, setFromOptions] = useState([]); // [{id, name, email}]
  const [recipients, setRecipients] = useState({
    clientReps:[], orderReps:[], assignedToEmails:[], customer:[], all:[]
  });

  useEffect(() => {
    if (!open) return;
    if (initialRecipients) {
      // Only seed if empty (don’t clobber user edits on reopen)
      const empty =
        !recipients.clientReps.length &&
        !recipients.orderReps.length &&
        !recipients.assignedToEmails.length &&
        !recipients.customer.length &&
        !recipients.all.length;

      if (empty) setRecipients(initialRecipients);
    }
  }, [open, initialRecipients]); // eslint-disable-line


  useEffect(() => { if (open) setActiveTab(initialTab); }, [open, initialTab]);

  const handleDialogClose = React.useCallback((e, reason) => {
    // ignore backdrop clicks and ESC
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    onClose?.();
  }, [onClose]);  

  // shipping
  const [shippingState, setShippingState] = useState({
    dateShipped: "",
    shippingCost: "",
    trackingNumbers: "",
  });
  const [shippingSubTab, setShippingSubTab] = useState("manage");
  const [shippingProgressState, setShippingProgressState] = useState({
    loading: false,
    loaded: false,
    error: "",
    receipts: [],
    progressRows: [],
    receiptSourcePoId: null,
    receiptSourcePoNumber: "",
    receiptSourceReason: "",
  });
  const [shippingPlacement, setShippingPlacement] = useState({
    enabled: false,
    warehouseKey: "main",
    binKey: "",
    warehouseLevel: "",
    warehouseCell: "",
    binLabel: "",
    binSubLocation: "",
    binShelfLevel: "",
    boxRef: "",
    containerType: "",
    containerCount: "",
    notes: "",
  });
  const [shippingWarehouses, setShippingWarehouses] = useState([]);
  const [shippingWarehouseLoading, setShippingWarehouseLoading] = useState(false);
  const [shippingWarehouseLayout, setShippingWarehouseLayout] = useState(null);
  const [shippingWarehouseLayoutLoading, setShippingWarehouseLayoutLoading] = useState(false);
  const [shippingWarehouseError, setShippingWarehouseError] = useState("");
  const [shippingBinPickerOpen, setShippingBinPickerOpen] = useState(false);

  // PDF preview state
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewSrc, setPreviewSrc]   = useState("");
  const [previewName, setPreviewName] = useState("");
  const [historyOpen, setHistoryOpen] = useState(false);
  const [historyProof, setHistoryProof] = useState(null);

  // Open preview helper
  const openPreview = (src, name = "Preview.pdf") => {
    if (!src) return;
    setPreviewSrc(src);
    setPreviewName(name);
    setPreviewOpen(true);
  };
  const openHistory = (proof) => {
    setHistoryProof(proof || null);
    setHistoryOpen(true);
  };

  useEffect(() => {
    if (!open || !poData) return;
  
    const dateIso =
      poData.shippedAt ??
      poData.dateShipped ??
      null;
  
    const costNum =
      poData?.shippingCostCents != null
        ? poData.shippingCostCents / 100
        : (poData?.shippingCost != null ? Number(poData.shippingCost) : null);
  
    const tnCsv = Array.isArray(poData?.trackingNumbers)
      ? trackingToCsv(poData.trackingNumbers)
      : (poData?.trackingNumbers || "");
  
    setShippingState({
      dateShipped: isoToYmd(dateIso),
      shippingCost: costNum == null ? "" : costNum.toFixed(2),
      trackingNumbers: tnCsv,
    });
  }, [
    open,
    // re-seed when *any* of these change:
    poData?.id,
    poData?.shippedAt,
    poData?.dateShipped,
    poData?.shippingCostCents,
    poData?.shippingCost,
    // string vs array
    Array.isArray(poData?.trackingNumbers)
      ? JSON.stringify(poData?.trackingNumbers)
      : poData?.trackingNumbers
  ]);

  const showShippingProgressTab = useMemo(
    () => shouldShowReceivingProgress(poData?.supplierStatus),
    [poData?.supplierStatus]
  );

  useEffect(() => {
    if (!open) return;
    setShippingSubTab("manage");
    setShippingProgressState({
      loading: false,
      loaded: false,
      error: "",
      receipts: [],
      progressRows: [],
      receiptSourcePoId: null,
      receiptSourcePoNumber: "",
      receiptSourceReason: "",
    });
    setShippingPlacement({
      enabled: false,
      warehouseKey: "main",
      binKey: "",
      warehouseLevel: "",
      warehouseCell: "",
      binLabel: "",
      binSubLocation: "",
      binShelfLevel: "",
      boxRef: "",
      containerType: "",
      containerCount: "",
      notes: "",
    });
    setShippingWarehouses([]);
    setShippingWarehouseLoading(false);
    setShippingWarehouseLayout(null);
    setShippingWarehouseLayoutLoading(false);
    setShippingWarehouseError("");
    setShippingBinPickerOpen(false);
  }, [open, poData?.id]);

  useEffect(() => {
    if (!showShippingProgressTab && shippingSubTab === "progress") {
      setShippingSubTab("manage");
    }
  }, [showShippingProgressTab, shippingSubTab]);

  const loadShippingProgress = useCallback(async () => {
    const poId = Number(poData?.id);
    if (!Number.isFinite(poId)) return;
    setShippingProgressState((prev) => ({ ...prev, loading: true, error: "" }));
    try {
      const res = await fetchPoReceipts(poId, instanceUniqueId);
      setShippingProgressState({
        loading: false,
        loaded: true,
        error: "",
        receipts: Array.isArray(res?.receipts) ? res.receipts : [],
        progressRows: Array.isArray(res?.progressRows) ? res.progressRows : [],
        receiptSourcePoId: Number.isFinite(Number(res?.receiptSourcePoId)) ? Number(res.receiptSourcePoId) : null,
        receiptSourcePoNumber: String(res?.receiptSourcePoNumber || ""),
        receiptSourceReason: String(res?.receiptSourceReason || ""),
      });
    } catch (error) {
      setShippingProgressState({
        loading: false,
        loaded: true,
        error: error?.response?.data?.message || "Failed to load receiving progress.",
        receipts: [],
        progressRows: [],
        receiptSourcePoId: null,
        receiptSourcePoNumber: "",
        receiptSourceReason: "",
      });
    }
  }, [poData?.id, instanceUniqueId]);

  useEffect(() => {
    if (!open || activeTab !== "shipping") return;
    loadShippingProgress();
  }, [open, activeTab, loadShippingProgress]);

  useEffect(() => {
    if (!open || activeTab !== "shipping" || !shippingPlacement.enabled || !instanceUniqueId) return;
    let cancelled = false;
    const loadWarehouses = async () => {
      setShippingWarehouseLoading(true);
      setShippingWarehouseError("");
      try {
        const res = await fetchWarehouses(instanceUniqueId);
        if (cancelled) return;
        const nextWarehouses = Array.isArray(res?.warehouses) ? res.warehouses : [];
        setShippingWarehouses(nextWarehouses);
        if (nextWarehouses.length && !nextWarehouses.some((warehouse) => warehouse.warehouseKey === shippingPlacement.warehouseKey)) {
          setShippingPlacement((prev) => ({
            ...prev,
            warehouseKey: nextWarehouses[0]?.warehouseKey || "main",
            binKey: "",
            warehouseLevel: "",
            warehouseCell: "",
            binLabel: "",
          }));
        }
      } catch (error) {
        if (cancelled) return;
        setShippingWarehouseError(error?.response?.data?.message || "Failed to load warehouses.");
      } finally {
        if (!cancelled) setShippingWarehouseLoading(false);
      }
    };
    loadWarehouses();
    return () => {
      cancelled = true;
    };
  }, [open, activeTab, shippingPlacement.enabled, instanceUniqueId]);

  useEffect(() => {
    if (!open || activeTab !== "shipping" || !shippingPlacement.enabled || !instanceUniqueId) return;
    let cancelled = false;
    const loadLayout = async () => {
      setShippingWarehouseLayoutLoading(true);
      setShippingWarehouseError("");
      try {
        const res = await fetchWarehouseLayout(instanceUniqueId, shippingPlacement.warehouseKey || "main");
        if (cancelled) return;
        setShippingWarehouseLayout(res?.layout || null);
      } catch (error) {
        if (cancelled) return;
        setShippingWarehouseLayout(null);
        setShippingWarehouseError(error?.response?.data?.message || "Failed to load warehouse layout.");
      } finally {
        if (!cancelled) setShippingWarehouseLayoutLoading(false);
      }
    };
    loadLayout();
    return () => {
      cancelled = true;
    };
  }, [open, activeTab, shippingPlacement.enabled, shippingPlacement.warehouseKey, instanceUniqueId]);

  const shippingBinOptions = useMemo(
    () => parseWarehouseBins(shippingWarehouseLayout),
    [shippingWarehouseLayout]
  );
  const selectedShippingBinOption = useMemo(
    () => shippingBinOptions.find((bin) => bin.key === shippingPlacement.binKey) || null,
    [shippingBinOptions, shippingPlacement.binKey]
  );
  const selectedShippingBinSummary = useMemo(() => {
    if (!selectedShippingBinOption) return "No bin selected.";
    return getStorageLocationDisplay({
      binLabel: selectedShippingBinOption.label,
      binSubLocation: shippingPlacement.binSubLocation,
      binShelfLevel: shippingPlacement.binShelfLevel,
      delimiter: " • ",
    });
  }, [selectedShippingBinOption, shippingPlacement.binShelfLevel, shippingPlacement.binSubLocation]);
  const selectedShippingBinTooltip = useMemo(() => selectedShippingBinOption
    ? getWarehouseLevelTooltip({
        layout: shippingWarehouseLayout,
        levelId: selectedShippingBinOption.warehouseLevel,
        fallbackName: selectedShippingBinOption.levelName,
      })
    : "", [selectedShippingBinOption, shippingWarehouseLayout]);
  const hasExistingShippingReceipts = shippingProgressState.receipts.length > 0;
  const canChangeWarehousePlacement =
    hasExistingShippingReceipts && !shippingProgressState.loading && !shippingProgressState.error;
  const shippingPlacementUnavailableMessage = shippingProgressState.loading
    ? "Checking received inventory for warehouse placement..."
    : shippingProgressState.error
      ? shippingProgressState.error
      : shippingProgressState.loaded && !hasExistingShippingReceipts
        ? "No received inventory is available for warehouse placement."
        : "";

  useEffect(() => {
    if (!shippingPlacement.enabled || canChangeWarehousePlacement || shippingProgressState.loading) return;
    setShippingPlacement((prev) => ({ ...prev, enabled: false }));
  }, [shippingPlacement.enabled, canChangeWarehousePlacement, shippingProgressState.loading]);

  const handlePickShippingBinFromMap = useCallback((binOption) => {
    setShippingPlacement((prev) => ({
      ...prev,
      binKey: binOption.key,
      warehouseLevel: binOption.warehouseLevel,
      warehouseCell: binOption.warehouseCell,
      binLabel: binOption.label,
    }));
    setShippingBinPickerOpen(false);
  }, []);

  const shippingProgressRows = useMemo(() => {
    const normalizeLineKey = (value) => String(value ?? "").trim();
    const receivedByLineKey = {};
    const storageByLineKey = {};
    const storageLevelsByLineKey = {};
    shippingProgressState.receipts.forEach((receipt) => {
      const key = normalizeLineKey(receipt?.poLineKey);
      if (!key) return;
      const quantityExact = Number(receipt?.quantityExact);
      const quantity = Number(receipt?.quantity);
      const legacyReceived = Number(receipt?.receivedQuantity);
      const receivedQuantity = Number.isFinite(quantityExact)
        ? quantityExact
        : (Number.isFinite(quantity) ? quantity : (Number.isFinite(legacyReceived) ? legacyReceived : 0));
      receivedByLineKey[key] = (Number(receivedByLineKey[key]) || 0) + receivedQuantity;
      const storage = buildReceiptStoragePresentation(receipt, shippingWarehouseLayout);
      if (!storageByLineKey[key]) storageByLineKey[key] = new Set();
      if (!storageLevelsByLineKey[key]) storageLevelsByLineKey[key] = new Set();
      if (storage.visibleText) storageByLineKey[key].add(storage.visibleText);
      if (storage.levelName) storageLevelsByLineKey[key].add(storage.levelName);
    });
    const decorateStorage = (line) => {
      const key = normalizeLineKey(line?.lineKey);
      const storageValues = Array.from(storageByLineKey[key] || new Set());
      const levelNames = Array.from(storageLevelsByLineKey[key] || new Set());
      const storageDetails = storageValues.join(" | ");
      const storageTooltip = levelNames.length
        ? `Warehouse level${levelNames.length > 1 ? "s" : ""}: ${levelNames.join(", ")}`
        : "";
      return storageValues.length ? {
        ...line,
        storageSummary: storageDetails || "—",
        storageDetails,
        storageTooltip,
      } : line;
    };
    if (Array.isArray(shippingProgressState.progressRows) && shippingProgressState.progressRows.length) {
      return shippingProgressState.progressRows.map(decorateStorage);
    }
    const lines = parseReceivablePoLines(poData);
    return lines.map((line) => {
      const orderedQuantity = Number(line?.orderedQuantity);
      const receivedQuantity = Number(receivedByLineKey[normalizeLineKey(line.lineKey)] || 0);
      const remainingQuantity = Number.isFinite(orderedQuantity) ? orderedQuantity - receivedQuantity : null;
      return decorateStorage({
        ...line,
        receivedQuantity,
        remainingQuantity,
        fullyReceived: Number.isFinite(orderedQuantity) ? receivedQuantity >= orderedQuantity : false,
        storageSummary: "—",
        storageDetails: "",
      });
    });
  }, [poData, shippingProgressState.receipts, shippingProgressState.progressRows, shippingWarehouseLayout]);
  

  const [uploadingAll, setUploadingAll] = useState(false);

// ⬇️ add near other imports at top of file if not present
// import axios from "axios";  // you already import axios in the file

// --- inside ProofPopup ---
const [poEdit, setPoEdit] = useState({
  supplierStatus: poData?.supplierStatus || "",
  productionRepStatus: poData?.productionRepStatus || "",
  nextActionType: actionNameFromAny(poData?.nextActionType ?? poData?.nextAction ?? ""),
  nextActionDate: "", // "yyyy-MM-ddTHH:mm" for <input type="datetime-local">
});
const [savingPo, setSavingPo] = useState(false);

// format ISO → "yyyy-MM-ddTHH:mm" for input
const isoToInputLocal = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  // keep minutes precision (strip seconds/ms)
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

// convert "yyyy-MM-ddTHH:mm" (local) → ISO string
const inputLocalToIso = (localStr) => {
  if (!localStr) return null;
  const d = new Date(localStr); // interpreted as local time
  return isNaN(d) ? null : d.toISOString();
};

// seed edit state whenever a new PO opens
useEffect(() => {
  setPoEdit({
    supplierStatus: poData?.supplierStatus || "",
    productionRepStatus: poData?.productionRepStatus || "",
    nextActionType: actionNameFromAny(poData?.nextActionType ?? poData?.nextAction ?? ""),
    nextActionDate: isoToInputLocal(poData?.nextActionDate || poData?.naDate || null),
  });
}, [actionNameFromAny, open, poData]);

// detect "dirty"
const isDirty = useMemo(() => {
  const seed = {
    supplierStatus: poData?.supplierStatus || "",
    productionRepStatus: poData?.productionRepStatus || "",
    nextActionType: actionNameFromAny(poData?.nextActionType ?? poData?.nextAction ?? ""),
    nextActionDate: isoToInputLocal(poData?.nextActionDate || poData?.naDate || null),
  };
  return (
    poEdit.supplierStatus !== seed.supplierStatus ||
    poEdit.productionRepStatus !== seed.productionRepStatus ||
    poEdit.nextActionType !== seed.nextActionType ||
    poEdit.nextActionDate !== seed.nextActionDate
  );
}, [actionNameFromAny, poEdit, poData]);

// tiny PATCH helper (send only changed fields)
const patchPurchaseOrder = (id, payload) => {
  const headers = { accessToken: localStorage.getItem("accessToken") };
  return axios.patch(
    `${process.env.REACT_APP_NODEJS_SERVER_URL}/purchase-order/${id}`,
    payload,
    { headers }
  );
};

const [savingShipping, setSavingShipping] = useState(false);

const dedupe = (arr) => Array.from(new Set(arr));

// Which proof are we assigning for?
const [assignDlgOpen, setAssignDlgOpen] = useState(false);
const [assignForProof, setAssignForProof] = useState(null);
const [assignDesignerId, setAssignDesignerId] = useState("");
const [assignBusy, setAssignBusy] = useState(false);

// Open the dialog for a specific proof row
const openAssignDialog = useCallback((proof) => {
  setAssignForProof(proof);
  // preselect current assignment if present
  const curId = proof?.designerUserId ? String(proof.designerUserId) : "";
  setAssignDesignerId(curId);
  setAssignDlgOpen(true);
}, []);

// Close/reset
const closeAssignDialog = useCallback(() => {
  setAssignDlgOpen(false);
  setAssignForProof(null);
  setAssignDesignerId("");
}, []);

/*
const legacyHandleSaveShipping = async () => {
  if (!poId) { toast.error("Missing PO id."); return; }

  // seed values from current poData for diff-only patch
  const seedDateIso = poData?.shippedAt ?? poData?.dateShipped ?? null;
  const seedCost =
    (poData?.shippingCostCents != null)
      ? (poData.shippingCostCents / 100)
      : (poData?.shippingCost != null ? Number(poData.shippingCost) : null);

  const seedTnArr = Array.isArray(poData?.trackingNumbers)
    ? poData.trackingNumbers.filter(Boolean)
    : parseTrackingCsv(poData?.trackingNumbers || "");

  // UI → normalized
  const nextDateIso = ymdToIso(shippingState.dateShipped);          // ISO or null
  const nextCostNum = toMoneyNumber(shippingState.shippingCost);    // number or null
  const nextTnArr   = parseTrackingCsv(shippingState.trackingNumbers);

  const payload = {};
  if ((nextDateIso || "") !== (seedDateIso || "")) {
    payload.shippedAt   = nextDateIso;  // primary
    payload.dateShipped = nextDateIso;  // alias
  }
  if (nextCostNum !== seedCost) {
    payload.shippingCost       = (nextCostNum == null ? null : Number(nextCostNum));
    payload.shippingCostCents  = (nextCostNum == null ? null : Math.round(Number(nextCostNum) * 100));
  }
  if (JSON.stringify(nextTnArr) !== JSON.stringify(seedTnArr)) {
    payload.trackingNumbers = nextTnArr;  // keep as array on the wire
  }

  const shouldSavePlacement = !!shippingPlacement.enabled;
  const hasShippingChanges = Object.keys(payload).length > 0;

  if (!hasShippingChanges && !shouldSavePlacement) {
    toast("No shipping changes to save.");
    return;
  }

  if (shouldSavePlacement && !selectedShippingBinOption) {
    toast.error("Pick a warehouse bin before saving.");
    return;
  }
  if (shouldSavePlacement && !canChangeWarehousePlacement) {
    toast.error(shippingPlacementUnavailableMessage || "No received inventory is available for warehouse placement.");
    return;
  }

  try {
    setSavingShipping(true);
    let shippingSaved = false;
    let placementSaved = false;

    // ⚠️ If your backend expects Authorization, use that instead:
    // const headers = { Authorization: `Bearer ${localStorage.getItem("accessToken")}` };
    if (hasShippingChanges) {
      const headers = { accessToken: localStorage.getItem("accessToken") };

    const res = await axios.patch(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/purchase-order/${poId}`,
      payload,
      { headers }
    );

    const updated = res?.data?.purchaseOrder || res?.data?.po || { ...poData, ...payload };

    toast.success("Shipping updated");

    // Mirror server → UI
    const updDateIso  = updated.shippedAt ?? updated.dateShipped ?? nextDateIso ?? null;
    const updCostCent = updated.shippingCostCents ?? (nextCostNum == null ? null : Math.round(nextCostNum * 100));
    const updCost     = (updCostCent != null) ? (updCostCent / 100) :
                        (updated.shippingCost != null ? Number(updated.shippingCost) : nextCostNum);

    const updTnArr = Array.isArray(updated?.trackingNumbers)
      ? updated.trackingNumbers
      : parseTrackingCsv(updated?.trackingNumbers || "");

    setShippingState({
      dateShipped: isoToYmd(updDateIso),
      shippingCost: updCost == null ? "" : updCost.toFixed(2),
      trackingNumbers: trackingToCsv(updTnArr),
    });

    // ✅ IMPORTANT: patch the row with BOTH fields the grid might read
    onPoUpdated?.({
      id: poId,
      shippedAt: updDateIso,
      dateShipped: updDateIso,
      shippingCost: (updCost == null ? null : updCost),            // number
      shippingCostCents: updCostCent,
      trackingNumbers: updTnArr,                                   // keep as array
    });
  } catch (e) {
    console.error(e);
    toast.error(e?.response?.data?.message || "Failed to save shipping");
  } finally {
    setSavingShipping(false);
  }
};



*/

const handleSaveShipping = async () => {
  if (!poId) { toast.error("Missing PO id."); return; }

  const seedDateIso = poData?.shippedAt ?? poData?.dateShipped ?? null;
  const seedCost =
    (poData?.shippingCostCents != null)
      ? (poData.shippingCostCents / 100)
      : (poData?.shippingCost != null ? Number(poData.shippingCost) : null);
  const seedTnArr = Array.isArray(poData?.trackingNumbers)
    ? poData.trackingNumbers.filter(Boolean)
    : parseTrackingCsv(poData?.trackingNumbers || "");

  const nextDateIso = ymdToIso(shippingState.dateShipped);
  const nextCostNum = toMoneyNumber(shippingState.shippingCost);
  if (String(shippingState.shippingCost || "").trim() && nextCostNum == null) {
    toast.error("Enter a valid shipping cost or clear the field.");
    return;
  }
  const nextTnArr = parseTrackingCsv(shippingState.trackingNumbers);

  const payload = {};
  const dateChanged = (nextDateIso || "") !== (seedDateIso || "");
  if (dateChanged) {
    payload.shippedAt = nextDateIso;
    payload.dateShipped = nextDateIso;
  }
  if (nextCostNum !== seedCost) {
    payload.shippingCost = (nextCostNum == null ? null : Number(nextCostNum));
    payload.shippingCostCents = (nextCostNum == null ? null : Math.round(Number(nextCostNum) * 100));
  }
  if (JSON.stringify(nextTnArr) !== JSON.stringify(seedTnArr)) {
    payload.trackingNumbers = nextTnArr;
  }
  if (dateChanged && shouldAutoMarkSupplierPoShipped(poData, nextDateIso)) {
    payload.supplierStatus = "Shipped";
  }

  const shouldSavePlacement = !!shippingPlacement.enabled;
  const hasShippingChanges = Object.keys(payload).length > 0;

  if (!hasShippingChanges && !shouldSavePlacement) {
    toast("No shipping changes to save.");
    return;
  }

  if (shouldSavePlacement && !selectedShippingBinOption) {
    toast.error("Pick a warehouse bin before saving.");
    return;
  }
  if (shouldSavePlacement && !canChangeWarehousePlacement) {
    toast.error(shippingPlacementUnavailableMessage || "No received inventory is available for warehouse placement.");
    return;
  }

  try {
    setSavingShipping(true);
    let shippingSaved = false;
    let placementSaved = false;

    if (hasShippingChanges) {
      const headers = { accessToken: localStorage.getItem("accessToken") };
      const res = await axios.patch(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/purchase-order/${poId}`,
        payload,
        { headers }
      );
      const updated = res?.data?.purchaseOrder || res?.data?.po || { ...poData, ...payload };
      const updDateIso = updated.shippedAt ?? updated.dateShipped ?? nextDateIso ?? null;
      const updCostCent = updated.shippingCostCents ?? (nextCostNum == null ? null : Math.round(nextCostNum * 100));
      const updCost = (updCostCent != null)
        ? (updCostCent / 100)
        : (updated.shippingCost != null ? Number(updated.shippingCost) : nextCostNum);
      const updTnArr = Array.isArray(updated?.trackingNumbers)
        ? updated.trackingNumbers
        : parseTrackingCsv(updated?.trackingNumbers || "");

      setShippingState({
        dateShipped: isoToYmd(updDateIso),
        shippingCost: updCost == null ? "" : updCost.toFixed(2),
        trackingNumbers: trackingToCsv(updTnArr),
      });

      onPoUpdated?.({
        id: poId,
        shippedAt: updDateIso,
        dateShipped: updDateIso,
        shippingCost: (updCost == null ? null : updCost),
        shippingCostCents: updCostCent,
        trackingNumbers: updTnArr,
        supplierStatus: updated.supplierStatus ?? payload.supplierStatus ?? poData?.supplierStatus,
      });
      shippingSaved = true;
    }

    if (shouldSavePlacement) {
      const placementPayload = {
        instanceUniqueId,
        warehouseKey: shippingPlacement.warehouseKey || "main",
        warehouseLevel: shippingPlacement.warehouseLevel || selectedShippingBinOption?.warehouseLevel || "",
        warehouseCell: shippingPlacement.warehouseCell || selectedShippingBinOption?.warehouseCell || "",
        binLabel: shippingPlacement.binLabel || selectedShippingBinOption?.label || "",
        binSubLocation: shippingPlacement.binSubLocation || "",
        binShelfLevel: shippingPlacement.binShelfLevel || "",
      };
      if (String(shippingPlacement.boxRef || "").trim()) {
        placementPayload.boxRef = String(shippingPlacement.boxRef || "").trim();
      }
      if (String(shippingPlacement.containerType || "").trim()) {
        placementPayload.containerType = String(shippingPlacement.containerType || "").trim();
      }
      if (String(shippingPlacement.containerCount || "").trim()) {
        placementPayload.containerCount = Number(shippingPlacement.containerCount);
      }
      if (String(shippingPlacement.notes || "").trim()) {
        placementPayload.notes = String(shippingPlacement.notes || "").trim();
      }

      const placementRes = await updatePoReceiptStoragePlacement(poId, placementPayload);
      setShippingProgressState((prev) => ({
        ...prev,
        loading: false,
        loaded: true,
        error: "",
        receipts: Array.isArray(placementRes?.receipts) ? placementRes.receipts : prev.receipts,
        progressRows: Array.isArray(placementRes?.progressRows) ? placementRes.progressRows : prev.progressRows,
        receiptSourcePoId: Number.isFinite(Number(placementRes?.receiptSourcePoId))
          ? Number(placementRes.receiptSourcePoId)
          : prev.receiptSourcePoId,
        receiptSourcePoNumber: String(placementRes?.receiptSourcePoNumber || prev.receiptSourcePoNumber || ""),
        receiptSourceReason: String(placementRes?.receiptSourceReason || prev.receiptSourceReason || ""),
      }));
      invalidatePurchaseOrderCache(poId);
      publishPurchaseOrderInvalidation(poId);
      placementSaved = true;
    }

    if (shippingSaved && placementSaved) {
      toast.success("Shipping and warehouse placement updated");
    } else if (shippingSaved) {
      toast.success("Shipping updated");
    } else if (placementSaved) {
      toast.success("Warehouse placement updated");
    }
  } catch (e) {
    console.error(e);
    toast.error(e?.response?.data?.message || "Failed to save shipping");
  } finally {
    setSavingShipping(false);
  }
};

useEffect(() => {
  if (!open) return;

  // ---- helpers ----
  const roleIsPurchasingish = (role = "") =>
    /\b(purchasing|production|buyer|procure|ops)\b/i.test(String(role));

    const toOption = (u) => {
      if (!u) return null;
      const id =
        u.id ?? u.userId ?? u.user_id ?? u.value ?? u.personId ?? u.PersonId ?? null;
    
      // accept lots of possible email keys, but allow missing email
      const email =
        u.email ?? u.Email ?? u.workEmail ?? u.userEmail ?? u.primaryEmail ?? null;
    
      const first = u.first_name ?? u.firstName ?? u.FirstName ?? "";
      const last  = u.last_name  ?? u.lastName  ?? u.LastName  ?? "";
      const name  = `${first} ${last}`.trim() || email || (id ? `User #${id}` : "");
      const role  = u.role ?? u.userRole ?? u.Role ?? "";
    
      return id ? { id: String(id), name, email: email || "", role } : null;
    };
    

  const normalizeList = (v) => {
    if (!v) return [];
    if (Array.isArray(v)) return v;
    if (typeof v === "string") {
      return v.split(/[,\s;]+/).map(s => s.trim()).filter(Boolean);
    }
    return [];
  };

  // Try to find a user by id across many pools
  const findUserById = (id, pools) => {
    const sid = String(id);
    for (const pool of pools) {
      if (!Array.isArray(pool)) continue;
      const hit = pool.find(u => {
        const uid = u?.id ?? u?.userId ?? u?.user_id ?? u?.value ?? u?.personId ?? u?.PersonId;
        return uid != null && String(uid) === sid;
      });
      if (hit) return hit;
    }
    return null;
  };

  const deepFlat = (v) => (Array.isArray(v) ? v.flat(Infinity) : []);

  // --- inside the effect that builds fromOptions ---
  const pools = [
    poData?.userDirectory,
    poData?.allUsers,
    authState?.allUsers,
    poData?.people,
    poData?.salesOrder?.people,
    poData?.salesOrder?.assignees,
    poData?.assignedTo,
    poData?.salesOrder?.assignedTo,
  ];
  
  // 🔧 deep-flatten and keep only object-like user entries
  const everyoneRaw = deepFlat(pools).filter(
    (x) => x && typeof x === "object" && !Array.isArray(x)
  );

  // If there’s a production rep id/email on the PO, ensure it’s included
  const prodRepId =
    poData?.productionRepId ??
    poData?.productionRep ??
    poData?.ProductionRepId ??
    null;

  const prodRepEmail =
    poData?.productionRepEmail ??
    poData?.ProductionRepEmail ??
    null;

  const explicitPurchasingRep = (() => {
    // If we have id but not email, try to resolve from pools (and from authState.allUsers)
    if (prodRepId && !prodRepEmail) {
      const resolved =
        findUserById(prodRepId, pools) ||
        findUserById(prodRepId, [authState?.allUsers].filter(Boolean));
      if (resolved) {
        return [{
          id: resolved.id ?? resolved.userId ?? resolved.user_id,
          email: resolved.email ?? resolved.Email,
          first_name:
            resolved.first_name ?? resolved.firstName ?? resolved.FirstName ?? "Purchasing Rep",
          last_name:
            resolved.last_name ?? resolved.lastName ?? resolved.LastName ?? "",
          role: resolved.role ?? resolved.userRole ?? "purchasing-rep",
        }];
      }
    }
    if (prodRepId && prodRepEmail) {
      return [{
        id: prodRepId,
        email: prodRepEmail,
        first_name: poData?.productionRepName || "Purchasing Rep",
        role: "purchasing-rep",
      }];
    }
    if (prodRepEmail) {
      return [{
        id: String(prodRepEmail).trim().toLowerCase(),
        email: prodRepEmail,
        first_name: poData?.productionRepName || "Purchasing Rep",
        role: "purchasing-rep",
      }];
    }
    return [];
  })();

  // Start with everyone we know + explicitPurchasingRep
  const raw = [...everyoneRaw, ...explicitPurchasingRep];

  // AssignedTo can also be string emails; include them
  const assignedStrings = [
    ...normalizeList(poData?.assignedTo),
    ...normalizeList(poData?.salesOrder?.assignedTo),
  ].filter(x => typeof x === "string" && x.includes("@"));

  // id → option
  const byId = new Map();
  for (const u of raw) {
    const opt = toOption(u);
    if (opt) byId.set(opt.id, opt);
  }

  // Add pure-email assignedTo entries (fabricate id as the email)
  for (const em of assignedStrings) {
    const key = em.toLowerCase();
    const exists = [...byId.values()].some(o => (o.email || "").toLowerCase() === key);
    if (!exists) byId.set(key, { id: key, name: em, email: em, role: "" });
  }

  // Also ensure logged-in user exists as a fallback
  if (authState?.id && authState?.email) {
    const sid = String(authState.id);
    if (!byId.has(sid)) {
      byId.set(sid, {
        id: sid,
        name:
          `${authState.first_name || ""} ${authState.last_name || ""}`.trim() ||
          authState.email,
        email: authState.email,
        role: authState.role || "",
      });
    }
  }

  // Sort with purchasing-ish roles on top
  let options = [...byId.values()].sort((a, b) => {
    const ap = roleIsPurchasingish(a.role) ? 0 : 1;
    const bp = roleIsPurchasingish(b.role) ? 0 : 1;
    return ap - bp || (a.name || "").localeCompare(b.name || "");
  });

  // De-dupe by email (final pass)
  const seen = new Set();
  options = options.filter(o => {
    const key = (o.email && o.email.toLowerCase()) || `id:${String(o.id)}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });


  // Pick default:
  const pickDefaultFrom = (opts = []) => {
    const byIdMap = new Map(opts.map(o => [String(o.id), o]));

    // 1) PO production rep id
    if (prodRepId && byIdMap.has(String(prodRepId))) return String(prodRepId);

    // 2) PO production rep email
    if (prodRepEmail) {
      const hit = opts.find(o => (o.email || "").toLowerCase() === String(prodRepEmail).toLowerCase());
      if (hit?.id) return String(hit.id);
    }

    // Do not invent a sender when the PO has no resolvable purchasing rep.
    return "";
  };

  console.log("[PO popup] pools", {
    userDirectory: Array.isArray(poData?.userDirectory) ? poData.userDirectory.length : poData?.userDirectory,
    allUsers: Array.isArray(poData?.allUsers) ? poData.allUsers.length : poData?.allUsers,
    authAllUsers: Array.isArray(authState?.allUsers) ? authState.allUsers.length : authState?.allUsers,
    people: Array.isArray(poData?.people) ? poData.people.length : poData?.people,
    soPeople: Array.isArray(poData?.salesOrder?.people) ? poData.salesOrder.people.length : poData?.salesOrder?.people,
    soAssignees: Array.isArray(poData?.salesOrder?.assignees) ? poData.salesOrder.assignees.length : poData?.salesOrder?.assignees,
    assignedTo: poData?.assignedTo,
  });
  
  console.log("[PO popup] everyoneRaw count", everyoneRaw.length);
  console.log("[PO popup] options before dedupe", options.length);
  

  setFromOptions(options);
  setFromUserId(pickDefaultFrom(options));
}, [
  open,
  // PO fields that may affect rep resolution
  poData?.productionRepId,
  poData?.productionRep,
  poData?.productionRepEmail,
  poData?.productionRepName,
  poData?.assignedTo,
  poData?.userDirectory,
  poData?.allUsers,
  poData?.people,
  poData?.salesOrder?.people,
  poData?.salesOrder?.assignees,
  poData?.salesOrder?.assignedTo,
  // auth/user directory
  authState?.id,
  authState?.email,
  authState?.role,
  authState?.allUsers,
]);






const handleSavePoDetails = async () => {
  if (!poId) { toast.error("Missing PO id."); return; }
  // build diff-only payload
  const payload = {};
  if (poEdit.supplierStatus !== (poData?.supplierStatus || "")) {
    payload.supplierStatus = poEdit.supplierStatus || null;
  }
  if (poEdit.productionRepStatus !== (poData?.productionRepStatus || "")) {
    payload.productionRepStatus = poEdit.productionRepStatus || null;
  }
  const nextActionIso = inputLocalToIso(poEdit.nextActionDate);
  const seedIso = poData?.nextActionDate || poData?.naDate || null;
  if ((nextActionIso || "") !== (seedIso || "")) {
    // your backend uses nextActionDate / naDate interchangeably; send canonical:
    payload.nextActionDate = nextActionIso;
  }
   // Normalize current UI label to id and compare
   const seedActionId = actionIdFromAny(poData?.nextActionType ?? poData?.nextAction ?? "");
   const curActionId  = actionIdFromAny(poEdit.nextActionType);
   const curActionLbl = actionNameFromAny(poEdit.nextActionType);
   if ((curActionId || "") !== (seedActionId || "")) {
    // send BOTH so the dashboard (id) and any viewers (label) stay in sync
     payload.nextAction = curActionId || null;        // e.g. "2"
     payload.nextActionType = curActionLbl || null;   // e.g. "Call Supplier"
   }

  if (!Object.keys(payload).length) { toast("No changes to save."); return; }

  try {
    setSavingPo(true);
    const res = await patchPurchaseOrder(poId, payload);
    const updated =
      res?.data?.purchaseOrder || res?.data?.po || res?.data || { ...poData, ...payload };
    toast.success("Purchase order updated");

    // locally reflect changes
    // (keeps popup in sync even before wiring real-time row refresh)
    //Object.assign(poData, updated);
    // optional: normalize back into edit state (especially if server adjusts dates)
    setPoEdit(s => ({
      ...s,
      supplierStatus: updated.supplierStatus ?? s.supplierStatus,
      productionRepStatus: updated.productionRepStatus ?? s.productionRepStatus,
      nextActionType: actionNameFromAny(updated.nextActionType ?? updated.nextAction ?? s.nextActionType),
      nextActionDate: isoToInputLocal(updated.nextActionDate || updated.naDate) ?? s.nextActionDate,
    }));

    // 🔌 future hook: let parent refresh the row instantly if provided
    onPoUpdated?.(updated);
    // (we’ll wire this in the parent on your next prompt)
  } catch (e) {
    console.error(e);
    toast.error(e?.response?.data?.message || "Update failed");
  } finally {
    setSavingPo(false);
  }
};



  // notes
  const [notesLoading] = useState(false);
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState("");
  const [replyDrafts, setReplyDrafts] = useState({});
  const [replySavingIds, setReplySavingIds] = useState({});
  const [noteAttachment, setNoteAttachment] = useState(null);
  const [replyAttachments, setReplyAttachments] = useState({});
  const [lightboxAttachment, setLightboxAttachment] = useState(null);
  const [activeEmailNote, setActiveEmailNote] = useState(null);
  const [activeReplyNoteId, setActiveReplyNoteId] = useState(null);
  const [expandedNoteThreads, setExpandedNoteThreads] = useState({});
  const replyInputRefs = useRef({});
  const [noteSaving, setNoteSaving] = useState(false);
  const [simpleMode, setSimpleMode] = useState(true); // default to inspiration view
  const [mentionDlgOpen, setMentionDlgOpen] = useState(false);
const [mentionUserIds, setMentionUserIds] = useState([]);

  // filters
  const [showProductionOnly, setShowProductionOnly] = useState(true);
  const [includeProjectNotes, setIncludeProjectNotes] = useState(false);
  const [noteVisibilityAnchorEl, setNoteVisibilityAnchorEl] = useState(null);
  const [showThisPoOnly, setShowThisPoOnly] = useState(false);
  const [infiniteNotesEnabled, setInfiniteNotesEnabled] = useState(false);
  const [notePrefsHydrated, setNotePrefsHydrated] = useState(false);
  const skipNextNotePrefsWriteRef = useRef(false);
  const [userFilterIds, setUserFilterIds] = useState([]);   // multi user ids
  const [searchText, setSearchText] = useState("");
  
  // CSS/UX pagination (client-side)
  const [page, setPage] = useState(1);
  const notesScrollRef = useRef(null);
  
  // mentions picker
  const noteTextareaRef = useRef(null);
  const noteAttachmentInputRef = useRef(null);
  const replyAttachmentInputRefs = useRef({});
  const [mentionOpen, setMentionOpen] = useState(false);
  const [mentionQuery, setMentionQuery] = useState("");
  const [mentionIndex, setMentionIndex] = useState(0);
  const mentionRangeRef = useRef({ from: null, to: null });
  const [replyMentionState, setReplyMentionState] = useState({ noteId: null, open: false, query: "", index: 0, from: null, to: null });
  const activeEmailView = useMemo(
    () => (activeEmailNote ? buildEmailViewerPropsFromNote(activeEmailNote) : null),
    [activeEmailNote]
  );
  
  // Insert @[Name](id) where the @-query was typed
  const insertMention = (user) => {
    const ta = noteTextareaRef.current;
    if (!ta) return;
  
    const { from, to } = mentionRangeRef.current || {};
    if (from == null || to == null) return;
  
    const label = user.name || user.email || `User #${user.id}`;
    const snippet = `@[${label}](${user.id})`;
  
    const before = newNote.slice(0, from);
    const after  = newNote.slice(to);
    const next   = before + snippet + after;
  
    setNewNote(next);
  
    const caret = (before + snippet).length;
    requestAnimationFrame(() => {
      if (!noteTextareaRef.current) return;
      noteTextareaRef.current.focus();
      noteTextareaRef.current.setSelectionRange(caret, caret);
    });
  
    // reset
    setMentionOpen(false);
    setMentionQuery("");
    setMentionIndex(0);
    mentionRangeRef.current = { from: null, to: null };
  };
  
  // Tiny helper to turn @[Name](id) into bold @Name for your list renderer
  const renderMentionsAsHtml = (text) =>
    String(text || "").replace(
      /@\[(?<display>[^\]]+)\]\((?<id>\d+)\)/g,
      (_m, _d, _id, _off, _str, groups) => `<b>@${(groups?.display || "").replace(/[<>&]/g, "")}</b>`
    );

  // proofing
  const [loading, setLoading] = useState(false);
  const [proofs, setProofs] = useState([]);
  const [designers, setDesigners] = useState([]);
  const [designerSelections, setDesignerSelections] = useState({});
  const [decorationNameMap, setDecorationNameMap] = useState({});
  const [poProofStatus, setPoProofStatus] = useState(
    normalizePurchaseOrderProofStatus(poData?.proofStatus)
  );
  const [savingPoProofStatus, setSavingPoProofStatus] = useState(false);

  useEffect(() => {
    if (open) setPoProofStatus(normalizePurchaseOrderProofStatus(poData?.proofStatus));
  }, [open, poData?.id, poData?.proofStatus]);

  // === All Proofs Uploaded confirm flow ===
  //const [confirmAllOpen, setConfirmAllOpen] = useState(false);


   const seedAllUploaded = React.useMemo(() => {
       return getPoAllProofsUploaded(poData);
     }, [poData]);
         
     const [poAllUploaded, setPoAllUploaded] = useState(seedAllUploaded);
     useEffect(() => {
       setPoAllUploaded(seedAllUploaded);
     }, [seedAllUploaded, open]);

  // convenience (single PO in popup)
    const poId = poData?.id;
    // fetchAllProofsList expects SALES ORDER id (the one you call "tabId" elsewhere)
    const soId =
      poData?.estimationId ??        // common in your rows
      poData?.salesOrderId ??        // alternate
      poData?.orderId ?? null;       // last-resort project number (often wrong for proofs)
    const estimationId = poData?.estimationId;
    // use Project Number (orderId) as the scope for this popup
    const orderIdForPopup =
    poData?.orderId != null ? String(poData.orderId) : null;

  const poNumber = poData?.poNumber ?? "—";
  const customer = poData?.customer ?? "Unnamed Project";
  const handlePoProofStatusChange = async (nextStatus) => {
    if (!poId || savingPoProofStatus || nextStatus === poProofStatus) return;
    const previousStatus = poProofStatus;
    setPoProofStatus(nextStatus);
    setSavingPoProofStatus(true);
    try {
      const result = await updatePurchaseOrderDetails(
        poId,
        buildPurchaseOrderProofStatusPatch(nextStatus)
      );
      const savedStatus = normalizePurchaseOrderProofStatus(
        result?.purchaseOrder?.proofStatus
          ?? result?.po?.proofStatus
          ?? result?.proofStatus
          ?? nextStatus
      );
      setPoProofStatus(savedStatus);
      onPoUpdated?.({ id: poId, proofStatus: savedStatus });
      invalidatePurchaseOrderCache(poId);
      publishPurchaseOrderInvalidation(poId);
      toast.success("Proof status updated");
    } catch (error) {
      setPoProofStatus(previousStatus);
      console.error("Failed to update PO proofStatus", error);
      toast.error(error?.response?.data?.message || "Failed to update Proof Status.");
    } finally {
      setSavingPoProofStatus(false);
    }
  };
  const loadPoAllUploadedFlag = React.useCallback(async () => {
    if (!poId || !orderIdForPopup) return null;
    try {
      const data = await lookupPurchaseOrders({
        projectNumber: orderIdForPopup,
        salesOrder: soId,
      });
      const list = Array.isArray(data?.purchaseOrders)
        ? data.purchaseOrders
        : (Array.isArray(data) ? data : []);
      const poRow = list.find((row) => String(row?.id) === String(poId));
      if (!poRow) return null;
      const next = !!poRow?.allProofsUploaded;
      setPoAllUploaded(next);
      return next;
    } catch (err) {
      console.warn("loadPoAllUploadedFlag failed:", err?.message || err);
      return null;
    }
  }, [orderIdForPopup, poId, soId]);

  const API = process.env.REACT_APP_NODEJS_SERVER_URL;
   // actions dropdown state
   const [actionsAnchor, setActionsAnchor] = useState(null);
   const actionsOpen = Boolean(actionsAnchor);
   const handleActionsClick = (e) => setActionsAnchor(e.currentTarget);
   const handleActionsClose = () => setActionsAnchor(null);

    const reflectPendingApproval = () => {
      setPoProofStatus("Pending Approval");
      onPoUpdated?.({ id: poId, proofStatus: "Pending Approval" });
      invalidatePurchaseOrderCache(poId);
      publishPurchaseOrderInvalidation(poId);
    };

    const sendApprovalEmails = async () => {
      if (!poId) {
        toast.error("Missing PO id.");
        return;
      }

      if (!hasAtLeastOneUpload) {
        toast("Upload at least one proof before sending emails.");
        return;
      }

      try {
        toast("Sending approval emails…");
        const payload = {
          triggerApprovalEmails: true,
          recipients: recipientsForApproval.all,
          ccOrderReps: recipientsForApproval.orderReps,
          ccClientReps: recipientsForApproval.clientReps,
        };
        await approveProofList(poId, payload);
        reflectPendingApproval();
        toast.success("Approval emails sent.");
      } catch (e) {
        console.error(e);
        toast.error(e?.response?.data?.message || "Failed to send emails");
      }
    };

  // PO-level gate + bundle link (single-PO)
  const rows = proofs || [];
  const rowsForRender = useMemo(
    () => getVisibleProofRows(rows, poId),
    [rows, poId]
  );
  const uploadedRows = rows.filter(hasUploadedFile);
  
  // Is there at least one uploaded proof?
  const hasAtLeastOneUpload = useMemo(
    () => rowsForRender.some(hasUploadedFile),
    [rowsForRender]
  );
  
  useEffect(() => {
    if (!open) return;
    if (poAllUploaded && !hasAtLeastOneUpload) {
      setPoAllUploaded(false);
    }
  }, [open, poAllUploaded, hasAtLeastOneUpload]);
  
  // Every proof row has a file? (required by backend before emailing)
  const hasAssignedDesigner = useMemo(
    () => (proofs || []).some(p => !!p?.designerUserId),
    [proofs]
  );

  // Every proof row has a file? (required before sending client bundle)
  const hasAllFiles = useMemo(
    () => rowsForRender.length > 0 && rowsForRender.every(hasUploadedFile),
    [rowsForRender]
  );

  const sendProofDesignRequest = async () => {
    if (!poId) { toast.error("Missing PO id."); return; }
    if (!hasAssignedDesigner) {
      toast("Assign a designer to at least one proof first.");
      return;
    }
    try {
      toast("Notifying assigned designer(s)...");
      await approveProofList(poId, { notifyDesigner: true });
      setPoProofStatus("Requested");
      onPoUpdated?.({ id: poId, proofStatus: "Requested" });
      // keep grids/public pages in sync
      invalidatePurchaseOrderCache(poId);
      publishPurchaseOrderInvalidation(poId);
      toast.success("Designer(s) notified.");
    } catch (e) {
      console.error(e);
      toast.error(e?.response?.data?.message || "Failed to notify designers");
    }
  };
  
  const sendArtworkApproval = async () => {
    if (!poId) { toast.error("Missing PO id."); return; }
    /*if (!hasAllFiles) {
      toast("Every proof row must have an uploaded file before sending.");
      return;
    }*/
    try {
      toast("Sending artwork approval…");
      await approveProofList(poId, {
        triggerApprovalEmails: true,
        // optional hints if your backend uses/accepts them:
        recipients: recipientsForApproval.all,
        ccOrderReps: recipientsForApproval.orderReps,
        ccClientReps: recipientsForApproval.clientReps,
      });
      reflectPendingApproval();
      toast.success("Artwork approval email sent.");
    } catch (e) {
      console.error(e);
      toast.error(e?.response?.data?.message || "Failed to send approval");
    }
  };

  // stable callback for deps
  const sendApprovalEmailsCb = useCallback(() => {
    sendApprovalEmails(); // calls the function you added earlier
  }, [sendApprovalEmails]);

   // canonical URLs
   const projectUrl =
     poData?.orderId
       ? `/instance/elite-promo-marketing/sales/orders/${poData.orderId}/overview`
       : null;
  
   const artworkUrl =
     poData?.orderId && poData?.estimationId
       ? `/generated-proofs/order/${poData.orderId}`
       : null;

   const singleProofUrl =
     poData?.orderId && poData?.estimationId
       ? `/generated-proofs/${poId}`
       : null;

   // tab-specific actions (easy to extend per tab later)
    
  
  
  
  const newProofId = () => `${Date.now()}-${Math.random().toString(36).slice(2,8)}`;  

  // decorate location names from multiple possible sources
  const buildDecorationNameMap = (poDataArg, fetchedProofs = []) => {
    const map = {};
   // 1) PO decorations (most reliable for popup)
   (poDataArg?.decorations || []).forEach((d) => {
     if (d?.decorationId != null) {
       const name = d.Location || d.location || d.name || "Location";
       map[String(d.decorationId)] = name;
     }
   });
    // 2) proof summary clientLinks (if they include ids)
    (poDataArg?.proofSummary?.clientLinks || []).forEach((l) => {
      if (l?.decorationId != null && l?.location) {
        map[String(l.decorationId)] = l.location;
      }
    });
    // 3) fetched proofs (various shapes)
    fetchedProofs.forEach((p) => {
      const loc =
        p.location ||
        p.decoration?.location ||
        p.decorationLocation ||
        p.locationName;
      if (loc && p.decorationId != null) {
        map[String(p.decorationId)] = loc;
      }
    });
    return map;
  };

// derive commenters from *all* notes we have in state
const { ids: commenterIds } = useMemo(
  () => extractCommentersFromNotes(notes),
  [notes]
);

// Build a user directory to resolve labels
// Flatten all user pools → unique, valid emails
const allDirectories = React.useMemo(() => ([
  poData?.userDirectory,
  poData?.allUsers,
  authState?.allUsers,
  poData?.people,
  poData?.salesOrder?.people,
  poData?.salesOrder?.assignees,
  poData?.assignedTo,
  poData?.salesOrder?.assignedTo,
]).filter(Boolean), [poData, authState]);

const directoryEmails = React.useMemo(() => {
  const flat = allDirectories.flat(Infinity).filter(x => x && typeof x === "object");
  const emails = flat.map(u =>
    u.email ?? u.Email ?? u.workEmail ?? u.userEmail ?? u.primaryEmail ?? ""
  );
  return validEmailList(emails);            // uses your EMAIL_RX
}, [allDirectories]);

const addEveryoneToRecipients = React.useCallback(() => {
  setRecipients(prev => ({
    ...prev,
    all: dedupeEmails([...(prev.all || []), ...directoryEmails]),
  }));
  toast.success(`Added ${directoryEmails.length} people from the directory`);
}, [directoryEmails]);

useEffect(() => {
  if (!open) return;
  // only seed if `all` is empty so we don't clobber user edits
  setRecipients(prev => prev.all?.length ? prev : ({
    ...prev,
    all: dedupeEmails([...(prev.all || []), ...directoryEmails]),
  }));
}, [open, directoryEmails]);


// Handy map: userId -> email (for when recipients are ids)
const emailById = React.useMemo(() => {
  const map = new Map();
  allDirectories.flat(Infinity).forEach(u => {
    if (!u || typeof u !== "object") return;
    const id =
      u.id ?? u.userId ?? u.user_id ?? u.value ?? u.personId ?? u.PersonId ?? null;
    const em =
      u.email ?? u.Email ?? u.workEmail ?? u.userEmail ?? u.primaryEmail ?? null;
    if (id != null && em) map.set(String(id), String(em));
  });
  return (id) => map.get(String(id)) || "";
}, [allDirectories]);


const commenterOptions = useMemo(
  () => mapUserIdsToOptions(commenterIds, allDirectories),
  [commenterIds, allDirectories]
);
// Build an ALL USERS directory for mentions (no role/seen filters)
const buildEveryoneForMentions = (pools = [], authState) => {
  const toId = (u) =>
    u?.id ?? u?.userId ?? u?.user_id ?? u?.value ?? u?.personId ?? u?.PersonId ?? null;

  const getName = (u) => {
    const f = u?.first_name ?? u?.firstName ?? u?.FirstName ?? "";
    const l = u?.last_name  ?? u?.lastName  ?? u?.LastName  ?? "";
    const n = `${f} ${l}`.trim();
    return n || u?.name || u?.email || (toId(u) ? `User #${toId(u)}` : "");
  };

  const getEmail = (u) =>
    u?.email ?? u?.Email ?? u?.workEmail ?? u?.userEmail ?? u?.primaryEmail ?? "";

  const getAvatar = (u) =>
    normalizeAvatarUrl(u?.profilePicture || u?.avatar || u?.photoUrl || null);

  // flatten pools and keep objects
  const raw = pools.flat(Infinity).filter((x) => x && typeof x === "object" && !Array.isArray(x));

  // include the logged-in user as a safety (in case not present in pools)
  if (authState?.id && authState?.email) {
    raw.push({
      id: authState.id,
      first_name: authState.first_name,
      last_name: authState.last_name,
      email: authState.email,
      profilePicture: authState.profilePicture,
    });
  }

  // de-dupe by id first, then by email
  const byId = new Map();
  for (const u of raw) {
    const id = toId(u);
    if (id == null) continue;
    byId.set(String(id), {
      id: String(id),
      name: getName(u),
      email: String(getEmail(u) || ""),
      avatar: getAvatar(u),
    });
  }

  // extra pass: there can be pure-email “assignees”
  const emailOnly = new Set(
    raw
      .map((u) => (typeof u === "string" ? u : null))
      .filter((e) => e && e.includes("@"))
      .map((e) => e.toLowerCase())
  );
  for (const em of emailOnly) {
    const exists = [...byId.values()].some((o) => (o.email || "").toLowerCase() === em);
    if (!exists) {
      byId.set(em, { id: em, name: em, email: em, avatar: null });
    }
  }

  // final sort by name
  return Array.from(byId.values()).sort((a, b) =>
    (a.name || "").localeCompare(b.name || "", undefined, { sensitivity: "base" })
  );
};

// Everyone = all directories flattened (no filters)
const everyoneForMentions = useMemo(() => {
  // include the same pools you already use elsewhere + obvious places
  const pools = [
    poData?.userDirectory,
    poData?.allUsers,
    authState?.allUsers,
    poData?.people,
    poData?.salesOrder?.people,
    poData?.salesOrder?.assignees,
    poData?.assignedTo,
    poData?.salesOrder?.assignedTo,
  ].filter(Boolean);

  return buildEveryoneForMentions(pools, authState);
}, [poData, authState]);

// --- SIMPLE INLINE SUPPORT FOR usersForMentions ---
// Accepts rows like {id,name,email,avatar|avatarUrl|profilePicture}, but is lenient.
const normalizeMentionUser = (u) => {
  if (!u) return null;
  const id =
    u.id ?? u.userId ?? u.user_id ?? u.value ?? u.personId ?? u.PersonId ?? null;
  if (id == null) return null;

  const first = u.first_name ?? u.firstName ?? u.FirstName ?? "";
  const last  = u.last_name  ?? u.lastName  ?? u.LastName  ?? "";
  const name  = (u.name ?? `${first} ${last}`.trim()) || u.email || `User #${id}`;
  const email = u.email ?? u.Email ?? u.workEmail ?? u.userEmail ?? u.primaryEmail ?? "";
  const avatar = u.avatar ?? u.avatarUrl ?? u.profilePicture ?? u.photoUrl ?? null;

  return {
    id: String(id),
    name,
    email: String(email || ""),
    avatar: (typeof normalizeAvatarUrl === "function" ? normalizeAvatarUrl(avatar) : avatar) || null,
  };
};

// If a usersForMentions array is provided, prefer it. Otherwise fall back to your existing pools.
const mentionSource = React.useMemo(() => {
  if (Array.isArray(usersForMentions) && usersForMentions.length) {
    // Use exactly what parent gave us
    const seen = new Set();
    return usersForMentions
      .map(normalizeMentionUser)
      .filter(Boolean)
      .filter((u) => {
        const k = (u.email || u.id).toLowerCase();
        if (seen.has(k)) return false;
        seen.add(k);
        return true;
      });
  }

  // Fallback = your previous “everyoneForMentions” build (unchanged)
  const pools = [
    poData?.userDirectory,
    poData?.allUsers,
    authState?.allUsers,
    poData?.people,
    poData?.salesOrder?.people,
    poData?.salesOrder?.assignees,
    poData?.assignedTo,
    poData?.salesOrder?.assignedTo,
  ].filter(Boolean);

  const everyone = buildEveryoneForMentions(pools, authState);
  return everyone.map(normalizeMentionUser).filter(Boolean);
}, [usersForMentions, poData, authState]);


// Mention dialog should prefer commenters; if none, fall back to fromOptions
// Prefer commenters at the top, but include EVERYONE
const mentionOptions = React.useMemo(() => {
  return [...mentionSource].sort((a,b) =>
    (a?.name || "").localeCompare(b?.name || "", undefined, { sensitivity: "base" })
  );
}, [mentionSource]);

// Search box uses mentionOptions
const filteredUsers = React.useMemo(() => {
  const q = (mentionQuery || "").trim().toLowerCase();
  if (!q) return mentionOptions;
  return mentionOptions.filter(u =>
    (u.name || "").toLowerCase().includes(q) ||
    (u.email || "").toLowerCase().includes(q)
  );
}, [mentionOptions, mentionQuery]);

  // Source of users for the dropdown — prefer the “commenters-first” list you already build
  const mentionList = useMemo(() => {
    // you already have `mentionOptions` (commenters-first fallback to fromOptions)
    // it contains [{id, name, email, avatar?}]
    return (mentionOptions || []).map(o => ({
      id: String(o.id),
      name: o.name || o.email || `User #${o.id}`,
      email: o.email || "",
      avatar: o.avatarUrl || o.avatar || null,
    }));
  }, [mentionOptions]);
  
  

  const clearNoteAttachment = useCallback(() => {
    setNoteAttachment(null);
    if (noteAttachmentInputRef.current) noteAttachmentInputRef.current.value = "";
  }, []);

  const handleNoteAttachmentChange = useCallback((event) => {
    const file = event.target.files?.[0] || null;
    if (!file) {
      setNoteAttachment(null);
      return;
    }
    const validationError = validateProductionNoteAttachment(file);
    if (validationError) {
      toast.error(validationError);
      clearNoteAttachment();
      return;
    }
    setNoteAttachment(file);
  }, [clearNoteAttachment]);

  const clearReplyAttachment = useCallback((noteId) => {
    setReplyAttachments((prev) => ({ ...prev, [noteId]: null }));
    if (replyAttachmentInputRefs.current?.[noteId]) replyAttachmentInputRefs.current[noteId].value = "";
  }, []);

  const handleReplyAttachmentChange = useCallback((noteId, event) => {
    const file = event.target.files?.[0] || null;
    if (!file) {
      setReplyAttachments((prev) => ({ ...prev, [noteId]: null }));
      return;
    }
    const validationError = validateProductionNoteAttachment(file);
    if (validationError) {
      toast.error(validationError);
      clearReplyAttachment(noteId);
      return;
    }
    setReplyAttachments((prev) => ({ ...prev, [noteId]: file }));
  }, [clearReplyAttachment]);

  const insertReplyMention = useCallback((noteId, user) => {
    const current = String(replyDrafts[noteId] || "");
    const { from, to } = replyMentionState || {};
    if (from == null || to == null) return;
    const label = user.name || user.email || `User #${user.id}`;
    const snippet = `@[${label}](${user.id})`;
    const next = current.slice(0, from) + snippet + current.slice(to);
    setReplyDrafts((prev) => ({ ...prev, [noteId]: next }));
    requestAnimationFrame(() => {
      const el = replyInputRefs.current?.[noteId];
      if (!el) return;
      const caret = (current.slice(0, from) + snippet).length;
      el.focus();
      el.setSelectionRange(caret, caret);
    });
    setReplyMentionState({ noteId: null, open: false, query: "", index: 0, from: null, to: null });
  }, [replyDrafts, replyMentionState]);

  const filteredReplyUsers = useMemo(() => {
    const q = String(replyMentionState.query || "").trim().toLowerCase();
    if (!q) return mentionOptions;
    return mentionOptions.filter((u) =>
      (u.name || "").toLowerCase().includes(q) ||
      (u.email || "").toLowerCase().includes(q)
    );
  }, [mentionOptions, replyMentionState.query]);

  const noteVisibilityPrefsKey = useMemo(() => {
    const userKey = authState?.id || authState?.email || "anonymous";
    return `purchasingPopupNotePrefs:${instanceUniqueId || "unknown-instance"}:${userKey}`;
  }, [authState?.email, authState?.id, instanceUniqueId]);

  useEffect(() => {
    setNotePrefsHydrated(false);
    if (typeof window === "undefined" || !noteVisibilityPrefsKey) {
      setNotePrefsHydrated(true);
      return;
    }

    let nextShowProductionOnly = true;
    let nextIncludeProjectNotes = false;
    let nextShowThisPoOnly = false;
    let nextInfiniteNotesEnabled = true;

    try {
      const parsed = JSON.parse(window.localStorage.getItem(noteVisibilityPrefsKey) || "null");
      if (parsed && typeof parsed === "object") {
        if (typeof parsed.showProductionOnly === "boolean") {
          nextShowProductionOnly = parsed.showProductionOnly;
        }
        if (typeof parsed.includeProjectNotes === "boolean") {
          nextIncludeProjectNotes = parsed.includeProjectNotes;
        }
        if (typeof parsed.showThisPoOnly === "boolean") {
          nextShowThisPoOnly = parsed.showThisPoOnly;
        }
        if (typeof parsed.infiniteNotesEnabled === "boolean") {
          nextInfiniteNotesEnabled = parsed.infiniteNotesEnabled;
        }
        if (typeof parsed.showThisPoOnly !== "boolean" && parsed.noteActivityScope === "this-po-only") {
          nextShowThisPoOnly = true;
        } else if (parsed.noteActivityScope === "all-project-activity") {
          nextShowThisPoOnly = false;
        }
      }
    } catch (_err) {
      // Ignore corrupt note visibility preferences and keep defaults.
    } finally {
      skipNextNotePrefsWriteRef.current = true;
      setShowProductionOnly(nextShowProductionOnly);
      setIncludeProjectNotes(nextIncludeProjectNotes);
      setShowThisPoOnly(nextShowThisPoOnly);
      setInfiniteNotesEnabled(nextInfiniteNotesEnabled);
      setPage(1);
      setNotePrefsHydrated(true);
    }
  }, [noteVisibilityPrefsKey]);

  useEffect(() => {
    if (!notePrefsHydrated || typeof window === "undefined" || !noteVisibilityPrefsKey) return;
    if (skipNextNotePrefsWriteRef.current) {
      skipNextNotePrefsWriteRef.current = false;
      return;
    }
    try {
      window.localStorage.setItem(
        noteVisibilityPrefsKey,
        JSON.stringify({ showProductionOnly, includeProjectNotes, showThisPoOnly, infiniteNotesEnabled })
      );
    } catch (_err) {
      // Ignore localStorage write failures.
    }
  }, [includeProjectNotes, infiniteNotesEnabled, notePrefsHydrated, noteVisibilityPrefsKey, showProductionOnly, showThisPoOnly]);

  useEffect(() => {
    if (!showProductionOnly && showThisPoOnly) {
      setShowThisPoOnly(false);
      setPage(1);
    }
  }, [showProductionOnly, showThisPoOnly]);

  const normalizeNoteScopeValue = useCallback((value) => (
    value == null ? "" : String(value).trim()
  ), []);

  const getCurrentPoNumberCandidates = useCallback(() => [
    poData?.poNumber,
    poData?.purchaseOrderNumber,
    poNumber,
  ].filter(Boolean).map((value) => String(value).trim().toLowerCase()), [poData?.poNumber, poData?.purchaseOrderNumber, poNumber]);

  const isNoteForCurrentPo = useCallback((note = {}) => {
    const currentPoId = normalizeNoteScopeValue(poId);
    const notePoIds = [
      note?.poId,
      note?.purchaseOrderId,
      note?.purchase_order_id,
      note?.POId,
      note?.po_id,
      ...(Array.isArray(note?.poIds) ? note.poIds : []),
      ...(Array.isArray(note?.purchaseOrderIds) ? note.purchaseOrderIds : []),
    ].map(normalizeNoteScopeValue).filter(Boolean);

    if (currentPoId && notePoIds.includes(currentPoId)) return true;

    const currentPoNumbers = getCurrentPoNumberCandidates();
    const notePoNumbers = [
      note?.poNumber,
      note?.purchaseOrderNumber,
      note?.purchase_order_number,
      note?.po_number,
      ...(Array.isArray(note?.poNumbers) ? note.poNumbers : []),
      ...(Array.isArray(note?.purchaseOrderNumbers) ? note.purchaseOrderNumbers : []),
    ].map((value) => String(value || "").trim().toLowerCase()).filter(Boolean);

    return currentPoNumbers.length > 0 &&
      notePoNumbers.some((value) => currentPoNumbers.includes(value));
  }, [getCurrentPoNumberCandidates, normalizeNoteScopeValue, poId]);

  const isNoteForCurrentProject = useCallback((note = {}) => {
    const currentOrder = orderIdForPopup ? String(orderIdForPopup) : "";
    if (!currentOrder) return false;
    return String(note?.orderId ?? note?.OrderId ?? note?.order_id ?? "") === currentOrder;
  }, [orderIdForPopup]);

  const effectiveIncludeProjectNotes = !showProductionOnly || includeProjectNotes;
  const effectiveShowThisPoOnly = showProductionOnly && showThisPoOnly;

  const shouldKeepNoteByScope = useCallback((note) => {
    const forPo = isNoteForCurrentPo(note);
    const forProject = isNoteForCurrentProject(note);
    const isWrittenProject = isWrittenProjectNoteForPurchasingPopup(note);
    const isInboundProjectEmail = isInboundProjectEmailNote(note);

    // Project-email notes are project-scoped communication and must remain visible
    // even when Production only / This PO only narrows the purchasing activity feed.
    if (isInboundProjectEmail && forProject) {
      return true;
    }

    if (!showProductionOnly) {
      return forProject || forPo;
    }

    if (includeProjectNotes && isWrittenProject && forProject) {
      return true;
    }

    if (effectiveShowThisPoOnly) {
      return forPo;
    }

    return forProject || forPo;
  }, [effectiveShowThisPoOnly, includeProjectNotes, isNoteForCurrentPo, isNoteForCurrentProject, showProductionOnly]);

  const shouldKeepNoteByVisibility = useCallback((note) => {
    if (!showProductionOnly) return true;
    if (isInboundProjectEmailNote(note)) return true;
    return isProductionBucketNote(note) ||
      (includeProjectNotes && isWrittenProjectNoteForPurchasingPopup(note));
  }, [includeProjectNotes, showProductionOnly]);

  const scopedNotes = useMemo(() => {
    return (notes || []).filter((note) => (
      shouldKeepNoteByScope(note) && shouldKeepNoteByVisibility(note)
    ));
  }, [notes, shouldKeepNoteByScope, shouldKeepNoteByVisibility]);

// 1) sort pinned/newest, 2) optional filter by users, 3) text search
const filteredSortedNotes = useMemo(() => {
  const q = searchText.trim().toLowerCase();
  const userSet = new Set((userFilterIds || []).map(String));

  let arr = [...scopedNotes];

  // pinned first, then newest first. Visibility/scope filtering already happened in scopedNotes.
  arr.sort((a,b) => {
    const apin = Boolean(a?.pinned || a?.pinnedPurchasing) ? 1 : 0;
    const bpin = Boolean(b?.pinned || b?.pinnedPurchasing) ? 1 : 0;
    if (bpin !== apin) return bpin - apin;

    const atime = new Date(a.createdAt || 0).getTime() || 0;
    const btime = new Date(b.createdAt || 0).getTime() || 0;
    return btime - atime;
  });

  if (userSet.size) {
    arr = arr.filter(n => n.userId != null && userSet.has(String(n.userId)));
  }

  if (q) {
    arr = arr.filter(n =>
      (n.message || "").toLowerCase().includes(q) ||
      (n.userName || "").toLowerCase().includes(q)
    );
  }

  return arr;
}, [scopedNotes, userFilterIds, searchText]);

// simple CSS/UX pagination (20 at a time)
const pageSize = 20;
const filteredThreadSourceNotes = useMemo(() => {
  const q = searchText.trim().toLowerCase();
  const userSet = new Set((userFilterIds || []).map(String));
  let arr = [...scopedNotes];
  if (userSet.size) {
    arr = arr.filter((n) => n.userId != null && userSet.has(String(n.userId)));
  }
  if (q) {
    arr = arr.filter((n) =>
      (n.message || "").toLowerCase().includes(q) ||
      (n.userName || "").toLowerCase().includes(q)
    );
  }
  return arr;
}, [scopedNotes, userFilterIds, searchText]);

const rootCandidates = useMemo(
  () => filteredSortedNotes.filter((n) => !parentKeyOf(n)),
  [filteredSortedNotes]
);
const pagedRootNotes = useMemo(
  () => rootCandidates.slice(0, page * pageSize),
  [rootCandidates, page]
);
const hasMoreNotes = pagedRootNotes.length < rootCandidates.length;
const noteIdOf = (n) => noteKeyOf(n);
const noteSequenceOf = (n) => {
  const seq = Number(n?.sequence);
  return Number.isFinite(seq) && seq > 0 ? seq : null;
};
const popupCustomerId = poData?.salesOrder?.customerId || poData?.customerId || null;
const threadedNotes = useMemo(() => {
  const allNodes = (filteredThreadSourceNotes || []).map((n) => ({
    ...n,
    __id: noteIdOf(n),
    __parentId: parentKeyOf(n),
  }));
  const nodeById = new Map(allNodes.map((n) => [n.__id, n]));
  const byParent = new Map();
  allNodes.forEach((n) => {
    const parentKey = n.__parentId || "__root__";
    if (!byParent.has(parentKey)) byParent.set(parentKey, []);
    byParent.get(parentKey).push(n);
  });
  const buildDescendants = (parentId, seen = new Set()) => {
    if (seen.has(parentId)) return [];
    const nextSeen = new Set(seen);
    nextSeen.add(parentId);
    return (byParent.get(parentId) || []).map((child) => ({
      ...child,
      children: buildDescendants(child.__id, nextSeen),
    }));
  };
  return (pagedRootNotes || []).map((root) => {
    const rootId = noteIdOf(root);
    const fullRoot = nodeById.get(rootId) || { ...root, __id: rootId, __parentId: "" };
    return {
      ...fullRoot,
      children: buildDescendants(fullRoot.__id),
    };
  });
}, [filteredThreadSourceNotes, pagedRootNotes]);

const hydrateProductionNotes = useCallback(async () => {
  if (!orderIdForPopup) return null;
  try {
    const fetched = await fetchProductionNotes(orderIdForPopup);
    const normalized = (fetched || []).map((n, i) => normalizeNote(n, i, allDirectories));
    setNotes((prev) => upsertNotes(prev, normalized, allDirectories));
    return normalized;
  } catch (error) {
    console.warn("Could not refresh production notes", error);
    return null;
  }
}, [allDirectories, orderIdForPopup]);

const resolveCanonicalPurchasingNote = useCallback(async (note) => {
  if (noteSequenceOf(note)) return normalizeNote(note, 0, allDirectories);
  const refreshed = await hydrateProductionNotes();
  const match = (refreshed || []).find((candidate) =>
    productionNoteIdentityMatches(candidate, note, { optimisticId: note?.id }) ||
    (candidate?.message === note?.message && String(candidate?.orderId || "") === String(note?.orderId || ""))
  );
  return match || null;
}, [allDirectories, hydrateProductionNotes]);

const isManualNote = (n) => {
  const action = String(n?.action || "").toLowerCase();
  const explicit = String(n?.noteType || "").toLowerCase();
  if (explicit === "manual") return true;
  return action === "purchasing-note" || action === "written-project-note";
};

const togglePurchasingPin = async (note) => {
  const noteId = noteIdOf(note);
  const sequence = noteSequenceOf(note);
  const noteCustomerId = Number(note?.customerId) || Number(popupCustomerId) || null;
  if (!noteId || !orderIdForPopup) return;
  const nextPinned = !Boolean(note?.pinned || note?.pinnedPurchasing);
  setNotes((prev) =>
    prev.map((n) => (noteIdOf(n) === noteId ? { ...n, pinned: nextPinned, pinnedPurchasing: nextPinned } : n))
  );
  try {
    if (noteCustomerId && sequence) {
      await axios.patch(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/${noteCustomerId}/notes/${sequence}/pin`,
        { pinned: nextPinned },
        { headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` } }
      );
    } else {
      throw new Error("Missing customer note sequence for pin.");
    }
  } catch (error) {
    setNotes((prev) =>
      prev.map((n) => (noteIdOf(n) === noteId ? { ...n, pinned: !nextPinned, pinnedPurchasing: !nextPinned } : n))
    );
    toast.error("Could not update pin.");
  }
};

const handleDeletePurchasingNote = async (note) => {
  const noteId = noteIdOf(note);
  const sequence = noteSequenceOf(note);
  const noteCustomerId = Number(note?.customerId) || Number(popupCustomerId) || null;
  if (!noteId || !orderIdForPopup) return;
  const ok = window.confirm("Delete this comment?");
  if (!ok) return;
  try {
    if (noteCustomerId && sequence) {
      await axios.delete(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/${noteCustomerId}/notes/${sequence}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` } }
      );
    } else {
      throw new Error("Missing customer note sequence for delete.");
    }
    setNotes((prev) => prev.map((n) => (noteIdOf(n) === noteId ? { ...n, message: "Comment deleted", deletedAt: new Date().toISOString() } : n)));
  } catch (error) {
    toast.error(error?.response?.data?.message || "Could not delete comment.");
  }
};

const handleReplyToPurchasingNote = async (note) => {
  const originalNoteId = noteIdOf(note);
  const refDraft = replyInputRefs.current?.[originalNoteId]?.value;
  const draft = String((refDraft ?? replyDrafts[originalNoteId]) || "").trim();
  if (!originalNoteId || !orderIdForPopup || !draft) return;

  let optimisticReplyId = null;
  try {
    let parentNote = note;
    let sequence = noteSequenceOf(parentNote);
    let noteCustomerId = Number(parentNote?.customerId) || Number(popupCustomerId) || null;

    if (!noteCustomerId || !sequence) {
      parentNote = await resolveCanonicalPurchasingNote(parentNote);
      sequence = noteSequenceOf(parentNote);
      noteCustomerId = Number(parentNote?.customerId) || Number(popupCustomerId) || null;
    }

    if (!noteCustomerId || !sequence) {
      toast.error("Refreshing production note before replying. Please try again in a moment.");
      return;
    }

    setReplySavingIds((prev) => ({ ...prev, [originalNoteId]: true }));

    const parentNotePreview = String(parentNote?.message || "")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<[^>]+>/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 280);
    const messageHtml = renderMentionsAsHtml ? renderMentionsAsHtml(draft) : draft;
    const mentions = extractMentionIds(draft);
    const replyTo = {
      sequence,
      id: parentNote?.id || parentNote?.sequence,
      authorName: parentNote?.userName || "",
      messagePreview: parentNotePreview,
      createdAt: parentNote?.createdAt || parentNote?.timestamp || null,
    };
    const basePayload = {
      orderId: orderIdForPopup,
      message: draft,
      messageText: draft,
      messageHtml,
      mentions,
      parentNoteSequence: sequence,
      parentNoteId: parentNote?.id || parentNote?.sequence,
      parentNotePreview,
      parentNoteAuthor: parentNote?.userName || "",
      isReply: true,
      replyTo,
      action: "purchasing-note",
      noteBucket: parentNote?.noteBucket || "production",
      source: parentNote?.source || "purchasing",
      scope: parentNote?.scope || "purchasing",
      poId: parentNote?.poId || poId,
      purchaseOrderId: parentNote?.purchaseOrderId || parentNote?.poId || poId,
      poNumber: parentNote?.poNumber || poData?.poNumber || poNumber,
      purchaseOrderNumber: parentNote?.purchaseOrderNumber || parentNote?.poNumber || poData?.purchaseOrderNumber || poData?.poNumber || poNumber,
    };
    const attachment = replyAttachments[originalNoteId] || null;
    const payload = attachment
      ? (() => {
          const form = new FormData();
          Object.entries(basePayload).forEach(([key, value]) => {
            if (value == null) return;
            form.append(key, typeof value === "object" ? JSON.stringify(value) : String(value));
          });
          form.append("file", attachment);
          return form;
        })()
      : basePayload;

    optimisticReplyId = `tmp-reply-${Date.now()}`;
    const optimisticReply = normalizeNote({
      id: optimisticReplyId,
      parentSequence: sequence,
      parentNoteSequence: sequence,
      parentId: parentNote?.id || null,
      message: messageHtml,
      messageText: draft,
      messageHtml,
      mentions,
      createdAt: new Date().toISOString(),
      userName:
        [authState?.first_name, authState?.last_name].filter(Boolean).join(" ") ||
        authState?.name ||
        "User",
      userId: authState?.id ?? null,
      customerId: noteCustomerId,
      orderId: orderIdForPopup,
      poId: basePayload.poId,
      purchaseOrderId: basePayload.purchaseOrderId,
      poNumber: basePayload.poNumber,
      purchaseOrderNumber: basePayload.purchaseOrderNumber,
      action: "written-project-note",
      noteType: "manual",
      noteBucket: basePayload.noteBucket,
      scope: basePayload.scope,
      source: basePayload.source,
      isReply: true,
      _origin: "reply-optimistic",
    }, 0, allDirectories);
    setNotes((prev) => upsertNotes(prev, optimisticReply, allDirectories));
    setExpandedNoteThreads((prev) => ({
      ...prev,
      [noteIdOf(parentNote)]: true,
    }));

    const response = await axios.post(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/${noteCustomerId}/notes/${sequence}/reply`,
      payload,
      { headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` } }
    );
    const res = response.data;
    const reply = res?.note;
    if (reply?.sequence) {
      const normalizedReply = normalizeNote({
        ...reply,
        parentSequence: reply.parentSequence || sequence,
        parentNoteSequence: reply.parentNoteSequence || sequence,
        customerId: reply.customerId || noteCustomerId,
        orderId: reply.orderId || orderIdForPopup,
        poId: reply.poId || parentNote?.poId || poId,
        purchaseOrderId: reply.purchaseOrderId || parentNote?.purchaseOrderId || parentNote?.poId || poId,
        poNumber: reply.poNumber || parentNote?.poNumber || poData?.poNumber || poNumber,
        purchaseOrderNumber: reply.purchaseOrderNumber || parentNote?.purchaseOrderNumber || parentNote?.poNumber || poData?.purchaseOrderNumber || poData?.poNumber || poNumber,
        noteBucket: reply.noteBucket || parentNote?.noteBucket || "production",
        scope: reply.scope || parentNote?.scope || "purchasing",
        source: reply.source || parentNote?.source || "purchasing",
      }, 0, allDirectories);
      setNotes((prev) =>
        upsertNotes(prev, normalizedReply, allDirectories, {
          optimisticId: optimisticReplyId,
        }),
      );
      setExpandedNoteThreads((prev) => ({ ...prev, [noteIdOf(parentNote)]: true }));
    } else {
      await hydrateProductionNotes();
      setNotes((prev) => prev.filter((item) => item?.id !== optimisticReplyId));
    }
    setReplyDrafts((prev) => ({ ...prev, [originalNoteId]: "" }));
    if (replyInputRefs.current?.[originalNoteId]) replyInputRefs.current[originalNoteId].value = "";
    clearReplyAttachment(originalNoteId);
    setActiveReplyNoteId(null);
    setReplyMentionState({ noteId: null, open: false, query: "", index: 0, from: null, to: null });
    toast.success("Reply posted");
  } catch (error) {
    if (optimisticReplyId) {
      setNotes((prev) => prev.filter((item) => item?.id !== optimisticReplyId));
    }
    toast.error(error?.response?.data?.message || "Could not reply.");
  } finally {
    setReplySavingIds((prev) => ({ ...prev, [originalNoteId]: false }));
  }
};

const toggleNoteThread = (noteId) => {
  setExpandedNoteThreads((prev) => ({ ...prev, [noteId]: !prev[noteId] }));
};









  
  // ---- local fn so we can reference state above ----

  // --- Chat note poster (fires chat-style socket + emails) ---
async function postProductionNote({ orderId, messageText, attachment = null }) {
  if (!orderId || !messageText?.trim()) return null;

  // Use your existing HTML renderer for mentions so the list shows bold @Name
  const messageHtml = (typeof renderMentionsAsHtml === "function")
    ? renderMentionsAsHtml(messageText)
    : String(messageText).replace(
        /@\[(?<display>[^\]]+)\]\((?<id>\d+)\)/g,
        (_m, _d, _id, _off, _str, g) => `<b>@${g?.display || "user"}</b>`
      );
  const mentions = extractMentionIds(messageText);
  const basePayload = {
    orderId,
    messageText: messageText.trim(),
    messageHtml,
    mentions,
    action: "purchasing-note",
    noteBucket: "production",
    source: "purchasing",
    scope: "purchasing",
    poId,
    purchaseOrderId: poId,
    poNumber: poData?.poNumber || poNumber,
    purchaseOrderNumber: poData?.poNumber || poData?.purchaseOrderNumber || poNumber,
  };

  try {
    const payload = attachment
      ? (() => {
          const form = new FormData();
          Object.entries(basePayload).forEach(([key, value]) => {
            if (value == null) return;
            form.append(key, Array.isArray(value) ? JSON.stringify(value) : String(value));
          });
          form.append("file", attachment);
          return form;
        })()
      : basePayload;
    const response = await axios.post(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/chat/order-note`,
      payload,
      { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
    );
    toast.success("Production note posted");
    return response?.data?.note || null;
  } catch (e) {
    console.error(e);
    toast.error(e?.response?.data?.error || e?.response?.data?.message || "Failed to post production note");
    throw e;
  }
}

// ---- local fn so we can reference state above ----
async function addNote() {
  const msg = (newNote || "").trim();
  if (!msg) return toast("Write something first.");

  // Chat endpoint needs the PROJECT number (orderId), not the PO id
  const ordId =
    (orderIdForPopup && String(orderIdForPopup)) ||
    (poData?.orderId && String(poData.orderId)) ||
    (poData?.OrderId && String(poData.OrderId)) ||
    null;

  if (!ordId) return toast.error("Missing Project # (orderId).");

  setNoteSaving(true);
  const optimisticId = `tmp-${Date.now()}`;
  const optimistic = normalizeNote({
    id: optimisticId,
    message: renderMentionsAsHtml ? renderMentionsAsHtml(msg) : msg,
    messageText: msg,
    messageHtml: renderMentionsAsHtml ? renderMentionsAsHtml(msg) : msg,
    mentions: extractMentionIds(msg),
    createdAt: new Date().toISOString(),
    userName: [authState?.first_name, authState?.last_name].filter(Boolean).join(" ") || authState?.name || "User",
    userId: authState?.id ?? null,
    userAvatar: normalizeAvatarUrl(authState?.profilePicture || authState?.avatar || authState?.avatarUrl || authState?.user?.profilePicture || authState?.user?.avatar || authState?.user?.avatarUrl || null),
    userAvatarUrl: normalizeAvatarUrl(authState?.profilePicture || authState?.avatar || authState?.avatarUrl || authState?.user?.profilePicture || authState?.user?.avatar || authState?.user?.avatarUrl || null),
    avatar: normalizeAvatarUrl(authState?.avatar || authState?.avatarUrl || null),
    avatarUrl: normalizeAvatarUrl(authState?.avatarUrl || authState?.profilePicture || authState?.avatar || null),
    profilePicture: normalizeAvatarUrl(authState?.profilePicture || authState?.user?.profilePicture || null),
    poId,
    orderId: ordId,
    customerId: popupCustomerId,
    action: "purchasing-note",
    noteBucket: "production",
    source: "purchasing",
    scope: "purchasing",
    purchaseOrderId: poId,
    poNumber: poData?.poNumber || poNumber,
    purchaseOrderNumber: poData?.poNumber || poData?.purchaseOrderNumber || poNumber,
    attachments: [],
    _origin: "chat-optimistic",
  }, 0, allDirectories);
  setNotes((prev) => upsertNotes(prev, optimistic, allDirectories));
  setNewNote("");

  try {
    const created = await postProductionNote({ orderId: ordId, messageText: msg, attachment: noteAttachment });
    if (created?.sequence) {
      const normalizedCreated = normalizeNote({ ...optimistic, ...created }, 0, allDirectories);
      setNotes((prev) => upsertNotes(prev, normalizedCreated, allDirectories, { optimisticId }));
      clearNoteAttachment();
    } else {
      await hydrateProductionNotes();
      clearNoteAttachment();
    }
  } catch (error) {
    setNotes((prev) => prev.filter((n) => n.id !== optimisticId));
  } finally {
    setNoteSaving(false);
  }
}



  const mergeApprovalsAndStatus = (proof, incomingApprovals) => {
    const next = {
      user:   { state: "pending", by: null, at: null, ...(proof.approvals?.user || {}) },
      client: { state: "pending", by: null, at: null, ...(proof.approvals?.client || {}) },
      ...incomingApprovals,
    };
    const u = next.user.state;
    const c = next.client.state;
    let status = proof.status;
    if (u === "rejected" || c === "rejected") status = "Rejected";
    else if (u === "approved" && c === "approved") status = "Approved";
    return { approvals: next, status };
  };

  // bundle url (same pattern as list)
  const getBundleUrl = () => {
    const base =
      process.env.REACT_APP_FRONTEND_URL ||
      process.env.REACT_APP_PUBLIC_URL ||
      window.location.origin;
    return `${base}/generated-proofs/order/${soId}`;
  };
  const getClientProofUrl = (poIdArg) => {
    const base =
      process.env.REACT_APP_FRONTEND_URL ||
      process.env.REACT_APP_PUBLIC_URL ||
      window.location.origin;
    return `${base}/generated-proofs/${poIdArg}`;
  };

  // load designers when popup opens
   useEffect(() => {
       if (!open) return;
       let alive = true;
       (async () => {
         try {
           const res = await fetchAllDesignReps();
           if (alive) setDesigners((res?.designers || []).map(u => ({ id: u.id, name: u.name || u.email })));
         } catch {}
       })();
       return () => { alive = false; };
     }, [open]);

  // load proofs for THIS PO when popup opens
  const refreshProofs = React.useCallback(async () => {
    if (!open || !soId) return;

    setLoading(true);
    try {
      const res = await fetchAllProofsList(soId);

      // Normalize one record from various key shapes
      const normalizeRecord = (raw) =>
        normalizeProof({
          ...raw,
          poId:
            raw.poId ??
            raw.purchaseOrderId ??
            raw.purchase_order_id ??
            raw.POId ??
            raw.po_id ??
            null,
          decorationId:
            raw.decorationId ??
            raw.decoration_id ??
            raw.locationId ??
            raw.location_id ??
            null,
          // file paths show up under many keys across your endpoints
          filePath: raw.filePath || raw.proofFilePath || raw.url || raw.link || null,
          fileName: raw.fileName || raw.filename || null,
          salesOrderId: raw.salesOrderId ?? raw.estimationId ?? raw.tabId ?? null,
          orderId:
            raw.orderId ??
            raw.OrderId ??
            raw.order_id ??
            raw.projectId ??
            null,
        });

      const all = Array.isArray(res?.proofs) ? res.proofs.map(normalizeRecord) : [];

      const poScoped = resolveProofsForPurchaseOrder(all, {
        ...poData,
        id: poId,
        poId,
      });

      const nameMap = buildDecorationNameMap(poData, poScoped);
      setDecorationNameMap(nameMap);
      setProofs(poScoped);
      onProofsChange?.(poId, poScoped, { source: "refresh" });
      await loadPoAllUploadedFlag();
    } catch (e) {
      console.error(e);
      toast.error(e?.response?.data?.message || "Could not load proofs.");
    } finally {
      setLoading(false);
    }
  }, [open, soId, poId, poData, onProofsChange, loadPoAllUploadedFlag]);

  // Keep this — now no eslint-disable needed
  useEffect(() => { refreshProofs(); }, [refreshProofs]);

  useEffect(() => {
    if (!open || !poId) return undefined;
    return subscribePurchaseOrderInvalidation(poId, async () => {
      await refreshProofs();
    });
  }, [open, poId, refreshProofs]);



  // notes hydrate (from parent props)
  useEffect(() => {
    if (!open) return;
    const fromParent = Array.isArray(poData?.initialNotes) ? poData.initialNotes : [];
    const derived = !fromParent.length
      ? (poData?.customerNotes || []).map((n, i) => normalizeNote(n, i, allDirectories))
      : fromParent.map((n, i) => normalizeNote(n, i, allDirectories));
    setNotes((prev) => upsertNotes(prev, derived, allDirectories));
  }, [open, poData?.initialNotes, poData?.customerNotes, allDirectories]);

  const handleShippingChange = (e) => {
    const { name, value } = e.target;
    setShippingState((prev) => ({ ...prev, [name]: value }));
  };


  const pushRowPatch = React.useCallback((patch) => {
      if (!poId) return;
      onPoUpdated?.({ id: poId, ...patch });
  }, [poId, onPoUpdated]);

   const lastSyncRef = useRef("");
   useEffect(() => {
     if (!open || !poId) return;
     // compute summary with only the bits that affect it
     const summary = finalizeProofSummaryForUI({
       proofs,
       allProofsUploaded: poAllUploaded,
       proofStatus: poData?.proofStatus,
       proofRequired: poData?.proofRequired,
       proofSummary: poData?.proofSummary,
     });
     const payload = { proofs, proofSummary: summary, allProofsUploaded: poAllUploaded };
     const key = JSON.stringify(payload);
     if (lastSyncRef.current !== key) {
       lastSyncRef.current = key;
       pushRowPatch(payload);
     }
   // note: no 'poData' (whole object) in deps
   }, [open, poId, poAllUploaded, proofs, pushRowPatch, poData?.proofStatus, poData?.proofRequired, poData?.proofSummary]);

  // --- server updates (keep parity with list) ---
  const updateProofDetails = async (payload) => {
    if (!poId) { toast.error("Missing poId"); return null; }
  
    // 🔹 optimistic local updates so the grid refresh happens instantly
    if (payload?.proofId) {
      setProofs(prev => {
        let next = prev;
        if (payload.status) {
          next = next.map(p => p.id === payload.proofId ? { ...p, status: payload.status } : p);
        }
        if (payload.approvals) {
          next = next.map(p => {
            if (p.id !== payload.proofId) return p;
            const merged = mergeApprovalsAndStatus(p, payload.approvals);
            return { ...p, ...merged };
          });
        }
        // 🔔 also signal parent immediately
        onProofsChange?.(poId, next, { source: "mutation" });
        return next;
      });
    }

  
    try {
      const res = await approveProofList(poId, toServerUpdate(payload));
  
      // Only re-fetch for structural changes (new upload/delete/added rows)
      const needsReload =
        !payload?.proofId || payload.deleteProofRow || payload.deleteUploadOnly || payload.newUpload;
      if (needsReload) await refreshProofs();
  
      return res?.data ?? { ok: true };
    } catch (e) {
      console.error("update failed", e);
      toast.error(e?.response?.data?.message || "Update failed");
      // (optional) roll back optimistic change if you want
      await refreshProofs();
      return null;
    }
  };
  
  // Assign then notify designers
const handleAssignAndNotify = useCallback(async () => {
  if (!poId) { toast.error("Missing PO id."); return; }
  if (!assignForProof?.id) { toast.error("Missing proof id."); return; }
  if (!assignDesignerId) { toast("Choose a designer first."); return; }

  try {
    setAssignBusy(true);
    // 1) assign the designer to this proof row
    const ok = await updateProofDetails({
      proofId: String(assignForProof.id),
      designerUserId: String(assignDesignerId),
    });
    if (!ok) { setAssignBusy(false); return; }

    // 2) notify all assigned designers (your backend handles fan-out)
    await approveProofList(poId, { notifyDesigner: true });

    toast.success("Designer assigned and notified.");
    // reflect UI
    setProofs(prev => prev.map(p => 
      (p.id === assignForProof.id ? { ...p, designerUserId: String(assignDesignerId) } : p)
    ));
    closeAssignDialog();
  } catch (e) {
    console.error(e);
    toast.error(e?.response?.data?.message || "Failed to assign/notify designer");
  } finally {
    setAssignBusy(false);
  }
}, [poId, assignForProof, assignDesignerId, updateProofDetails]);

  // helper
  const currentUserName = React.useMemo(() => {
    const f = (authState?.first_name || "").trim();
    const l = (authState?.last_name || "").trim();
    return [f, l].filter(Boolean).join(" ") || authState?.email || "Elite Core";
  }, [authState]);

  const currentUserId = authState?.id ?? null;

  // internal approve/reject
  const handleUserDecision = (proof, isApproved) =>
    updateProofDetails({
      proofId: proof.id,
      approvals: {
        user: {
          state: isApproved ? "approved" : "rejected",
          by: currentUserName,       // UI hint; API should also stamp from req.auth
          byId: currentUserId,       // optional; API can persist
          at: new Date().toISOString(),
        }
      },
    }).then(ok => ok && toast.success(`${currentUserName} ${isApproved ? "approved" : "rejected"} this proof`));

  const handleClientDecision = (proof, isApproved) =>
    updateProofDetails({
      proofId: proof.id,
      approvals: { client: { state: isApproved ? "approved" : "rejected", by: "Client", at: new Date().toISOString() } },
    }).then(ok => ok && toast.success(`Client ${isApproved ? "approved" : "rejected"} this proof`));

  // per-row "all uploaded" gate
  const handleProofsUploadedChange = (proof, checked) =>
    updateProofDetails({ proofId: proof.id, allProofsUploaded: !!checked })
      .then(ok => ok && checked && toast("Client & team notified."));

  // designer assign
  const handleAssignDesigner = (proof) => {
    const id = designerSelections[proof.id];
    if (!id) return;
    updateProofDetails({ proofId: proof.id, designerUserId: id })
      .then(ok => ok && toast.success("Designer assigned"));
  }

  const makeProofId = () => `${Date.now()}-${Math.random().toString(36).slice(2,8)}`;


  // upload: first (virtual) vs replace (real)
  const handleFilesUpload = async (proof, file) => {
    if (!poId || !file) return;
    try {
      const rowId = proof?.id ?? proof?.proofId ?? proof?.Id ?? proof?.proof_id ?? null;
      const isVirtual = !rowId;
      const proofId = isVirtual ? makeProofId() : String(rowId);
  
      const fd = new FormData();
      fd.append("files", file);           // multer.array("files")
      fd.append("proofId", proofId);      // REQUIRED by the controller
      if (proof.decorationId != null) {
        fd.append("decorationId", String(proof.decorationId));
      }
      // optional extras:
      // fd.append("comments", "");
      // fd.append("designerUserId", "");
      // fd.append("allProofsUploaded", "false");
  
      await uploadProofList(poId, fd);    // ✅ correct route now
      toast.success("Proof uploaded");
    } catch (e) {
      console.error(e);
      toast.error(e?.response?.data?.message || "Upload failed");
    } finally {
      await refreshProofs();
    }
  };
  
  
  
  
  
  
  const onRowFileSelect = (proof) => async (e) => {
    const file = e.target.files?.[0];
    await handleFilesUpload(proof, file);
    e.target.value = ""; // allow re-selecting same file
  };

  // delete upload (match list contract)
  const handleDeleteUpload = async (proof) => {
    const ok = await updateProofDetails({
      proofId: proof.id,
      deleteUploadOnly: true,
      deletedBy: currentUserName,
      deletedByEmail: authState?.email || "",
    });
    if (ok) toast.success("Upload deleted");
  };

  const handleDeleteProofRow = async (proof) => {
    if (!proof?.id || poAllUploaded) return;
    const okToDelete = window.confirm("Delete this proof row?");
    if (!okToDelete) return;
    const ok = await updateProofDetails({
      proofId: proof.id,
      deleteProofRow: true,
    });
    if (ok) toast.success("Proof row deleted");
  };

  //const isPoAllProofsUploaded = rows.length > 0 && rows.every(r => r.allProofsUploaded === true);
// 3) when toggled, set local state using the server's answer
const handlePoAllProofsUploaded = async (checked) => {
  if (!poId) return;
  const previousProofStatus = poProofStatus;
  setPoProofStatus(getPurchaseOrderProofStatusForReadiness(poProofStatus, checked));
  try {
    const result = await updatePurchaseOrderDetails(poId, { allProofsUploaded: !!checked });
    const val =
      result?.purchaseOrder?.allProofsUploaded ??
      result?.allProofsUploaded ??
      result?.po?.allProofsUploaded ??
      !!checked;
    const nextProofStatus = normalizePurchaseOrderProofStatus(
      result?.purchaseOrder?.proofStatus
        ?? result?.po?.proofStatus
        ?? result?.proofStatus
        ?? (val ? "Proof Uploaded" : "Proof Needed")
    );
    setPoAllUploaded(!!val);                 // ← makes the box reflect DB immediately
    setPoProofStatus(nextProofStatus);
    onPoFlagChange?.(poId, !!val);
    onPoUpdated?.({ id: poId, allProofsUploaded: !!val, proofStatus: nextProofStatus });
    invalidatePurchaseOrderCache(poId);
    publishPurchaseOrderInvalidation(poId);
    toast.success(`All proofs ${val ? "marked uploaded" : "unmarked"}.`);
  } catch (e) {
    setPoProofStatus(previousProofStatus);
    console.error("Failed to update PO-level allProofsUploaded", e);
    toast.error(e?.response?.data?.message || "Failed to update PO-level All Proofs Uploaded.");
  }
};

  
  

  const handleTopLevelUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length || !poId) return;
  
    try {
      for (const f of files) {
        const fd = new FormData();
        fd.append("files", f);                 // field name must be "files"
        fd.append("proofId", newProofId());    // give each file its own proof row
        // You can also include: fd.append("decorationId", ""); for default/null
  
        await uploadProofList(poId, fd);       // ✅ correct route
      }
      toast.success("File(s) uploaded");
    } catch (err) {
      console.error("Upload failed", err);
      toast.error(err?.response?.data?.message || "Upload failed");
    } finally {
      await refreshProofs();
      e.target.value = "";
    }
  };
  
  const projectName =
  poData?.projectName ||
  poData?.salesOrder?.projectName ||
  poData?.salesOrder?.name ||
  poData?.projectName ||
  null;

  const noUploads = !hasAtLeastOneUpload; 

const canMarkAllUploaded = useMemo(
  () => uploadedRows.length > 0 && rows.every((r) => !!r.filePath),
  [rows, uploadedRows]
);

const disabledReason = useMemo(() => {
  if (uploadedRows.length === 0) return "Upload at least one proof first.";
  if (rows.some(r => !r.filePath)) return "Every location must have an uploaded file.";
  return "";
}, [rows, uploadedRows]);

// Track user IDs we couldn't map to emails locally
const unresolvedIds = useRef(new Set());

const dedupeEmails = (arr = []) =>
  Array.from(new Set(arr.map(s => String(s || "").trim()).filter(Boolean)));
const normalizeRole = (role = "") =>
  String(role || "").trim().toLowerCase().replace(/[_\s]+/g, "-");
const isProofApprovalToRole = (role) => {
  const r = normalizeRole(role);
  return ["order-rep", "client-rep", "administrator", "admin", "super-administrator"].includes(r);
};
const emailFromUser = (user) =>
  String(user?.email || user?.Email || user?.userEmail || "").trim();


// Who will get the approval emails
const recipientsForApproval = React.useMemo(() => {
  const proofRecipients = poData?.proofEmailRecipients || poData?.emailRecipients || {};
  const proofSalesOrderContacts = Array.isArray(proofRecipients?.salesOrderContacts)
    ? proofRecipients.salesOrderContacts
    : [proofRecipients?.billingContact, proofRecipients?.shippingContact].filter(Boolean);
  const salesOrderContactOptions = mergeContactOptionsByEmail(proofSalesOrderContacts);
  const salesOrderContactEmails = validEmailList(
    salesOrderContactOptions.map((r) => r.email)
  );

  const clientRepEmails = (recipients.clientReps || [])
    .map(emailById)
    .filter(Boolean);

  const orderRepEmails = (recipients.orderReps || [])
    .map(emailById)
    .filter(Boolean);

  const fallbackCustomer = validEmailList([
    ...(recipients.customer || []),

    // Sales order / client email field from purchasing dashboard row
    poData?.Email,
    poData?.email,

    // Optional alternate shapes if parent passes nested sales order data
    poData?.salesOrder?.Email,
    poData?.salesOrder?.email,
    poData?.clientEmail,
    poData?.clientContactEmail,
    poData?.customerEmail,
  ]);
  const customer = validEmailList([
    ...salesOrderContactEmails,
    ...(salesOrderContactEmails.length ? [] : fallbackCustomer),
  ]);
  const assignedOrderUsers = [
    ...(Array.isArray(poData?.orderAssignedUsers) ? poData.orderAssignedUsers : []),
    ...(Array.isArray(poData?.Order?.AssignedTo) ? poData.Order.AssignedTo : []),
    ...(Array.isArray(poData?.salesOrder?.AssignedTo) ? poData.salesOrder.AssignedTo : []),
  ];
  const orderAssignedToRecipients = validEmailList(
    assignedOrderUsers
      .filter((u) => isProofApprovalToRole(u?.role))
      .map(emailFromUser)
      .filter(Boolean)
  );

  const assignedToEmails = validEmailList(recipients.assignedToEmails || []);

  const all = dedupeEmails([
    ...customer,
    ...orderAssignedToRecipients,
    ...assignedToEmails,
    ...clientRepEmails,
    ...orderRepEmails,
  ]);
  return {
    all,
    clientReps: clientRepEmails,
    orderReps: orderRepEmails,
    assignedToEmails,
    orderAssignedToRecipients,
    customer,
    salesOrderContacts: salesOrderContactOptions,
  };
}, [recipients, emailById, poData]);

const resolveIdsToEmails = useCallback(async (ids) => {
  if (!ids?.length) return [];
  try {
    const headers = { accessToken: localStorage.getItem("accessToken") };
    const { data } = await axios.get(
      `${API}/auth`,
      { params: { ids: ids.join(",") }, headers }
    );

    // accept multiple shapes
    const rows =
      Array.isArray(data?.users) ? data.users :
      Array.isArray(data?.listOfUsers) ? data.listOfUsers :
      Array.isArray(data) ? data : [];

    // build map then return only the requested ids (in order)
    const byId = new Map(
      rows
        .filter(u => u?.id != null && u?.email)
        .map(u => [String(u.id), u])
    );

    return ids
      .map(id => byId.get(String(id))?.email)
      .filter(e => EMAIL_RX.test(e));
  } catch {
    return [];
  }
}, [API]);

const [emailDlgOpen, setEmailDlgOpen] = useState(false);

const [confirmAllOpen, setConfirmAllOpen] = useState(false);

// --- Email dialog state ---
const [emailSending, setEmailSending] = useState(false);
const [proofEmailFollowUp, setProofEmailFollowUp] = useState(false);
const [emailTemplates, setEmailTemplates] = useState([]);
const [emailTemplatesLoading, setEmailTemplatesLoading] = useState(false);
const [useCustomTemplate, setUseCustomTemplate] = useState(false);
const [emailComposerValue, setEmailComposerValue] = useState({
  to: [],
  cc: [],
  bcc: [],
  subject: "",
  body: "",
  templateId: "",
  layout: "plain",
  quickActions: {},
});

const removeFollowUpPrefix = React.useCallback(stripRevisedPrefix, []);
const applyFollowUpPrefix = React.useCallback(
  (txt = "") => applyRevisedPrefix(txt),
  []
);

const getDefaultProofBody = React.useCallback(
  (poNumber = "") => `Hello,

Your proofs ${" for " + poNumber || ""} are ready for review.
Please approve each line or request changes. Thank you!`,
  []
);

const getDefaultProofSubject = React.useCallback(buildDefaultProofSubject, []);

  const [recipientsResolved, setRecipientsResolved] = useState(() => ({
    clientReps: recipientsForApproval.clientReps,
    orderReps: recipientsForApproval.orderReps,
    assignedToEmails: recipientsForApproval.assignedToEmails,
    orderAssignedToRecipients: recipientsForApproval.orderAssignedToRecipients,
    customer:  recipientsForApproval.customer,
    salesOrderContacts: recipientsForApproval.salesOrderContacts || [],
    all:       recipientsForApproval.all,   // can be overwritten below
  }));

  const allEmailsPool = useMemo(() => {
    const dedupe = (arr=[]) => Array.from(new Set(arr.map(s => String(s).trim()).filter(Boolean)));
    return dedupe([
           ...(recipientsResolved.customer || []),
           ...(recipientsResolved.orderAssignedToRecipients || []),
           ...(recipientsResolved.clientReps || []),
           ...(recipientsResolved.orderReps || []),
           ...(recipientsResolved.assignedToEmails || []),
    ]);
  }, [recipientsResolved]);

  const contactOptions = useMemo(() => {
    const emailMap = new Map();
    const push = (email, name = "", role = "", extra = {}) => {
      const em = String(email || "").trim().toLowerCase();
      if (!EMAIL_RX.test(em)) return;
      const existing = emailMap.get(em);
      const next = {
        id: extra.id || existing?.id || em,
        email: em,
        name: name || existing?.name || em,
        role: role || existing?.role || "",
        badge: extra.badge || existing?.badge || "",
        label: extra.label || existing?.label || extra.badge || "",
        source: extra.source || existing?.source || "",
      };
      emailMap.set(em, next);
    };

    const assignedUsers = [
      ...(Array.isArray(poData?.orderAssignedUsers) ? poData.orderAssignedUsers : []),
      ...(Array.isArray(poData?.Order?.AssignedTo) ? poData.Order.AssignedTo : []),
      ...(Array.isArray(poData?.salesOrder?.AssignedTo) ? poData.salesOrder.AssignedTo : []),
    ];
    assignedUsers.forEach((u) => {
      const email = emailFromUser(u);
      if (!email) return;
      const displayName = `${u?.first_name || ""} ${u?.last_name || ""}`.trim();
      push(email, displayName || email, normalizeRole(u?.role || ""));
    });

    const proofRecipients = poData?.proofEmailRecipients || poData?.emailRecipients || {};
    const proofContacts = Array.isArray(proofRecipients?.salesOrderContacts)
      ? proofRecipients.salesOrderContacts
      : [proofRecipients?.billingContact, proofRecipients?.shippingContact].filter(Boolean);
    const mergedProofContacts = mergeContactOptionsByEmail(proofContacts);
    mergedProofContacts.forEach((c) => {
      const email = String(c?.email || '').trim().toLowerCase();
      const name = c?.name || email;
      const badge = c?.badge || '';
      push(email, name, "client-contact", {
        badge,
        label: badge,
        source: c?.source,
        id: c?.contactId ? `sales-order-contact-${c.contactId}` : email,
      });
    });

    allEmailsPool.forEach((email) => push(email, email, ""));
    return Array.from(emailMap.values());
  }, [allEmailsPool, poData]);

  const contactByEmail = useMemo(() => {
    const map = new Map();

    const addContact = (contact) => {
      if (!contact?.email) return;
      const normalized = normalizeProofContactOption(contact) || {
        id: contact.email,
        email: String(contact.email).trim().toLowerCase(),
        name: contact.name || contact.email,
      };
      map.set(normalized.email, normalized);
    };

    (recipientsResolved.salesOrderContacts || []).forEach(addContact);
    (contactOptions || []).forEach(addContact);

    return map;
  }, [recipientsResolved.salesOrderContacts, contactOptions]);

  const asEmailContactsWithMetadata = React.useCallback((emails = []) => {
    return dedupeEmails(emails)
      .filter((e) => EMAIL_RX.test(e))
      .map((email) => {
        const key = String(email).trim().toLowerCase();
        return contactByEmail.get(key) || { id: key, email: key, name: key };
      });
  }, [contactByEmail]);

// Opens the dialog and pre-fills recipients
const openEmailDialog = useCallback(async () => {

    // Try local resolution first
    let to = dedupeEmails([
      ...(recipientsResolved.customer || []),
      ...(recipientsResolved.orderAssignedToRecipients || []),
    ]);

    let cc = omitSelectedFromEmail([
      ...(recipientsResolved.orderReps || []),
      ...(recipientsResolved.clientReps || []),
      ...(recipientsResolved.assignedToEmails || []),
    ]);
    cc = cc.filter((email) => !to.map((e) => e.toLowerCase()).includes(String(email || "").toLowerCase()));
  
    // If some IDs couldn't resolve locally, batch-resolve them now
    if (unresolvedIds.current.size) {
      const extra = await resolveIdsToEmails(Array.from(unresolvedIds.current));
      unresolvedIds.current.clear();
      // Heuristic: extra emails from IDs are most likely order reps/assignees
      cc = omitSelectedFromEmail([...cc, ...extra]);
    }
  
    const poNumber = getProofEmailPoNumber(poData);
    const baseSubject = getDefaultProofSubject(poData);
    const purchasingRep = resolveProofEmailSender({ fromOptions, fromUserId });
    setProofEmailFollowUp(false);
    setUseCustomTemplate(false);
    setEmailComposerValue({
      to: asEmailContactsWithMetadata(to),
      cc: asEmailContactsWithMetadata(cc),
      bcc: mergeProofSenderIntoBcc([], purchasingRep),
      subject: baseSubject,
      body: getDefaultProofBody(poNumber),
      templateId: "",
      layout: "elite",
      quickActions: {},
    });
    setEmailDlgOpen(true);
  }, [recipientsResolved, resolveIdsToEmails, poData, getDefaultProofSubject, getDefaultProofBody, asEmailContactsWithMetadata, fromOptions, fromUserId]);

useEffect(() => {
  if (!emailDlgOpen) return;
  let cancelled = false;
  const loadTemplates = async () => {
    setEmailTemplatesLoading(true);
    try {
      const headers = { accessToken: localStorage.getItem("accessToken") };
      const instanceRes = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/byinstanceUniqueId/${instanceUniqueId}`,
        { headers }
      );
      const instanceId = Number(instanceRes?.data?.id || instanceRes?.data?.instance?.id);
      if (!Number.isFinite(instanceId) || instanceId <= 0) {
        throw new Error("Could not resolve instance id for templates.");
      }
      const templatesRes = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/${instanceId}/email-templates`,
        { headers }
      );
      if (!cancelled) {
        setEmailTemplates(Array.isArray(templatesRes?.data?.templates) ? templatesRes.data.templates : []);
      }
    } catch (err) {
      if (!cancelled) {
        setEmailTemplates([]);
        toast.error(err?.response?.data?.message || "Unable to load email templates.");
      }
    } finally {
      if (!cancelled) setEmailTemplatesLoading(false);
    }
  };
  loadTemplates();
  return () => { cancelled = true; };
}, [emailDlgOpen, instanceUniqueId]);

useEffect(() => {
  if (!emailDlgOpen) return;
  let cancelled = false;
  const loadTemplates = async () => {
    setEmailTemplatesLoading(true);
    try {
      const headers = { accessToken: localStorage.getItem("accessToken") };
      const instanceRes = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/byinstanceUniqueId/${instanceUniqueId}`,
        { headers }
      );
      const instanceId = Number(instanceRes?.data?.id || instanceRes?.data?.instance?.id);
      if (!Number.isFinite(instanceId) || instanceId <= 0) {
        throw new Error("Could not resolve instance id for templates.");
      }
      const templatesRes = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/${instanceId}/email-templates`,
        { headers }
      );
      if (!cancelled) {
        setEmailTemplates(Array.isArray(templatesRes?.data?.templates) ? templatesRes.data.templates : []);
      }
    } catch (err) {
      if (!cancelled) {
        setEmailTemplates([]);
        toast.error(err?.response?.data?.message || "Unable to load email templates.");
      }
    } finally {
      if (!cancelled) setEmailTemplatesLoading(false);
    }
  };
  loadTemplates();
  return () => { cancelled = true; };
}, [emailDlgOpen, instanceUniqueId]);

const toValid = validEmailList((emailComposerValue?.to || []).map((c) => c?.email || c?.id));
const ccValid = validEmailList((emailComposerValue?.cc || []).map((c) => c?.email || c?.id));
const bccValid = validEmailList((emailComposerValue?.bcc || []).map((c) => c?.email || c?.id));
const proofEmailSender = React.useMemo(() => {
  return resolveProofEmailSender({ fromOptions, fromUserId });
}, [fromOptions, fromUserId]);

const canSend = !emailSending && toValid.length > 0 && !!proofEmailSender?.email;

const fromDisplayValue = React.useMemo(() => {
  if (!proofEmailSender) return "";
  return `${proofEmailSender.name || "User"} <${proofEmailSender.email || ""}>`;
}, [proofEmailSender]);

const selectedFromEmail = React.useMemo(() => {
  return String(proofEmailSender?.email || "").trim().toLowerCase();
}, [proofEmailSender]);

const omitSelectedFromEmail = React.useCallback(
  (emails = []) =>
    dedupeEmails(emails).filter(
      (email) => String(email).trim().toLowerCase() !== selectedFromEmail
    ),
  [selectedFromEmail]
);

const handleProofFollowUpToggle = React.useCallback((checked) => {
  setProofEmailFollowUp(checked);
  setEmailComposerValue((prev) => {
    const current = String(prev?.subject || "");
    const nextSubject = checked
      ? applyFollowUpPrefix(current)
      : removeFollowUpPrefix(current);
    return { ...prev, subject: nextSubject };
  });
}, [applyFollowUpPrefix, removeFollowUpPrefix]);

const actionsMenu = useMemo(() => {
  const items = [
    projectUrl && { type: "link", label: "View Project", href: projectUrl },
    singleProofUrl && { type: "link", label: "View Proof Approval", href: singleProofUrl },
    artworkUrl && { type: "link", label: "View All Project Proof Appovals", href: artworkUrl },
    // 🔹 Always show these two actions
    {
      type: "action",
      label: "Request Designer",
      onClick: sendProofDesignRequest,
      disabled: !hasAssignedDesigner,
      tooltip: !hasAssignedDesigner ? "Assign a designer on at least one proof." : "",
    },
    {
      type: "action",
      label: "Email Proof Approval",
      onClick: openEmailDialog,
      //disabled: !hasAllFiles,
      //tooltip: !hasAllFiles ? "Every proof row must have an uploaded file." : "",
    },
  ];

  return items.filter(Boolean);
}, [
  projectUrl,
  artworkUrl,
  hasAssignedDesigner,
  hasAllFiles,
  sendProofDesignRequest,
  openEmailDialog,
]);



  const allApprovedAndUploaded = useMemo(
    () => rows.filter(r => !!r.filePath).length > 0 &&
          rows.filter(r => !!r.filePath).every(r => r.status === "Approved"),
    [rows]
  );

  const [supplierDlgOpen, setSupplierDlgOpen] = useState(false);
  const [supplierEmail, setSupplierEmail] = useState(
    poData?.supplier?.Email || poData?.supplierInfo?.email || ""
  );

  const searchPeople = async (q) => {
    const { data } = await axios.get(`${API}/users/search`, {
      params: { q },
      headers: { accessToken: localStorage.getItem("accessToken") }
    });
    // expect [{name, email, avatarUrl?}]
    return (data?.users || []).map(u => ({
      name: `${u.first_name || ""} ${u.last_name || ""}`.trim() || u.email,
      email: u.email,
      avatarUrl: u.profilePicture || u.avatar || null,
    }));
  };

  const without = (arr = [], banned = []) => {
    const ban = new Set((banned || []).map(s => String(s).trim().toLowerCase()));
    return (arr || []).filter(e => !ban.has(String(e).trim().toLowerCase()));
  }
  
  // 2) when dialog opens (or PO changes), resolve any IDs and build a final snapshot
  useEffect(() => {
    if (!open) return;
  
    const dedupe = (arr=[]) => Array.from(new Set(arr.filter(Boolean).map(s => String(s).trim())));
    const clientRepIds =
      normalizeIdList(poData?.clientRepIds) ||
      normalizeIdList(poData?.salesOrder?.clientRepIds) ||
      normalizeIdList(poData?.salesOrder?.clientReps);
    const orderRepIds =
      normalizeIdList(poData?.orderRepIds) ||
      normalizeIdList(poData?.salesOrder?.orderRepIds) ||
      normalizeIdList(poData?.salesOrder?.orderReps);
  
    const leftovers = Array.from(new Set([
      ...(clientRepIds || []),
      ...(orderRepIds  || []),
      ...Array.from(unresolvedIds.current || []),   // you already track these
    ]));
  
    (async () => {
      // use your existing /auth resolver as-is
      const extra = leftovers.length ? await resolveIdsToEmails(leftovers) : [];
  
      const clientReps = dedupe([
        ...recipientsForApproval.clientReps,
        ...extra, // if some of the “extras” are actually client reps
      ]);
      const orderReps  = dedupe([
        ...recipientsForApproval.orderReps,
        ...extra, // same idea — if you want, split extras by role instead
      ]);
      const customer = dedupe(recipientsForApproval.customer);
      const assignedToEmails = dedupe(recipientsForApproval.assignedToEmails);

      // TO should be client/customer only
      const all = dedupe(customer);

      setRecipientsResolved({
        clientReps,
        orderReps,
        assignedToEmails,
        orderAssignedToRecipients: dedupe(recipientsForApproval.orderAssignedToRecipients),
        customer,
        salesOrderContacts: recipientsForApproval.salesOrderContacts || [],
        all,
      });
    })();
  }, [open, poData, recipientsForApproval, resolveIdsToEmails]);

  return (
    <Dialog
      className="po-detail-popup"
      open={open}
      onClose={handleDialogClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          width: {
            xs: "calc(100vw - 24px)",
            sm: "min(1680px, calc(100vw - 48px))",
          },
          height: {
            xs: "calc(100vh - 24px)",
            sm: "min(1000px, calc(100vh - 48px))",
          },
          maxWidth: {
            xs: "calc(100vw - 24px)",
            sm: "calc(100vw - 48px)",
          },
          maxHeight: {
            xs: "calc(100vh - 24px)",
            sm: "calc(100vh - 48px)",
          },
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          m: { xs: 1.5, sm: 3 },
        },
      }}
    >
      <DialogTitle className="create-order-dialog-title" sx={{ flex: "0 0 auto" }}>
         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>

           <Box component="span">PO Tasks & Notes</Box>
           <Box className="po-detail-button-group">
             <Button
               variant="contained"
               onClick={handleActionsClick}
               sx={{
                 textTransform: "none",
                 color: "white",
                 backgroundColor: "#c3171d",
                 "&:hover": { backgroundColor: "white", color: "#c3171d" },
                 fontWeight: 600,
                 display: "flex",
                 alignItems: "center",
                 gap: "0.5rem",
                 marginRight: 5
               }}
               startIcon={<SettingsIcon />}
             >
               Actions
             </Button>
             <Menu
        anchorEl={actionsAnchor}
        open={actionsOpen}
        onClose={handleActionsClose}
        slotProps={{
          paper: { sx: { p: 1, minWidth: 240, border: "1px solid #CCC", borderRadius: "4px" } }
        }}
      >




      {actionsMenu.map((a) => {
          if (a.type === "link") {
            return (
              <MenuItem
                key={a.label}
                component={Link}
                to={a.href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleActionsClose}
                sx={{ fontWeight: 700 }}
              >
                {a.label}
              </MenuItem>
            );
          }

          const item = (
            <MenuItem
              key={a.label}
              onClick={() => { if (!a.disabled) { try { a.onClick?.(); } finally { handleActionsClose(); } } }}
              disabled={!!a.disabled}
              sx={{ fontWeight: 700, opacity: a.disabled ? 0.6 : 1, cursor: a.disabled ? "not-allowed" : "pointer" }}
            >
              {a.label}
            </MenuItem>
          );

          return a.tooltip
            ? <Tooltip key={`${a.label}-tt`} title={a.tooltip} arrow placement="right"><span>{item}</span></Tooltip>
            : item;
        })}

      </Menu>


            <Button sx={{color: "#FFF"}} onClick={onClose}>Close</Button>

           </Box>
         </Box>
       </DialogTitle>
      <DialogContent
        className="create-order-dialog-content production-po-dialog-content"
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >

        <h4 className="production-heading">{customer} - {projectName} - PO #{poNumber}</h4>

        <Toaster position="top-right" />

        <Tabs
          value={activeTab}
          onChange={(e, v) => setActiveTab(v)}
          textColor="inherit"
          TabIndicatorProps={{ style: { backgroundColor: '#000' } }}
          sx={{
            // default (unselected) color if you want a subtle grey:
            '& .MuiTab-root': { color: '#5f6368' },
            fontFamily: '"Nunito", "Helvetica Neue", Arial, sans-serif',
            // active tab label:
            '& .MuiTab-root.Mui-selected': { color: '#000 !important' },
          }}
        >
          <Tab label="Overview" value="overview" />
          <Tab label="Proofing" value="proofing" />
          <Tab label="Shipping" value="shipping" />
          <Tab label="Details" value="details" />
        </Tabs>

        {/* === OVERVIEW === */}
        {activeTab === "overview" && (
          <Box mt={3} display="grid">
            {/* composer */}


{/* ── Filters row ────────────────────────────────────────────────────── */}
<Box sx={{ mt: 2, p: 1, border: "1px dashed #e5e7eb", borderRadius: 1, bgcolor: "#fafafa" }}>
  <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
    <Tooltip title="Note visibility options">
      <IconButton
        size="small"
        aria-label="Note visibility options"
        onClick={(event) => setNoteVisibilityAnchorEl(event.currentTarget)}
        sx={{ border: "1px solid #d1d5db", bgcolor: "#fff", width: 40, height: 40 }}
      >
        <SettingsIcon fontSize="small" />
      </IconButton>
    </Tooltip>
    <Menu
      anchorEl={noteVisibilityAnchorEl}
      open={Boolean(noteVisibilityAnchorEl)}
      onClose={() => setNoteVisibilityAnchorEl(null)}
      PaperProps={{ sx: { width: 330, p: 1 } }}
    >
      <Box sx={{ px: 1, py: 0.75 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, fontFamily: "Nunito" }}>
          Note visibility
        </Typography>
        <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mt: 0.25 }}>
          Choose which notes appear in this purchasing popup.
        </Typography>
      </Box>
      <FormGroup sx={{ px: 1, py: 0.5, gap: 1 }}>
        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={showProductionOnly}
              onChange={(e) => {
                const checked = e.target.checked;
                setShowProductionOnly(checked);
                if (!checked) setShowThisPoOnly(false);
                setPage(1);
              }}
            />
          }
          label={
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>Production only</Typography>
              <Typography variant="caption" sx={{ color: "text.secondary" }}>
                Show purchasing, proofing, shipping, receiving, and production notes.
              </Typography>
            </Box>
          }
          sx={{ alignItems: "flex-start", m: 0 }}
        />
        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={effectiveIncludeProjectNotes}
              disabled={!showProductionOnly}
              onChange={(e) => { setIncludeProjectNotes(e.target.checked); setPage(1); }}
            />
          }
          label={
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>Include project notes</Typography>
              <Typography variant="caption" sx={{ color: "text.secondary" }}>
                {showProductionOnly ? "Show written project notes in this popup." : "Included automatically when Production only is off."}
              </Typography>
            </Box>
          }
          sx={{ alignItems: "flex-start", m: 0 }}
        />
        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={showProductionOnly && showThisPoOnly}
              disabled={!showProductionOnly}
              onChange={(event) => {
                if (!showProductionOnly) return;
                setShowThisPoOnly(event.target.checked);
                setPage(1);
              }}
            />
          }
          label={
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>This PO only</Typography>
              <Typography variant="caption" sx={{ color: "text.secondary" }}>
                {showProductionOnly ? `Show only notes tied to PO #${poNumber}.` : "Available when Production only is on."}
              </Typography>
            </Box>
          }
          sx={{ alignItems: "flex-start", m: 0 }}
        />
        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={infiniteNotesEnabled}
              onChange={(event) => {
                setInfiniteNotesEnabled(event.target.checked);
                setPage(1);
              }}
            />
          }
          label={
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>Infinite scroll</Typography>
              <Typography variant="caption" sx={{ color: "text.secondary" }}>
                Load more notes automatically while scrolling inside this popup.
              </Typography>
            </Box>
          }
          sx={{ alignItems: "flex-start", m: 0 }}
        />
      </FormGroup>
      <Box sx={{ display: "flex", justifyContent: "flex-end", px: 1, pt: 0.5 }}>
        <Button size="small" onClick={() => setNoteVisibilityAnchorEl(null)}>Close</Button>
      </Box>
    </Menu>

    <Autocomplete
      multiple
      options={commenterOptions}
      value={commenterOptions.filter(o => userFilterIds.some(id => String(id) === String(o.id)))}
      onChange={(_, val) => { setUserFilterIds(val.map(v => String(v.id))); setPage(1); }}
      getOptionLabel={(o) => (o ? o.name : "")}
      isOptionEqualToValue={(a,b) => String(a.id) === String(b.id)}
      renderInput={(params) => (
        <TextField {...params} size="small" label="Filter by user(s)" sx={{ height: 40, minHeight: "40px !important" }} placeholder="Type a name…" />
      )}
      sx={{ minWidth: 260, background: "#ffe6fe", minHeight: "40px !important", height: 40, maxHeight: 40 }}
    />

    <TextField
      size="small"
      placeholder="Search notes…"
      InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, opacity: 0.6 }} /> }}
      value={searchText}
      onChange={(e) => { setSearchText(e.target.value); setPage(1); }}
      sx={{ minWidth: 240, height: 40, maxHeight: 40, minHeight: "40px !important", background: "#f4e4b8" }}
    />

    <Box sx={{ ml: "auto" }}>
      <Typography variant="caption" sx={{ opacity: 0.7, fontFamily: "Nunito"}}>
        Showing {pagedRootNotes.length} / {rootCandidates.length}
      </Typography>
    </Box>
  </Stack>
</Box>


{/* ── Production Notes Composer ───────────────────────────────────────── */}
{/* ── Production Notes Composer ───────────────────────── */}
<Box sx={{ mt: 1, p: 2, border: "1px solid #eee", borderRadius: 2, bgcolor: "#d2ebeb", position: "relative" }}>
  <Typography variant="subtitle2" sx={{ fontSize: 18, mb: 1, fontWeight: 700, fontFamily: "Nunito" }}>
    Production notes for Project #{orderIdForPopup || "—"}
  </Typography>

  <Stack direction="row" spacing={1} sx={{ mb: 1 }} alignItems="center">
    <Tooltip arrow title="Type @ then a name to tag and notify teammates.">
      <InfoOutlinedIcon fontSize="small" />
    </Tooltip>
    <Typography sx={{ fontSize: "16px", fontFamily: "Nunito" }} variant="caption">Use <code>@</code> to mention people. Enter to insert, Cmd/Ctrl+Enter to post.</Typography>
  </Stack>

  <TextField
    inputRef={noteTextareaRef}
    multiline minRows={2} maxRows={6} fullWidth
    placeholder="Add a production note..."
    sx={{ background: "#FFF", borderRadius: "10px" }}
    value={newNote}
    onChange={(e) => setNewNote(e.target.value)}
    onKeyDown={(e) => {
      // submit
      if ((e.ctrlKey || e.metaKey) && e.key === "Enter") {
        e.preventDefault();
        addNote();                      // <-- defined below (3)
        return;
      }
      if (!mentionOpen) return;

      if (e.key === "Escape") {
        setMentionOpen(false);
        return;
      }
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        e.preventDefault();
        const max = filteredUsers.length;
        if (!max) return;
        setMentionIndex(i => (e.key === "ArrowDown" ? (i + 1) % max : (i - 1 + max) % max));
      }
      if (e.key === "Enter") {
        if (!filteredUsers.length) return;
        e.preventDefault();
        insertMention(filteredUsers[mentionIndex]);
      }
    }}
    onKeyUp={(e) => {
      const ta = noteTextareaRef.current || e.currentTarget;
      const { value, selectionStart } = ta;

      // Match the @-trigger immediately before caret
      // Allows letters, numbers, space, dot, dash, underscore (tweak as you like)
      const upto = value.slice(0, selectionStart);
      const m = upto.match(/@([a-z0-9 _.\-]{0,30})$/i);

      if (m) {
        const from = selectionStart - m[0].length;
        const to   = selectionStart;
        mentionRangeRef.current = { from, to };
        setMentionQuery(m[1] || "");
        setMentionOpen(true);
        setMentionIndex(0);
      } else {
        mentionRangeRef.current = { from: null, to: null };
        setMentionOpen(false);
        setMentionQuery("");
        setMentionIndex(0);
      }
    }}
  />

  <Box sx={{ mt: 1, display: "flex", gap: 1, alignItems: "center", justifyContent: "space-between", flexWrap: "wrap" }}>
    <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
      <input
        ref={noteAttachmentInputRef}
        type="file"
        accept="image/*,application/pdf"
        onChange={handleNoteAttachmentChange}
        style={{ display: "none" }}
      />
      <Button size="small" variant="outlined" onClick={() => noteAttachmentInputRef.current?.click()} disabled={noteSaving}>
        + Attachment
      </Button>
      <ProductionNoteAttachmentPreview file={noteAttachment} onRemove={clearNoteAttachment} />
    </Stack>
    <Button
      variant="contained"
      onClick={addNote}
      disabled={noteSaving || !newNote.trim()}
    >
      {noteSaving ? "Saving…" : "Add Note"}
    </Button>
  </Box>

  {/* Inline mention dropdown */}
  {mentionOpen && (
    <Box
      sx={{
        position: "absolute",
        zIndex: 20,
        left: 8,
        right: "auto",
        top: "100%",
        mt: 1,
        width: 360,
        maxHeight: 260,
        overflowY: "auto",
        bgcolor: "white",
        border: "1px solid #e0e0e0",
        borderRadius: 1.5,
        boxShadow: "0 8px 24px rgba(0,0,0,0.14)",
      }}
    >
      {filteredUsers.length === 0 ? (
        <Box sx={{ p: 1.25, color: "text.secondary", fontSize: 14 }}>No users</Box>
      ) : filteredUsers.map((u, i) => (
        <Box
          key={u.id}
          onMouseDown={(e) => { e.preventDefault(); insertMention(u); }}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            px: 1.25,
            py: 1,
            cursor: "pointer",
            bgcolor: i === mentionIndex ? "rgba(0,0,0,0.04)" : "transparent",
            "&:hover": { bgcolor: "rgba(0,0,0,0.04)" },
          }}
        >
          <Avatar src={u.avatar || ""} sx={{ width: 26, height: 26 }}>
            {(u.name || "U").slice(0,2).toUpperCase()}
          </Avatar>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1 }}>
              {u.name}
            </Typography>
            {!!u.email && (
              <Typography variant="caption" sx={{ opacity: 0.7 }}>
                {u.email}
              </Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  )}
</Box>




{/* ── Mentions Dialog ────────────────────────────────────────────────── */}
<Dialog open={mentionDlgOpen} onClose={() => setMentionDlgOpen(false)} maxWidth="sm" fullWidth>
  <DialogTitle>Select people to tag</DialogTitle>
  <DialogContent dividers>
    <Autocomplete
      multiple
      options={mentionOptions}
      value={mentionOptions.filter(o => mentionUserIds.some(id => String(id) === String(o.id)))}
      onChange={(_, val) => setMentionUserIds(val.map(v => String(v.id)))}
      getOptionLabel={(o) => (o ? `${o.name}${o.email ? ` <${o.email}>` : ""}` : "")}
      isOptionEqualToValue={(a,b) => String(a.id) === String(b.id)}
      renderInput={(params) => (
        <TextField {...params} label="Notify users" placeholder="Search…" />
      )}
      renderOption={(props, o) => (
        <li {...props} key={o.id}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Avatar src={normalizeAvatarUrl(o.avatar)} sx={{ width: 26, height: 26 }}>
              {(o.name || "U").slice(0,2).toUpperCase()}
            </Avatar>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>{o.name}</Typography>
              {!!o.email && <Typography variant="caption" sx={{ opacity: 0.7 }}>{o.email}</Typography>}
            </Box>
          </Stack>
        </li>
      )}
    />
    {!!commenterOptions.length && (
      <Typography variant="caption" sx={{ mt: 1, display:"block", opacity:0.75 }}>
        Tip: List shows people who have already commented on this order first.
      </Typography>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setMentionDlgOpen(false)}>Done</Button>
  </DialogActions>
</Dialog>

            {/* notes list */}
{/* ── Notes list ─────────────────────────────────────────────────────── */}
<div className="production-proof-popup-notes">
  <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{ mt: 1, mb: 1 }}>
    <Typography variant="subtitle2" component="h4" sx={{ fontWeight: 700, fontFamily: "Nunito" }}>
      Notes
    </Typography>
    {showProductionOnly ? (
      <Chip size="small" variant="outlined" label="Production only" />
    ) : (
      <Chip size="small" variant="outlined" sx={{ opacity: 0.75 }} label="All notes" />
    )}
    {showProductionOnly && includeProjectNotes && (
      <Chip size="small" color="info" variant="outlined" label="Including project notes" />
    )}
    {!showProductionOnly && (
      <Chip size="small" color="info" variant="outlined" label="All note types" />
    )}
    {showProductionOnly && showThisPoOnly && (
      <Chip size="small" color="secondary" variant="outlined" label="This PO only" />
    )}
  </Stack>

  {notesLoading ? (
    <Typography variant="body2">Loading notes…</Typography>
  ) : !pagedRootNotes.length ? (
    <Typography variant="body2" color="text.secondary">No notes match your filters.</Typography>
  ) : (
    <Box
      ref={notesScrollRef}
      onScroll={(event) => {
        if (!infiniteNotesEnabled || !hasMoreNotes) return;
        const node = event.currentTarget;
        if (node.scrollHeight - node.scrollTop - node.clientHeight <= 96) {
          setPage((current) => current + 1);
        }
      }}
      sx={{
        display: "grid",
        gap: 0.5,
        ...(infiniteNotesEnabled ? { maxHeight: 520, overflowY: "auto", pr: 0.5 } : {}),
      }}
    >
      {(() => {
      const renderNoteNode = (n, depth = 0, idx = 0) => {
        const when = n.createdAt ? new Date(n.createdAt) : null;
        const who  = n.userName || [n.userFirstName, n.userLastName].filter(Boolean).join(" ") || n.userRole || "User";
        const looksHtml = typeof n.message === "string" && /<\/?[a-z][\s\S]*>/i.test(n.message);
        const prod = isProductionBucketNote(n);
        const noteId = noteIdOf(n);
        const canDelete = isManualNote(n) && Number(n?.userId) === Number(authState?.id) && !n?.deletedAt;
        const canViewEmail = canViewEmailNote(n);
        const emailPreview = canViewEmail ? buildEmailNotePreview(n) : null;
        const hasChildren = Array.isArray(n.children) && n.children.length > 0;
        const isExpanded = Boolean(expandedNoteThreads[noteId]);
        const noteDirectoryUser = findNoteDirectoryUser(n, allDirectories);
        const avatarSrc = resolveNoteAvatarUrl(n, noteDirectoryUser);

        return (
          <div key={`${noteId || "note"}-${idx}`} className="production-note" style={{ borderLeft: prod ? "3px solid #0ea5e9" : "3px solid transparent", paddingLeft: 8, marginLeft: depth * 18, position: "relative" }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Avatar
                src={avatarSrc || undefined}
                alt={who}
                sx={{ width: 37, height: 37 }}
              >
                {!avatarSrc ? getInitials(who) : null}
              </Avatar>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>{who}</Typography>
              <Typography variant="caption" color="text.secondary">
                {when ? when.toLocaleString() : ""}
              </Typography>
              {prod && <Chip size="small" label="Production" sx={{ ml: 1 }} />}
              {n.poId && (
                <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                  PO #{n.poId}
                </Typography>
              )}
            </Stack>
            <IconButton
              size="small"
              onClick={() => setActiveReplyNoteId((prev) => (prev === noteId ? null : noteId))}
              sx={{ position: "absolute", top: 6, right: 68, color: "#555" }}
            >
              <ReplyIcon fontSize="small" />
            </IconButton>
            <IconButton size="small" onClick={() => togglePurchasingPin(n)} sx={{ position: "absolute", top: 6, right: 38, color: (n?.pinned || n?.pinnedPurchasing) ? 'gold' : 'grey' }}>
              {(n?.pinned || n?.pinnedPurchasing) ? <StarIcon fontSize="small" /> : <StarBorderIcon fontSize="small" />}
            </IconButton>
            {canDelete && (
              <IconButton size="small" color="error" onClick={() => handleDeletePurchasingNote(n)} sx={{ position: "absolute", top: 6, right: 8 }}>
                <DeleteForeverIcon fontSize="small" />
              </IconButton>
            )}

            {emailPreview ? (
              <Box sx={{ mt: 0.5 }}>
                <Typography variant="body2" sx={{ fontWeight: 700 }}>
                  {emailPreview.directionLabel}
                  {emailPreview.party ? ` · ${emailPreview.party}` : ""}
                </Typography>
                <Typography variant="body2">
                  {emailPreview.subject}
                </Typography>
              </Box>
            ) : looksHtml ? (
              <div style={{ fontSize: 14, lineHeight: 1.5, whiteSpace: "normal" }} dangerouslySetInnerHTML={{ __html: n.message }} />
            ) : (
              <Typography variant="body2" sx={{ whiteSpace: "pre-wrap", mt: 0.5 }}>{n.message}</Typography>
            )}
            {canViewEmail && (
              <Button
                size="small"
                startIcon={<VisibilityOutlinedIcon fontSize="small" />}
                onClick={() => setActiveEmailNote(n)}
                sx={{ mt: 0.5, mb: 0.25, px: 0, minWidth: 0, textTransform: "none", fontWeight: 700 }}
              >
                View email
              </Button>
            )}
            <ProductionNoteAttachments attachments={n.attachments || []} onImageClick={setLightboxAttachment} />
            {activeReplyNoteId === noteId && (
              <Box sx={{ mt: 1, position: "relative" }}>
                <Stack direction="row" spacing={1}>
                  <TextField
                    size="small"
                    fullWidth
                    placeholder="Write a reply... Type @ to tag a teammate"
                    value={replyDrafts[noteId] || ""}
                    inputRef={(el) => {
                      if (el) replyInputRefs.current[noteId] = el;
                    }}
                    onChange={(e) => setReplyDrafts((prev) => ({ ...prev, [noteId]: e.target.value }))}
                    onKeyDown={(e) => {
                      if (!replyMentionState.open || replyMentionState.noteId !== noteId) return;
                      if (e.key === "Escape") {
                        setReplyMentionState({ noteId: null, open: false, query: "", index: 0, from: null, to: null });
                        return;
                      }
                      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                        e.preventDefault();
                        const max = filteredReplyUsers.length;
                        if (!max) return;
                        setReplyMentionState((prev) => ({
                          ...prev,
                          index: e.key === "ArrowDown" ? (prev.index + 1) % max : (prev.index - 1 + max) % max,
                        }));
                      }
                      if (e.key === "Enter" && filteredReplyUsers.length) {
                        e.preventDefault();
                        insertReplyMention(noteId, filteredReplyUsers[replyMentionState.index]);
                      }
                    }}
                    onKeyUp={(e) => {
                      const input = e.target;
                      const value = String(
                        input?.value ?? replyDrafts[noteId] ?? "",
                      );
                      const selectionStart = Number.isInteger(input?.selectionStart)
                        ? input.selectionStart
                        : value.length;
                      const upto = value.slice(0, selectionStart);
                      const match = upto.match(/@([a-z0-9 _.\-]{0,30})$/i);
                      if (match) {
                        setReplyMentionState({
                          noteId,
                          open: true,
                          query: match[1] || "",
                          index: 0,
                          from: selectionStart - match[0].length,
                          to: selectionStart,
                        });
                      } else if (replyMentionState.noteId === noteId) {
                        setReplyMentionState({ noteId: null, open: false, query: "", index: 0, from: null, to: null });
                      }
                    }}
                  />
                  <Button
                    variant="contained"
                    disabled={Boolean(replySavingIds[noteId])}
                    onClick={() => handleReplyToPurchasingNote(n)}
                  >
                    {replySavingIds[noteId] ? "Posting…" : "Post"}
                  </Button>
                  <Button variant="text" onClick={() => setActiveReplyNoteId(null)}>Cancel</Button>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.75 }} flexWrap="wrap">
                  <input
                    ref={(el) => { if (el) replyAttachmentInputRefs.current[noteId] = el; }}
                    type="file"
                    accept="image/*,application/pdf"
                    onChange={(e) => handleReplyAttachmentChange(noteId, e)}
                    style={{ display: "none" }}
                  />
                  <Button size="small" variant="outlined" onClick={() => replyAttachmentInputRefs.current?.[noteId]?.click()}>
                    + Attachment
                  </Button>
                  <ProductionNoteAttachmentPreview file={replyAttachments[noteId]} compact onRemove={() => clearReplyAttachment(noteId)} />
                </Stack>
                {replyMentionState.open && replyMentionState.noteId === noteId && (
                  <Box className="production-note-reply-mention-menu">
                    {filteredReplyUsers.length === 0 ? (
                      <Box sx={{ p: 1, color: "text.secondary", fontSize: 13 }}>No users</Box>
                    ) : filteredReplyUsers.map((u, i) => (
                      <Box
                        key={u.id}
                        onMouseDown={(e) => { e.preventDefault(); insertReplyMention(noteId, u); }}
                        className={i === replyMentionState.index ? "is-active" : ""}
                      >
                        <Avatar src={u.avatar || ""} sx={{ width: 24, height: 24 }}>{(u.name || "U").slice(0, 2).toUpperCase()}</Avatar>
                        <span>{u.name || u.email}</span>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            )}
            {hasChildren ? (
              <Box sx={{ mt: 1 }}>
                <Button
                  size="small"
                  onClick={() => toggleNoteThread(noteId)}
                  startIcon={isExpanded ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
                >
                  {isExpanded ? "Hide replies" : `Show replies (${n.children.length})`}
                </Button>
                {isExpanded ? (
                  <Box sx={{ mt: 1, display: "grid", gap: 0.75 }}>
                    {n.children.map((child, childIdx) => renderNoteNode(child, depth + 1, childIdx))}
                  </Box>
                ) : null}
              </Box>
            ) : null}
          </div>
        );
      };
      return threadedNotes.map((n, idx) => renderNoteNode(n, 0, idx));
      })()}

      {hasMoreNotes && !infiniteNotesEnabled && (
        <Box sx={{ display: "grid", placeItems: "center", mt: 1 }}>
          <Button variant="outlined" onClick={() => setPage(p => p + 1)} sx={{background: "#FFF", color: "#000" }}>Load 20 more</Button>
        </Box>
      )}
      {hasMoreNotes && infiniteNotesEnabled && (
        <Typography variant="caption" color="text.secondary" sx={{ textAlign: "center", py: 1 }}>
          Scroll for more
        </Typography>
      )}
    </Box>
  )}
</div>
{lightboxAttachment && (
  <div className="production-note-image-lightbox" onClick={() => setLightboxAttachment(null)} role="presentation">
    <button type="button" className="production-note-image-lightbox-close" onClick={() => setLightboxAttachment(null)} aria-label="Close image preview">×</button>
    <img src={lightboxAttachment.url} alt={lightboxAttachment.fileName || "Production note attachment preview"} />
  </div>
)}

          </Box>
        )}

        {/* === PROOFING === */}
        {activeTab === "proofing" && (
          <Box mt={3}>
            <FormControl size="small" sx={{ width: 280, mb: 2 }} disabled={savingPoProofStatus}>
              <InputLabel id="po-proof-status-label">Proof Status</InputLabel>
              <Select
                labelId="po-proof-status-label"
                label="Proof Status"
                value={poProofStatus}
                onChange={(event) => handlePoProofStatusChange(event.target.value)}
              >
                {PURCHASE_ORDER_PROOF_STATUS_OPTIONS.map((option) => (
                  <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* header row: bundle + PO All Proofs Uploaded */}
            <Box mb={2} display="flex" alignItems="center" gap={2} justifyContent="space-between">
              <Box display="flex" alignItems="center" gap={2}>
                  {/* Top-level uploader — hidden when all proofs uploaded */}
                  {!poAllUploaded && (
                    <DropArea
                      label="Drop proofs for this PO"
                      sublabel="Each file becomes its own proof row"
                      multiple
                       busy={uploadingAll}
                       onFiles={async (files) => {
                         if (uploadingAll || !files?.length) return;
                         try {
                           setUploadingAll(true);
                           for (const f of files) {
                             const fd = new FormData();
                             fd.append("files", f);
                             fd.append("proofId", newProofId());
                             await uploadProofList(poId, fd);
                           }
                           toast.success(`${files.length} file(s) uploaded`);
                           await refreshProofs();
                         } catch (e) {
                           console.error(e);
                           toast.error(e?.response?.data?.message || "Upload failed");
                         } finally {
                           setUploadingAll(false);
                         }
                       }}
                    />
                  )}
                  {/* NEW: Top-level uploader (mimics the inspiration’s “Select Files”) */}
                  {/*<Box mb={2}>
                    <Button variant="contained" component="label">
                      Select Files
                      <input
                        type="file"
                        hidden
                        multiple
                        onChange={async (e) => {
                          const files = Array.from(e.target.files || []);
                          for (const f of files) {
                            const fd = new FormData();
                            fd.append("files", f); // no proofId / decorationId -> general PO proof
                            await uploadProofList(poId, fd);
                          }
                          toast.success("File(s) uploaded");
                          await refreshProofs();
                        }}
                      />
                    </Button>
                  </Box>*/}


              </Box>
              <Tooltip
  arrow
  title={
       poAllUploaded && !hasAtLeastOneUpload
         ? "Currently marked 'All proofs uploaded', but there are no files. Click to uncheck to re-enable uploads."
         : canMarkAllUploaded
           ? "Marks this PO as 'All proofs uploaded'. No emails are sent."
           : disabledReason
  }
>



  <FormControlLabel
    control={
      <Checkbox
        checked={poAllUploaded}
        onChange={(e) => handlePoAllProofsUploaded(e.target.checked)}
        disabled={!canMarkAllUploaded && !poAllUploaded} // allow uncheck
        sx={{
          '&.Mui-checked': { color: 'rgb(199, 9, 9) !important' },
          '&.Mui-checked:hover': { backgroundColor: 'rgba(199, 9, 9, 0.08) !important' },
          '&.Mui-focusVisible.Mui-checked': {
            outline: '2px solid rgba(199, 9, 9, 0.6)', outlineOffset: 2,
          },
          '&.Mui-disabled.Mui-checked': { color: 'rgba(199, 9, 9, 0.38) !important' },
        }}
      />
    }
    label="All Proofs Uploaded"
    sx={{ m: 0 }}
  />
</Tooltip>

              <FormControlLabel
                control={
                  <Checkbox
                    checked={simpleMode}
                    onChange={(e) => setSimpleMode(e.target.checked)}
                          sx={{
                          // default (unchecked) icon tint if you want:
                          // color: 'rgba(0,0,0,0.54)',
                          '&.Mui-checked': {
                            color: 'rgb(199, 9, 9) !important',
                          },
                          // optional: keep the red while hovered/focused too
                          '&.Mui-checked:hover': {
                            backgroundColor: 'rgba(199, 9, 9, 0.08) !important',
                          },
                          '&.Mui-focusVisible.Mui-checked': {
                            outline: '2px solid rgba(199, 9, 9, 0.6)',
                            outlineOffset: 2,
                          },
                          // optional: dim when disabled + checked
                          '&.Mui-disabled.Mui-checked': {
                            color: 'rgba(199, 9, 9, 0.38) !important',
                          },
                        }}
                  />
                }
                
                label="Simple view"
                sx={{ m: 0 }}
              />
            </Box>

            {loading ? (
              <Typography>Loading…</Typography>
            ) : rowsForRender.length > 0 ? (
              rowsForRender.map((proof) => {
                const decoKey = String(proof.decorationId ?? "");
                const locName = proof.location || decorationNameMap[decoKey] || null;
              
                return (
                  <Box key={proof.id || `virtual-${decoKey}`} sx={{ borderTop: '1px solid #ccc', mt: 1.5, pt: 1.5 }}>
                    {simpleMode ? (
                      /* ===== SIMPLE LAYOUT ===== */
(<div
  className="po-proof-flex-row"
  style={{
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    flexWrap: 'wrap',
  }}
>
  {/* thumbnail OR per-row upload */}
  <div className="po-proof-image-column" style={{ flex: '0 0 auto', minWidth: 260 }}>

{!proof.filePath && !poAllUploaded && (
  <DropArea
    label="Drop proof file"
    sublabel="It will attach to this proof row"
    multiple={false}
    onFiles={async (files) => {
      const file = files?.[0];
      if (!file) return;
      await handleFilesUpload(proof, file);
    }}
  />
)}

{proof.filePath && (
  <>
    {isPdfUrl(proof.filePath) ? (
      <Box
        sx={{
          position: "relative",
          borderRadius: 1,
          overflow: "hidden",
          border: "1px dashed #bdbdbd",
          width: 200,
          display: "grid",
          placeItems: "center",
          bgcolor: "#fafafa",
        }}
      >
        <PdfThumb src={proof.filePath} width={180} height={120} />
        <IconButton
          size="small"
          aria-label="Preview PDF"
          title="Preview"
          onClick={() => openPreview(proof.filePath, proof.fileName || proof.filePath.split("/").pop())}
          sx={{
            position: "absolute",
            top: 6,
            right: 6,
            zIndex: 2,
            bgcolor: "white",
            boxShadow: 1,
            "&:hover": { bgcolor: "white" },
          }}
        >
          <VisibilityOutlinedIcon fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          aria-label="Delete"
          title="Delete"
          onClick={() => handleDeleteUpload(proof)}
          disabled={poAllUploaded}
          sx={{
            position: "absolute",
            bottom: 6,
            right: 6,
            zIndex: 2,
            bgcolor: "rgba(0,0,0,0.55)",
            color: "common.white",
            "&:hover": { bgcolor: "error.main" },
          }}
        >
          <DeleteForeverIcon fontSize="small" />
        </IconButton>
      </Box>
    ) : (
      <ProofThumb
        src={proof.filePath}
        href={proof.filePath}
        onDelete={!poAllUploaded ? () => handleDeleteUpload(proof) : null}
        width={160}
      />
    )}
  </>
)}

</div>
  {/* filename + date + download */}
  <div className="po-proof-image-details">
    <Typography sx={{ mt: 0, wordBreak: 'break-all' }}>
      {proof.fileName || (proof.filePath ? proof.filePath.split('/').pop() : '—')}
    </Typography>
    <Typography variant="body2" color="text.secondary">
      {proof.updatedAt
        ? new Date(proof.updatedAt).toLocaleDateString()
        : proof.createdAt
        ? new Date(proof.createdAt).toLocaleDateString()
        : ''}
    </Typography>
    {proof.filePath && (
      <Button
        size="small"
        variant="text"
        component="a"
        href={proof.filePath}
        download={proof.fileName || undefined}
        target="_blank"
        rel="noopener noreferrer"
      >
        Download
      </Button>
    )}
  </div>
  {/* 🔹 two approval notices (You + Client) */}
  <Box sx={{ display:'flex', alignItems:'center', gap:1.25, flexWrap:'wrap' }}>
    <ApprovalChip
      roleLabel="Internal"
      state={proof.approvals?.user?.state}
      at={proof.approvals?.user?.at}
      by={proof.approvals?.user?.by}
    />
    <ApprovalChip
      roleLabel="Client"
      state={proof.approvals?.client?.state}
      at={proof.approvals?.client?.at}
      by={proof.approvals?.client?.by}
    />
    <Button
      size="small"
      variant="outlined"
      onClick={() => openHistory(proof)}
      sx={{ textTransform: "none" }}
      startIcon={<HistoryIcon fontSize="small" />}
    >
      History ({toAuditTrail(proof).length})
    </Button>
    <Button
      size="small"
      color="error"
      onClick={() => handleDeleteProofRow(proof)}
      disabled={poAllUploaded}
    >
      Delete row
    </Button>
  </Box>
</div>)

                    ) : (
                      /* ===== ADVANCED LAYOUT (your existing block) ===== */
                      (<Box
                        mb={3}
                        p={2}
                        border="1px solid #eee"
                        borderRadius="2px"
                        sx={{
                          bgcolor:
                            proof.status === "Approved"
                              ? "#eafdeb"
                              : proof.status === "Rejected"
                              ? "#fff1f1"
                              : "inherit",
                        }}
                      >
                        <Typography variant="subtitle2" gutterBottom>
                          Location: {locName ?? "—"}
                          {proof.decorationId != null ? ` (${proof.decorationId})` : ""}
                          {proof.isVirtual ? " • Needs proof" : ""}
                        </Typography>
                        {/* file block */}
                        <Box display="flex" alignItems="center" gap={2} mb={1}>
                        {proof.filePath ? (
  <>
    {isPdfUrl(proof.filePath) ? (
      <Box
        sx={{
          position: "relative",
          borderRadius: 1,
          overflow: "hidden",
          border: "1px dashed #bdbdbd",
          width: 220,
          height: 140,
          display: "grid",
          placeItems: "center",
          bgcolor: "#fafafa",
        }}
      >
        <PdfThumb src={proof.filePath} width={200} height={120} />
        <IconButton
          size="small"
          aria-label="Preview PDF"
          title="Preview"
          onClick={() => openPreview(proof.filePath, proof.fileName || proof.filePath.split("/").pop())}
          sx={{
            position: "absolute",
            top: 6,
            right: 6,
            zIndex: 2,
            bgcolor: "white",
            boxShadow: 1,
            "&:hover": { bgcolor: "white" },
          }}
        >
          <VisibilityOutlinedIcon fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          aria-label="Delete"
          title="Delete"
          onClick={() => handleDeleteUpload(proof)}
          disabled={poAllUploaded}
          sx={{
            position: "absolute",
            bottom: 6,
            right: 6,
            zIndex: 2,
            bgcolor: "rgba(0,0,0,0.55)",
            color: "common.white",
            "&:hover": { bgcolor: "error.main" },
          }}
        >
          <DeleteForeverIcon fontSize="small" />
        </IconButton>
      </Box>
    ) : (
      <ProofThumb
        src={proof.filePath}
        href={proof.filePath}
        onDelete={!poAllUploaded ? () => handleDeleteUpload(proof) : null}
        width={120}
      />
    )}

    {(!poAllUploaded || !hasAtLeastOneUpload) && (
      <Box sx={{ mt: 1.5, maxWidth: 420 }}>
        <DropArea
          label="Drop to replace file"
          sublabel={`Current: ${proof.fileName || proof.filePath.split('/').pop()}`}
          multiple={false}
          onFiles={async (files) => {
            const f = files[0];
            await handleFilesUpload(proof, f);
          }}
        />
      </Box>
    )}
  </>
) : (
  !poAllUploaded && (
    <Box sx={{ maxWidth: 420 }}>
      <DropArea
        label="Drop proof file"
        sublabel="They’ll attach to this proof row"
        multiple
        onFiles={async (files) => {
          for (const f of files) await handleFilesUpload(proof, f);
        }}
      />
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        No proof file yet.
      </Typography>
    </Box>
  )
)}


                        </Box>
                        {/* row-level all uploaded */}
                        {/*<FormControlLabel
                          control={
                            <Checkbox
                              checked={!!proof.allProofsUploaded}
                              onChange={(e) => handleProofsUploadedChange(proof, e.target.checked)}
                              disabled={!proof.filePath}
                            />
                          }
                          label="All proofs uploaded (notify client/order rep)"
                        />*/}
                        {/* approvals */}
                        {proof.approvals && (
                          <Box mt={2}>
                            <Typography
                              variant="body2"
                              sx={{
                                color:
                                  proof.approvals.user?.state === "approved"
                                    ? "success.main"
                                    : proof.approvals.user?.state === "rejected"
                                    ? "error.main"
                                    : "text.primary",
                              }}
                            >
                            <Typography variant="body2" sx={{ color:
                              proof.approvals.user?.state === "approved" ? "success.main" :
                              proof.approvals.user?.state === "rejected" ? "error.main" : "text.primary"
                            }}>
                              Internal: {proof.approvals.user?.state}
                              {renderBy(proof.approvals.user?.by) && ` by ${renderBy(proof.approvals.user?.by)}`}
                              {proof.approvals.user?.at && ` at ${new Date(proof.approvals.user.at).toLocaleString()}`}
                            </Typography>

                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                color:
                                  proof.approvals.client?.state === "approved"
                                    ? "success.main"
                                    : proof.approvals.client?.state === "rejected"
                                    ? "error.main"
                                    : "text.primary",
                              }}
                            >
                              Client: {proof.approvals.client?.state}
                              {renderBy(proof.approvals.client?.by) && ` by ${renderBy(proof.approvals.client?.by)}`}
                              {proof.approvals.client?.at && ` at ${new Date(proof.approvals.client.at).toLocaleString()}`}
                            </Typography>
                          </Box>
                        )}
                        {/* overrides */}
                        {proof.status === "Uploaded" && proof.id && (
                          <Box mt={1} display="flex" gap={1} flexWrap="wrap">
                            <Button size="small" disabled={proof.approvals?.user?.state === "approved"} onClick={() => handleUserDecision(proof, true)}>
                              Override user approval
                            </Button>
                            <Button size="small" disabled={proof.approvals?.user?.state === "rejected"} onClick={() => handleUserDecision(proof, false)}>
                              Override user reject
                            </Button>
                            <Button size="small" disabled={proof.approvals?.client?.state === "approved"} onClick={() => handleClientDecision(proof, true)}>
                              Override client approve
                            </Button>
                            <Button size="small" disabled={proof.approvals?.client?.state === "rejected"} onClick={() => handleClientDecision(proof, false)}>
                              Override client reject
                            </Button>
                          </Box>
                        )}
                        {/* client link */}
                        {proof.filePath && proof.id && (
                          <Box
                            mt={2}
                            display="flex"
                            alignItems="center"
                            gap={1}
                            sx={{ bgcolor: "#fafafa", border: "1px dashed #ddd", borderRadius: 1, p: 1 }}
                          >
                            <Typography variant="body2" sx={{ flex: 1 }}>
                              Client proof link:&nbsp;
                              <a href={getClientProofUrl(poId, proof.id)} target="_blank" rel="noopener noreferrer">(Open)</a>
                            </Typography>
                            <Button
                              size="small"
                              variant="outlined"
                              href={getClientProofUrl(poId, proof.id)}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open
                            </Button>
                            <Button
                              size="small"
                              onClick={async () => {
                                const url = getClientProofUrl(poId, proof.id);
                                try {
                                  await navigator.clipboard.writeText(url);
                                  toast.success("Client link copied");
                                } catch {
                                  const ta = document.createElement("textarea");
                                  ta.value = url;
                                  document.body.appendChild(ta);
                                  ta.select();
                                  document.execCommand("copy");
                                  document.body.removeChild(ta);
                                  toast.success("Client link copied");
                                }
                              }}
                            >
                              Copy
                            </Button>
                          </Box>
                        )}
                        {/* designer assignment */}
{proof.id && designers.length > 0 && (
  <Box mt={2}>
    <Button
      size="small"
      variant="contained"
      onClick={() => openAssignDialog(proof)}
    >
      Assign designer…
    </Button>
    {proof.designerUserId && (
      <Typography variant="caption" sx={{ ml: 1, opacity: 0.7 }}>
        Current: {
          designers.find(d => String(d.id) === String(proof.designerUserId))?.name || `#${proof.designerUserId}`
        }
      </Typography>
    )}
  </Box>
)}
                        {proof.id && (
                          <Box mt={1}>
                            <Button
                              size="small"
                              color="error"
                              onClick={() => handleDeleteProofRow(proof)}
                              disabled={poAllUploaded}
                            >
                              Delete row
                            </Button>
                          </Box>
                        )}
                      </Box>)
                    )}
                  </Box>
                );
              })
              
            ) : (
              <>
              {/*<Box>
                {JSON.stringify(rows)}
                <Typography mb={1}>No locations found for this PO.</Typography>
                {soId && estimationId && (
                  <Button
                    component={Link}
                    to={`/instance/elite-promo-marketing/sales/orders/${soId}/pos-proofs/${estimationId}`}
                    target="_blank"
                    variant="outlined"
                  >
                    Open proofs page
                  </Button>
                )}
              </Box>*/}
              </>
            )}
          </Box>
        )}

        <Dialog open={confirmAllOpen} onClose={()=>setConfirmAllOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Send approval requests?</DialogTitle>
          <DialogContent dividers>
            <Typography sx={{ mb:1.5 }}>
              We'll email approval links for each uploaded proof. 
              { 
                //Recipients:
              }
            </Typography>
            {/*<ul style={{ marginTop: 0 }}>
              <li><b>Client Rep(s):</b> {recipientsForApproval.clientReps.length ? recipientsForApproval.clientReps.join(', ') : '—'}</li>
              <li><b>Order Rep(s):</b> {recipientsForApproval.orderReps.length ? recipientsForApproval.orderReps.join(', ') : '—'}</li>
              <li><b>Customer:</b> {recipientsForApproval.customer.length ? recipientsForApproval.customer.join(', ') : '—'}</li>
            </ul>*/}
            <Typography variant="body2" color="text.secondary">
              They'll be able to approve/reject each proof. Rejections will notify the production team and designer to revise.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>setConfirmAllOpen(false)}>Cancel</Button>
            <Button
              variant="contained"
              onClick={async ()=> {
                setConfirmAllOpen(false);
                await handlePoAllProofsUploaded(true); // your existing function; server sends emails
              }}
            >
              Send & Mark Uploaded
            </Button>
          </DialogActions>
          {/* Live preview dialog */}
        </Dialog>










        {/* === SHIPPING === */}
        {activeTab === "shipping" && (
          <Box mt={3}>
            <Tabs
              value={shippingSubTab}
              onChange={(_, v) => setShippingSubTab(v)}
              sx={{ borderBottom: "1px solid", borderColor: "divider", mb: 2 }}
            >
              <Tab label="Manage" value="manage" />
              {showShippingProgressTab && <Tab label="Progress" value="progress" />}
            </Tabs>

            {shippingSubTab === "manage" && (
              <Box component="form">
                {[
                  { label: "Date Shipped", name: "dateShipped", type: "date" },
                  { label: "Shipping Cost", name: "shippingCost" },
                  { label: "Tracking Numbers (comma-separated)", name: "trackingNumbers" },
                ].map(({ label, name, type = "text" }) => (
                  <TextField
                    key={name}
                    fullWidth
                    label={label}
                    name={name}
                    type={type}
                    InputLabelProps={type === "date" ? { shrink: true } : undefined}
                    sx={{ mb: 2 }}
                    value={shippingState[name]}
                    onChange={(e) => setShippingState((prev) => ({ ...prev, [name]: e.target.value }))}
                  />
                ))}
                <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
                  <Stack spacing={1.5}>
                    <Box>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                        Warehouse placement
                      </Typography>
                      <Typography variant="caption" sx={{ opacity: 0.75 }}>
                        Optionally move already-received goods back into a warehouse bin from this shipping flow.
                      </Typography>
                    </Box>
                    <FormControlLabel
                      control={(
                        <Checkbox
                          checked={shippingPlacement.enabled}
                          disabled={!canChangeWarehousePlacement}
                          onChange={(e) => setShippingPlacement((prev) => ({ ...prev, enabled: e.target.checked }))}
                        />
                      )}
                      label="Put PO contents back into warehouse"
                    />
                    {!canChangeWarehousePlacement && shippingPlacementUnavailableMessage && (
                      <Typography variant="caption" color={shippingProgressState.error ? "error" : "text.secondary"}>
                        {shippingPlacementUnavailableMessage}
                      </Typography>
                    )}
                    {shippingPlacement.enabled && (
                      <Stack spacing={1.5}>
                        {shippingProgressState.receiptSourceReason === "linked_goods_po" &&
                          shippingProgressState.receiptSourcePoId &&
                          Number(shippingProgressState.receiptSourcePoId) !== Number(poData?.id) && (
                            <Typography variant="caption" sx={{ opacity: 0.75 }}>
                              {`Storage changes will update linked receipt source PO ${
                                shippingProgressState.receiptSourcePoNumber
                                  ? `#${shippingProgressState.receiptSourcePoNumber}`
                                  : `#${shippingProgressState.receiptSourcePoId}`
                              }.`}
                            </Typography>
                          )}
                        <FormControl size="small" fullWidth>
                          <InputLabel id="shipping-placement-warehouse-label">Warehouse</InputLabel>
                          <Select
                            labelId="shipping-placement-warehouse-label"
                            label="Warehouse"
                            value={shippingPlacement.warehouseKey || "main"}
                            onChange={(e) => setShippingPlacement((prev) => ({
                              ...prev,
                              warehouseKey: e.target.value,
                              binKey: "",
                              warehouseLevel: "",
                              warehouseCell: "",
                              binLabel: "",
                            }))}
                          >
                            {shippingWarehouses.map((warehouse) => (
                              <MenuItem key={warehouse.warehouseKey} value={warehouse.warehouseKey}>
                                {warehouse.name}
                              </MenuItem>
                            ))}
                            {!shippingWarehouses.length && <MenuItem value="main">Main Warehouse</MenuItem>}
                          </Select>
                        </FormControl>
                        <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
                          <Button
                            variant="outlined"
                            onClick={() => setShippingBinPickerOpen(true)}
                            startIcon={shippingWarehouseLayoutLoading ? <CircularProgress size={16} /> : <WarehouseIcon fontSize="small" />}
                            disabled={shippingWarehouseLoading}
                          >
                            Pick bin on map
                          </Button>
                          <Typography variant="body2" sx={{ alignSelf: "center", opacity: 0.82 }}>
                            Selected:{" "}
                            {selectedShippingBinTooltip ? (
                              <Tooltip title={selectedShippingBinTooltip}>
                                <span tabIndex={0}>{selectedShippingBinSummary}</span>
                              </Tooltip>
                            ) : selectedShippingBinSummary}
                          </Typography>
                        </Stack>
                        {shippingWarehouseError && (
                          <Typography variant="caption" color="error">
                            {shippingWarehouseError}
                          </Typography>
                        )}
                        <TextField
                          size="small"
                          fullWidth
                          label="Container/reference"
                          value={shippingPlacement.boxRef}
                          onChange={(e) => setShippingPlacement((prev) => ({ ...prev, boxRef: e.target.value }))}
                        />
                        <Grid container spacing={1.5}>
                          <Grid item xs={12} sm={4}>
                            <FormControl size="small" fullWidth>
                              <InputLabel id="shipping-placement-container-type">Container Type</InputLabel>
                              <Select
                                labelId="shipping-placement-container-type"
                                label="Container Type"
                                value={shippingPlacement.containerType}
                                onChange={(e) => setShippingPlacement((prev) => ({ ...prev, containerType: e.target.value }))}
                              >
                                <MenuItem value="">Leave unchanged</MenuItem>
                                {["box", "pallet", "carton", "crate", "roll", "bundle", "other"].map((type) => (
                                  <MenuItem key={type} value={type}>{type}</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              size="small"
                              fullWidth
                              type="number"
                              inputProps={{ min: 1 }}
                              label="Container Count"
                              value={shippingPlacement.containerCount}
                              onChange={(e) => setShippingPlacement((prev) => ({ ...prev, containerCount: e.target.value }))}
                            />
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              size="small"
                              fullWidth
                              label="Sub-location"
                              value={shippingPlacement.binSubLocation}
                              onChange={(e) => setShippingPlacement((prev) => ({ ...prev, binSubLocation: e.target.value }))}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              label="Shelf level"
                              value={shippingPlacement.binShelfLevel}
                              onChange={(e) => setShippingPlacement((prev) => ({ ...prev, binShelfLevel: e.target.value }))}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              label="Notes"
                              value={shippingPlacement.notes}
                              onChange={(e) => setShippingPlacement((prev) => ({ ...prev, notes: e.target.value }))}
                            />
                          </Grid>
                        </Grid>
                      </Stack>
                    )}
                  </Stack>
                </Paper>
                <Button
                  variant="contained"
                  onClick={handleSaveShipping}
                  disabled={savingShipping}
                  startIcon={savingShipping ? <CircularProgress size={16} /> : null}
                >
                  {savingShipping ? "Saving…" : "Save Shipping"}
                </Button>
              </Box>
            )}

            {shippingSubTab === "progress" && showShippingProgressTab && (
              <Stack spacing={1.25}>
                <Typography variant="caption" sx={{ opacity: 0.75 }}>
                  Read-only receiving progress. Edit in Shipping Labels.
                </Typography>
                {shippingProgressState.receiptSourceReason === "linked_goods_po" &&
                  shippingProgressState.receiptSourcePoId &&
                  Number(shippingProgressState.receiptSourcePoId) !== Number(poData?.id) && (
                    <Typography variant="caption" sx={{ opacity: 0.75 }}>
                      {`Showing receiving/storage progress from linked supplier PO ${
                        shippingProgressState.receiptSourcePoNumber
                          ? `#${shippingProgressState.receiptSourcePoNumber}`
                          : `#${shippingProgressState.receiptSourcePoId}`
                      }.`}
                    </Typography>
                  )}
                {shippingProgressState.loading && <CircularProgress size={20} />}
                {shippingProgressState.error && <Typography color="error">{shippingProgressState.error}</Typography>}
                {!shippingProgressState.loading && !shippingProgressRows.length ? (
                  <Paper variant="outlined" sx={{ p: 2 }}>
                    <Typography variant="body2" color="text.secondary">No PO line items available for this PO.</Typography>
                  </Paper>
                ) : (
                  <TableContainer component={Paper} variant="outlined">
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>PO Line / Product</TableCell>
                          <TableCell align="right">Expected</TableCell>
                          <TableCell align="right">Received</TableCell>
                          <TableCell align="right">Remaining</TableCell>
                          <TableCell align="center">Storage</TableCell>
                          <TableCell align="center">Fully received</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {!shippingProgressRows.length && (
                          <TableRow>
                            <TableCell colSpan={6} align="center">No receiving progress available.</TableCell>
                          </TableRow>
                        )}
                        {shippingProgressRows.map((line) => (
                          <TableRow key={`shipping-progress-${line.lineKey}`}>
                            <TableCell>{line.lineLabel}</TableCell>
                            <TableCell align="right">{Number.isFinite(line.orderedQuantity) ? line.orderedQuantity : "—"}</TableCell>
                            <TableCell align="right">{line.receivedQuantity}</TableCell>
                            <TableCell align="right">{line.remainingQuantity == null ? "—" : line.remainingQuantity}</TableCell>
                            <TableCell align="center">
                              <Tooltip title={line.storageTooltip || line.storageDetails || line.storageSummary}>
                                <span>{line.storageSummary}</span>
                              </Tooltip>
                            </TableCell>
                            <TableCell align="center">
                              <Chip
                                size="small"
                                label={line.fullyReceived ? "Yes" : "No"}
                                color={line.fullyReceived ? "success" : "default"}
                                variant={line.fullyReceived ? "filled" : "outlined"}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Stack>
            )}
          </Box>
        )}

        <Dialog open={shippingBinPickerOpen} onClose={() => setShippingBinPickerOpen(false)} maxWidth="lg" fullWidth>
          <DialogTitle>Select Warehouse Bin</DialogTitle>
          <DialogContent>
            {shippingWarehouseLayoutLoading && !shippingWarehouseLayout ? (
              <Typography variant="body2" color="text.secondary">
                Loading warehouse layout...
              </Typography>
            ) : (
              <Stack spacing={1.5}>
                <WarehouseBinPickerMap
                  layout={shippingWarehouseLayout}
                  activeWarehouseKey={shippingPlacement.warehouseKey || "main"}
                  selectedBinKey={shippingPlacement.binKey}
                  onSelectBin={handlePickShippingBinFromMap}
                  disabled={savingShipping}
                  showOnlyBinsSelectable
                />
                <Typography variant="caption" sx={{ opacity: 0.75 }}>
                  Click any highlighted bin block to apply that warehouse location.
                </Typography>
              </Stack>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShippingBinPickerOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>

        {/* === DETAILS === */}
{/* === DETAILS === */}
{activeTab === "details" && (
  <Box
    component="form"
    onSubmit={(e) => { e.preventDefault(); handleSavePoDetails(); }}
    sx={{ mt: 3, display: "grid", gap: 2 }}
  >
    {/* Header */}
    <Typography variant="h6" sx={{ fontWeight: 700 }}>
      Edit Purchase Order
    </Typography>



    {/* Content grid */}
    <Grid container spacing={2}>
      {/* LEFT COLUMN */}
      <Grid item xs={12} md={6}>
        <Card variant="outlined" sx={{ borderRadius: 2 }}>
          <CardHeader
            title="Status & Stage"
            subheader="Set vendor stage and internal production status"
            sx={{ pb: 0.5 }}
          />
          <CardContent sx={{ display: "grid", gap: 2 }}>
            {/* Stage (supplierStatus) */}
            <FormControl size="small" fullWidth>
              <InputLabel>Stage</InputLabel>
              <Select
                label="Stage"
                value={poEdit.supplierStatus}
                onChange={(e) => setPoEdit(s => ({ ...s, supplierStatus: e.target.value }))}
              >
                {STAGE_ENUMS.map(opt => (
                  <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                ))}
              </Select>
              <FormHelperText>
                Supplier-facing lifecycle (e.g. Created → Submitted → …).
              </FormHelperText>
            </FormControl>

            {/* Status (productionRepStatus) */}
            <FormControl size="small" fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                label="Status"
                value={poEdit.productionRepStatus}
                onChange={(e) => setPoEdit(s => ({ ...s, productionRepStatus: e.target.value }))}
              >
                {STATUS_ENUMS.map(opt => (
                  <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                ))}
              </Select>
              <FormHelperText>
                Internal production state tracked by your team.
              </FormHelperText>
            </FormControl>
          </CardContent>
        </Card>
      </Grid>

      {/* RIGHT COLUMN */}
      <Grid item xs={12} md={6}>
        <Card variant="outlined" sx={{ borderRadius: 2, height: "100%" }}>
          <CardHeader
            title="Next Action"
            subheader="What’s next and when it should happen"
            sx={{ pb: 0.5 }}
          />
          <CardContent sx={{ display: "grid", gap: 2 }}>
            <TextField
              size="small"
              type="datetime-local"
              label="Next Action Date"
              InputLabelProps={{ shrink: true }}
              value={poEdit.nextActionDate}
              onChange={(e) => setPoEdit(s => ({ ...s, nextActionDate: e.target.value }))}
              fullWidth
              helperText="Local time; used for reminders and follow-ups."
            />

            <Autocomplete
              size="small"
              freeSolo
              options={nextActionTypes}
              value={poEdit.nextActionType || null}
              onChange={(_, v) => setPoEdit(s => ({ ...s, nextActionType: v || "" }))}
              onInputChange={(_, v) => setPoEdit(s => ({ ...s, nextActionType: v || "" }))}
              renderInput={(params) => (
                <TextField {...params} label="Next Action Type" helperText="e.g. Follow up, Send proof, Call vendor" />
              )}
            />
          </CardContent>
        </Card>
      </Grid>



      <Grid item xs={12}>
      <Box>
  <Button
    variant="text"
    disabled={!isDirty || savingPo}
    onClick={() => {
      setPoEdit({
        supplierStatus: poData?.supplierStatus || "",
        productionRepStatus: poData?.productionRepStatus || "",
        nextActionType: actionNameFromAny(poData?.nextActionType ?? poData?.nextAction ?? ""),
        nextActionDate: isoToInputLocal(poData?.nextActionDate || poData?.naDate || null),
      });
    }}
  >
    Revert
  </Button>

  <Button
    variant="contained"
    onClick={handleSavePoDetails}
    disabled={!isDirty || savingPo}
    startIcon={savingPo ? <CircularProgress size={16} /> : null}
  >
    {savingPo ? "Saving…" : "Save changes"}
  </Button>
</Box>
</Grid>


      {/* READ-ONLY SPEC */}
{/* PURCHASE ORDER OVERVIEW (robust aliases + 18px) */}
<Grid item xs={12}>
  <Card variant="outlined" sx={{ borderRadius: 2 }}>
    <CardHeader title="Purchase Order Overview" sx={{ pb: 0.5 }} />
    <CardContent>
      {poData && typeof poData === "object" ? (
        (() => {
          // ------- helpers: safe get + alias resolution -------
          const val = (obj, keys, fallback = undefined) => {
            for (const k of keys) {
              if (obj && Object.prototype.hasOwnProperty.call(obj, k)) {
                const v = obj[k];
                if (v !== undefined && v !== null && v !== "") return v;
              }
            }
            return fallback;
          };
          const nest = (obj, path) =>
            path.split(".").reduce((o, p) => (o && o[p] !== undefined ? o[p] : undefined), obj);

          const firstNonEmpty = (...vs) => vs.find(v => v !== undefined && v !== null && String(v).trim() !== "");

          const yesNo = (v) => {
            if (typeof v === "boolean") return v ? "Yes" : "No";
            if (typeof v === "string") {
              const s = v.toLowerCase();
              if (["yes", "true", "1"].includes(s)) return "Yes";
              if (["no", "false", "0"].includes(s)) return "No";
            }
            return v ? "Yes" : "No";
          };

          const fmtDate = (d) => {
            if (!d) return "—";
            // support Date, ISO strings, or already formatted
            const dt = new Date(d);
            if (isNaN(dt)) {
              // try nested or numeric timestamp string
              const n = Number(d);
              if (!Number.isNaN(n)) {
                const dt2 = new Date(n);
                return isNaN(dt2) ? String(d) : dt2.toLocaleDateString();
              }
              return String(d);
            }
            return dt.toLocaleDateString();
          };

          const prettyType = (t) => ({
            Same_supplier_decoration: "Supplier Decorates → Client",
            Different_supplier_decoration: "External Decorator → Client",
            Combined_supplier_and_external_decoration: "Combined: Supplier & External Deco",
            Other_service_art: "Art Service (Internal)",
            No_decoration: "Blanks (No Decoration)",
          }[t] || t || "—");

          const linesFromAddressObj = (addr) =>
            addr
              ? [
                  addr.name,
                  addr.street,
                  [addr.city, addr.stateProvince || addr.state].filter(Boolean).join(", "),
                  addr.postalZipCode || addr.postal,
                  addr.country,
                ]
                  .filter(Boolean)
                  .join("\n")
              : null;

          // ------- normalize/alias all fields shown in the UI -------

          // PO Number
          const poNumber = firstNonEmpty(
            val(poData, ["poNumber", "purchaseOrderNumber", "po Number"]),
            val(poData, ["PO Number"]) // if already prettified elsewhere
          );

          // Order # (external)
          const orderNumber = firstNonEmpty(
            val(poData, ["orderId", "order Id"]),
            val(poData, ["salesOrderId", "estimationId"]) // fallback if needed
          );

          // Route: prefer explicit routeSummary, else map from type
          const route = firstNonEmpty(
            val(poData, ["routeSummary"]),
            prettyType(firstNonEmpty(
              val(poData, ["purchaseOrderType"]),
              val(poData, ["row Type"]) // if someone stored "PO" vs specific types
            ))
          );

          // Supplier / Decorator
          const supplierDecorator = firstNonEmpty(
            nest(poData, "supplierInfo.supplierName"),
            val(poData, ["supplier"]),                // old flat key
            val(poData, ["vendorSupplierName"])       // if you add this later
          );

          // Proof/Supplier/Production statuses
          const rawProofStatus = firstNonEmpty(
            val(poData, ["proofStatus", "proof Status"])
          );
          const proofStatus = rawProofStatus
            ? normalizePurchaseOrderProofStatus(rawProofStatus)
            : "";
          const supplierStatus = firstNonEmpty(
            val(poData, ["supplierStatus", "supplier Status"])
          );
          const productionStatus = firstNonEmpty(
            val(poData, ["productionRepStatus", "production Rep Status"])
          );

          // In-Hands Date
          const inHands = firstNonEmpty(
            val(poData, ["inhandsDate", "in Hands Date", "inHandsDate"])
          );

          // Shipping Method
          const shippingMethod = firstNonEmpty(
            val(poData, ["shippingMethod", "shipping Method"]),
            nest(poData, "supplierInfo.shippingMethod")
          );

          // Firm Ship
          const firm = firstNonEmpty(
            val(poData, ["firm"]),
            nest(poData, "supplierInfo.firm")
          );

          // Client Email
          const clientEmail = firstNonEmpty(
            val(poData, ["clientContactEmail", "client Email"])
          );

          // Next Action Date
          const nextActionDate = firstNonEmpty(
            val(poData, ["nextActionDate", "next Action Date"])
          );

          // Ship To (string or object)
          const shipToText = firstNonEmpty(
            val(poData, ["shippingAddress"]),
            linesFromAddressObj(val(poData, ["shipTo"])) ||
              linesFromAddressObj(nest(poData, "supplierInfo.shipTo"))
          );

          // Ship From (string or object)
          const shipFromText = firstNonEmpty(
            val(poData, ["shipFromAddress"]),
            linesFromAddressObj(val(poData, ["shipFrom"])) ||
              linesFromAddressObj(nest(poData, "supplierInfo.shipFrom"))
          );

          // ------- rows to render -------
          const rows = [
            { label: "PO Number", value: poNumber },
            { label: "Order #", value: orderNumber },
            { label: "Route", value: route || "—" },
            { label: "Supplier / Decorator", value: supplierDecorator || "—" },
            { label: "Proof Status", value: proofStatus || "—" },
            { label: "Supplier Status", value: supplierStatus || "—" },
            { label: "Production Status", value: productionStatus || "—" },
            { label: "In-Hands Date", value: fmtDate(inHands) },
            { label: "Shipping Method", value: shippingMethod || "—" },
            { label: "Firm Ship", value: yesNo(!!firm) },
            { label: "Client Email", value: clientEmail || "—" },
            { label: "Next Action Date", value: fmtDate(nextActionDate) },
          ];

          return (
            <Grid container spacing={2}>
              {rows.map(({ label, value }) => (
                <Grid key={label} item xs={12} sm={6} md={4}>
                  <Box sx={{ display: "grid", gap: 0.25 }}>
                    <Typography variant="body1" sx={{ fontSize: 18, lineHeight: 1.2 }} component="div">
                      <b>{label}</b>
                    </Typography>
                    <Typography variant="body1" sx={{ fontSize: 18, wordBreak: "break-word", whiteSpace: "pre-line" }}>
                      {value ?? "—"}
                    </Typography>
                  </Box>
                </Grid>
              ))}

              {/* Addresses (full-width for readability) */}
              <Grid item xs={12} md={6}>
                <Box sx={{ display: "grid", gap: 0.25 }}>
                  <Typography variant="body1" sx={{ fontSize: 18 }} component="div">
                    <b>Ship To</b>
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18, whiteSpace: "pre-line" }}>
                    {shipToText || "—"}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box sx={{ display: "grid", gap: 0.25 }}>
                  <Typography variant="body1" sx={{ fontSize: 18 }} component="div">
                    <b>Ship From</b>
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18, whiteSpace: "pre-line" }}>
                    {shipFromText || "—"}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          );
        })()
      ) : (
        <Typography variant="body1" sx={{ fontSize: 18 }} color="text.secondary">
          No PO data available.
        </Typography>
      )}
    </CardContent>
  </Card>
</Grid>


    </Grid>




    {/* Sticky actions footer */}
  </Box>
)}


      </DialogContent>
      {isPdfUrl(previewSrc) && (
          <PdfViewerDialog
            open={previewOpen}
            src={previewSrc}
            fileName={previewName}
            onClose={() => setPreviewOpen(false)}
          />
        )}
      <Dialog open={historyOpen} onClose={() => setHistoryOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Proof History</DialogTitle>
        <DialogContent dividers>
          {(() => {
            const trail = [...toAuditTrail(historyProof)].sort(
              (a, b) => new Date(b?.at || 0) - new Date(a?.at || 0)
            );
            if (!trail.length) return <Typography variant="body2">No history yet.</Typography>;
            return (
              <Box sx={{ display: "grid", gap: 1.25 }}>
                {trail.map((evt, idx) => {
                  const eventFile = evt?.filePath || historyProof?.filePath || "";
                  const ext = extFromUrl(eventFile);
                  const atText = evt?.at ? new Date(evt.at).toLocaleString() : "—";
                  const actorName = evt?.actor?.name || "Unknown";
                  const actorEmail = evt?.actor?.email ? ` (${evt.actor.email})` : "";
                  return (
                    <Box
                      key={`${evt?.at || "evt"}-${idx}`}
                      sx={{ p: 1.25, border: "1px solid #eee", borderRadius: 1.5, display: "flex", gap: 1.25 }}
                    >
                      <Box
                        component={eventFile ? "a" : "div"}
                        href={eventFile || undefined}
                        target={eventFile ? "_blank" : undefined}
                        rel={eventFile ? "noopener noreferrer" : undefined}
                        sx={{
                          width: 48,
                          height: 48,
                          border: "1px solid #eee",
                          borderRadius: 1,
                          display: "grid",
                          placeItems: "center",
                          overflow: "hidden",
                          bgcolor: "#fafafa",
                          flexShrink: 0,
                        }}
                      >
                        {eventFile && isImageExt(ext) ? (
                          <img
                            src={eventFile}
                            alt="proof-history-preview"
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                          />
                        ) : ext === "pdf" ? (
                          <PictureAsPdfOutlinedIcon sx={{ color: "#d32f2f" }} />
                        ) : (
                          <InsertDriveFileOutlinedIcon color="action" />
                        )}
                      </Box>
                      <Box sx={{ minWidth: 0 }}>
                        <Typography variant="body2">
                          <b style={{ textTransform: "capitalize" }}>{evt?.type || "event"}</b> • {atText}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" display="block">
                          {actorName}
                          {actorEmail}
                        </Typography>
                        {(evt?.fromStatus || evt?.toStatus) && (
                          <Typography variant="caption" color="text.secondary" display="block">
                            {evt?.fromStatus || "—"} → {evt?.toStatus || "—"}
                          </Typography>
                        )}
                        {evt?.comment ? (
                          <Typography variant="body2" sx={{ mt: 0.5 }}>
                            {evt.comment}
                          </Typography>
                        ) : null}
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            );
          })()}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setHistoryOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
      <EmailViewerDialog
        open={Boolean(activeEmailNote && activeEmailView)}
        email={activeEmailView}
        onClose={() => setActiveEmailNote(null)}
      />
      <Dialog open={assignDlgOpen} onClose={closeAssignDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Assign designer</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Pick a designer for {assignForProof?.location ? `"${assignForProof.location}"` : "this proof"}.
            On save, they’ll be notified automatically.
          </Typography>

          <FormControl size="small" fullWidth>
            <InputLabel id="assign-designer-label">Designer</InputLabel>
            <Select
              labelId="assign-designer-label"
              label="Designer"
              value={assignDesignerId}
              onChange={(e) => setAssignDesignerId(String(e.target.value))}
            >
              {designers.map((d) => (
                <MenuItem key={d.id} value={String(d.id)}>
                  {d.name}
                </MenuItem>
              ))}
            </Select>
            {!!assignForProof?.designerUserId && (
              <FormHelperText>
                Was: {
                  designers.find(d => String(d.id) === String(assignForProof.designerUserId))?.name
                  || `#${assignForProof.designerUserId}`
                }
              </FormHelperText>
            )}
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeAssignDialog} disabled={assignBusy}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleAssignAndNotify}
            disabled={!assignDesignerId || assignBusy}
            startIcon={assignBusy ? <CircularProgress size={16} /> : null}
          >
            {assignBusy ? "Assigning…" : "Assign & Email"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={emailDlgOpen} onClose={()=>setEmailDlgOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle className="create-order-dialog-title">Email Proof Approval</DialogTitle>
        <DialogContent className="create-order-dialog-content" dividers>


          <Typography sx={{ mb: 2 }}>
            Choose recipients. Defaults are based on the order&apos;s client contact, client reps, order reps, and AssignedTo.
          </Typography>
          <EmailComposer
            contacts={contactOptions}
            templates={useCustomTemplate ? emailTemplates : []}
            showTemplateSelect={useCustomTemplate}
            value={emailComposerValue}
            onChange={setEmailComposerValue}
            showAttachments={false}
            showQuickActions={false}
            showLayout={false}
            showFromField
            fromValue={fromDisplayValue}
            fromHelperText="Proof approval emails always send from the purchasing rep."
            fromName={proofEmailSender?.name || ""}
            fromEmail={proofEmailSender?.email || ""}
            showTemplatePreviewRow={false}
            preserveSubjectOnTemplateChange
            additionalOptions={[
              {
                key: "proof-follow-up",
                label: "Revisal auto-prefixes REVISED: (unless you customize the subject).",
                checked: proofEmailFollowUp,
                onChange: handleProofFollowUpToggle,
              },
              {
                key: "use-custom-template",
                label: emailTemplatesLoading ? "Use a custom template (loading...)" : "Use a custom template",
                checked: useCustomTemplate,
                onChange: (checked) => {
                  setUseCustomTemplate(checked);
                  if (!checked) {
                    setEmailComposerValue((prev) => ({ ...prev, templateId: "" }));
                  } else if (!emailTemplates.length && !emailTemplatesLoading) {
                    toast("No enabled templates are available for this instance.");
                  }
                },
              },
            ]}
          />



        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setEmailDlgOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            disabled={!canSend}
            onClick={async () => {
              if (!poId) { toast.error("Missing PO id."); return; }
              setEmailSending(true);
              try {
                if (!proofEmailSender?.email) {
                  toast.error("Choose a purchasing rep sender before sending.");
                  return;
                }

                const senderId = proofEmailSender.userId || null;

                await approveProofList(poId, {
                  triggerApprovalEmails: true,
                  recipients: toValid,
                  cc: ccValid,
                  bcc: bccValid,
                  fromUserId: senderId,
                  from: {
                    name: proofEmailSender.name,
                    email: proofEmailSender.email,
                  },
                  emailType: proofEmailFollowUp ? "revisal" : "new",
                  subject: String(emailComposerValue?.subject || ""),
                  message: String(emailComposerValue?.body || ""),
                  messageFormat: "html",
                  templateId: emailComposerValue?.templateId || "",
                  layout: emailComposerValue?.layout || "elite",
                });
                reflectPendingApproval();

                toast.success("Approval email sent.");
                setEmailDlgOpen(false);
              } catch (e) {
                console.error(e);
                toast.error(e?.response?.data?.message || "Failed to send emails");
              } finally {
                setEmailSending(false);
              }
            }}
          >
            {emailSending ? "Sending…" : "Send"}
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
  

}

// Reusable fixed add-button + menu
function AddRecipientsButton({ anchorRight = 8, anchorTop = '40%', pool = [], exclude = [], onAdd }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const excludeSet = React.useState(() => new Set((exclude||[]).map(s=>String(s).toLowerCase())))[0];
  const available = React.useMemo(
    () => (pool || []).filter(e => !excludeSet.has(String(e).toLowerCase())),
    [pool, excludeSet]
  );

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          right: anchorRight,
          top: anchorTop,
          transform: 'translateY(-50%)',
          width: 30,
          height: 30,
          borderRadius: '16px',
          boxShadow: 2,
          bgcolor: 'lightgreen',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          zIndex: 2
        }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        title="Add recipients"
        aria-label="Add recipients"
      >
        <AddIcon sx={{ fontSize: 36 }} />
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        slotProps={{ paper: { sx: { maxHeight: 360, minWidth: 280 } } }}
      >
        <MenuItem
          disabled={!available.length}
          onClick={() => { onAdd?.(available); setAnchorEl(null); }}
        >
          Add all ({available.length})
        </MenuItem>
        <Box sx={{ px: 1, pb: 1 }}>
          <TextField
            size="small"
            fullWidth
            placeholder="Search… (filters live)"
            onChange={(e) => {
              const q = e.target.value.toLowerCase();
              const container = e.target.closest('[role="presentation"]');
              // quick client-side filter on list items
              container?.querySelectorAll('[data-email]').forEach(li => {
                const match = li.dataset.email.includes(q);
                li.style.display = match ? '' : 'none';
              });
            }}
          />
        </Box>
        {available.map(e => (
          <MenuItem
            key={e}
            data-email={String(e).toLowerCase()}
            onClick={() => { onAdd?.([e]); setAnchorEl(null); }}
          >
            <MailOutlineIcon fontSize="small" sx={{ mr: 1 }} />
            {e}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}



function SmartEmailAutocomplete({
  label,
  value,
  onChange,
  placeholder,
  // smart sources
  sources = {
    clientReps: [],   // emails[]
    orderReps: [],    // emails[]
    assignedTo: [],   // emails[]
    customer: [],     // emails[]
  },
  // optional async people search (return array of {name, email, avatarUrl})
  searchPeople,       // async (query) => [{name,email,avatarUrl?}]
}) {
  const [inputValue, setInputValue] = React.useState("");
  const [searching, setSearching] = React.useState(false);
  const [people, setPeople] = React.useState([]); // [{name,email,avatarUrl}]
  const [open, setOpen] = React.useState(false);
  const abortRef = React.useRef(null);

  const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
  const splitEmails = (s = "") =>
    String(s).split(/[,\s;]+/).map(t => t.trim()).filter(Boolean);
  const normalizeEmails = (arr = []) =>
    Array.from(new Set(
      arr.flatMap(v => typeof v === "string" ? splitEmails(v) : [])
         .map(s => s.trim())
         .filter(Boolean)
    ));
  const isValid = (e) => EMAIL_RX.test(e);

  const commitEmails = React.useCallback((raw) => {
    if (!raw) return;
    const next = normalizeEmails([...value, ...splitEmails(raw)]);
    onChange(next);
    setInputValue("");
  }, [value, onChange]);

  // async directory search with tiny debounce
  React.useEffect(() => {
    if (!searchPeople) return;
    const q = inputValue.trim();
    if (q.length < 2) { setPeople([]); return; }

    const t = setTimeout(async () => {
      try {
        abortRef.current?.abort?.();
        const ac = new AbortController();
        abortRef.current = ac;
        setSearching(true);
        const rows = await searchPeople(q, { signal: ac.signal });
        setPeople(Array.isArray(rows) ? rows : []);
      } catch { /* ignore */ }
      finally { setSearching(false); }
    }, 180);
    return () => clearTimeout(t);
  }, [inputValue, searchPeople]);

  const {
    clientReps = [],
    orderReps = [],
    assignedTo: assignedToList = [],
    customer = [],
  } = sources || {};
  
  // map sources into options (use the safe vars above)
  const groupOptions = React.useMemo(() => ([
    { key: "grp-client",   type: "group", label: `Add Client Reps (${clientReps.length})`,   emails: clientReps },
    { key: "grp-order",    type: "group", label: `Add Order Reps (${orderReps.length})`,     emails: orderReps },
    { key: "grp-assign",   type: "group", label: `Add AssignedTo (${assignedToList.length})`, emails: assignedToList },
    { key: "grp-customer", type: "group", label: `Add Customer (${customer.length})`,        emails: customer },
  ].filter(g => (g.emails?.length ?? 0) > 0)), [clientReps, orderReps, assignedToList, customer]);

  const peopleOptions = React.useMemo(() => (
    people
      .filter(p => p?.email)
      .map(p => ({ key: `p-${p.email}`, type: "person", ...p }))
  ), [people]);

  // filter options by input
  const allOptions = React.useMemo(() => {
    const q = inputValue.trim().toLowerCase();
    const match = (s) => s.toLowerCase().includes(q);

    const groups = groupOptions.filter(g => match(g.label));
    const persons = peopleOptions.filter(p => match(p.name || "") || match(p.email || ""));
    // If input itself looks like an email, surface a “use …” option
    const rawEmailOpt = EMAIL_RX.test(inputValue)
      ? [{ key: `raw-${inputValue}`, type: "raw", label: `Use "${inputValue}"`, email: inputValue }]
      : [];

    return [...groups, ...persons, ...rawEmailOpt];
  }, [inputValue, groupOptions, peopleOptions]);

  // commit on paste
  const onPaste = (e) => {
    const text = e.clipboardData?.getData("text");
    if (text && /[,;\s]/.test(text)) {
      e.preventDefault();
      commitEmails(text);
    }
  };

  const renderTags = (val, getTagProps) =>
    val.map((email, idx) => {
      const invalid = !isValid(email);
      const { key, ...tagProps } = getTagProps({ index: idx });
      return (
        <Chip
          key={key}
          label={email}
          {...tagProps}
                   // soften invalid styling: outlined + small dot instead of big red chip
                   variant={invalid ? "outlined" : "filled"}
                   icon={invalid ? <Box sx={{
                     width: 8, height: 8, borderRadius: '50%', bgcolor: 'warning.main'
                   }} /> : undefined}
        />
      );
    });

  return (
    <Autocomplete
      multiple
      freeSolo
      open={open && allOptions.length > 0}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      options={allOptions}
      filterOptions={(x) => x} // we pre-filtered
      getOptionLabel={(opt) => {
        if (typeof opt === "string") return opt;
        if (opt.type === "person") return `${opt.name} <${opt.email}>`;
        if (opt.type === "group")  return opt.label;
        if (opt.type === "raw")    return opt.email;
        return "";
      }}
      value={value}
      inputValue={inputValue}
      onInputChange={(_, v, reason) => {
        if (reason === "reset") return; // handled by selection
        setInputValue(v);
      }}
      onChange={(_, newVal, reason, details) => {
        // Selecting an option
        const opt = details?.option;
        if (opt?.type === "group") {
          onChange(normalizeEmails([...value, ...opt.emails]));
          setInputValue("");
          return;
        }
        if (opt?.type === "person") {
          onChange(normalizeEmails([...value, opt.email]));
          setInputValue("");
          return;
        }
        if (opt?.type === "raw") {
          onChange(normalizeEmails([...value, opt.email]));
          setInputValue("");
          return;
        }
        // Chips edited directly
        onChange(normalizeEmails(newVal));
      }}
      // commit on Enter/comma/semicolon/blur
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === "," || e.key === ";") {
          e.preventDefault();
          commitEmails(inputValue);
        }
      }}
      onBlur={() => commitEmails(inputValue)}
      renderTags={renderTags}
      renderOption={(props, opt) => {
        if (opt.type === "group") {
          return (
            <li {...props} key={opt.key} style={{ display: "flex", gap: 8 }}>
              <Chip size="small" icon={<GroupIcon />} label="Group" />
              <span>{opt.label}</span>
            </li>
          );
        }
        if (opt.type === "person") {
          return (
            <li {...props} key={opt.key} style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <Avatar sx={{ width: 24, height: 24 }} src={opt.avatarUrl}>
                {(opt.name || opt.email).slice(0,2).toUpperCase()}
              </Avatar>
              <div>
                <div style={{ fontWeight: 600 }}>{opt.name || opt.email}</div>
                <div style={{ fontSize: 12, opacity: 0.7 }}>{opt.email}</div>
              </div>
            </li>
          );
        }
        return <li {...props} key={opt.key || String(opt)}>{opt.label || String(opt)}</li>;
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          onPaste={onPaste}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {searching ? <CircularProgress size={18} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          helperText={
            value.some(v => !isValid(v))
              ? "Some addresses look invalid. They’ll still be included unless you remove them."
              : undefined
          }
        />
      )}
      sx={{ mb: 2 }}
    />
  );
}

// tiny icon used above
function GroupIcon(props){ return <PeopleAltIcon fontSize="small" {...props} /> }

function SimpleEmailList({ title = "Suggested recipients", emails = [], exclude = [], onAdd }) {
  const excludeSet = new Set((exclude || []).map(s => s.toLowerCase()));
  const available = (emails || []).filter(e => !excludeSet.has(String(e).toLowerCase()));
  if (available.length === 0) return null;

  return (
    <Box sx={{ mt: 1, mb: 2 }}>
      <Typography variant="caption" sx={{ display: 'block', mb: 0.5, color: 'text.secondary' }}>
        {title}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
        <Button
          size="small"
          variant="outlined"
          onClick={() => onAdd?.(available)}
          sx={{ height: 28 }}
        >
          Add all ({available.length})
        </Button>
        {available.map((e) => (
          <Chip
            key={e}
            size="small"
            label={e}
            variant="outlined"
            onClick={() => onAdd?.([e])}
            sx={{ cursor: 'pointer' }}
          />
        ))}
      </Box>
    </Box>
  );
}
